import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  ISO8601DateTime: { input: any; output: any; }
};

export type Airline = {
  __typename?: 'Airline';
  code: Scalars['String']['output'];
  domesticArrivalTerminal?: Maybe<Scalars['String']['output']>;
  domesticDepartureTerminal?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  intlArrivalTerminal?: Maybe<Scalars['String']['output']>;
  intlDepartureTerminal?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type BookBookingType = {
  contact?: InputMaybe<BookContact>;
  epicPassId?: InputMaybe<Scalars['String']['input']>;
  idNumber?: InputMaybe<Scalars['String']['input']>;
  itineraryId?: InputMaybe<Scalars['String']['input']>;
  legs: Array<Res>;
  madeBy?: InputMaybe<MadeBy>;
  payment: Payment;
};

export type BookContact = {
  altPhone?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type BookCreditCard = {
  address?: InputMaybe<Scalars['String']['input']>;
  cvv?: InputMaybe<Scalars['String']['input']>;
  encryptedCardNumber?: InputMaybe<Scalars['String']['input']>;
  encryptedExpiryMonth?: InputMaybe<Scalars['String']['input']>;
  encryptedExpiryYear?: InputMaybe<Scalars['String']['input']>;
  encryptedSecurityCode?: InputMaybe<Scalars['String']['input']>;
  expiration?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  localId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberLast4?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  processorId?: InputMaybe<Scalars['Int']['input']>;
  refId?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  tokenType?: InputMaybe<Scalars['String']['input']>;
  typeCode?: InputMaybe<Scalars['String']['input']>;
  uniqueId?: InputMaybe<Scalars['String']['input']>;
};

export type BookFlight = {
  airline?: InputMaybe<Scalars['String']['input']>;
  flightCity?: InputMaybe<Scalars['String']['input']>;
  flightNumber?: InputMaybe<Scalars['String']['input']>;
  flightTime?: InputMaybe<Scalars['String']['input']>;
  flightType?: InputMaybe<Scalars['String']['input']>;
  terminal?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of Book */
export type BookInput = {
  booking: BookBookingType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Scalars['Int']['input']>;
};

export type BookLegPaymentItemType = {
  paymentAmount?: InputMaybe<Scalars['Float']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  programId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type BookLegPaymentsType = {
  amountDue?: InputMaybe<Scalars['Float']['input']>;
  items?: InputMaybe<Array<BookLegPaymentItemType>>;
  totalPaymentAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type BookLoc = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressDetails?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  crossStreet?: InputMaybe<Scalars['String']['input']>;
  directions?: InputMaybe<Scalars['String']['input']>;
  displayAddress?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  latLng?: InputMaybe<InputLatLng>;
  name?: InputMaybe<Scalars['String']['input']>;
  sector?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type BookPassengerDetails = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of Book */
export type BookPayload = {
  __typename?: 'BookPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  itineraryId?: Maybe<Scalars['String']['output']>;
  resErrors?: Maybe<Array<Scalars['String']['output']>>;
  resIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type BookStop = {
  comments?: InputMaybe<Scalars['String']['input']>;
  location: BookLoc;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of CancelRes */
export type CancelResInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  resId: Scalars['Int']['input'];
};

/** Autogenerated return type of CancelRes */
export type CancelResPayload = {
  __typename?: 'CancelResPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Colors = {
  __typename?: 'Colors';
  id: Scalars['ID']['output'];
  primaryColor: Scalars['String']['output'];
  primaryHover: Scalars['String']['output'];
  primaryText: Scalars['String']['output'];
};

export type ColumnDefinition = {
  __typename?: 'ColumnDefinition';
  dataFormat?: Maybe<Scalars['String']['output']>;
  dataType?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type Config = {
  __typename?: 'Config';
  allowCouponRemoval: Scalars['Boolean']['output'];
  allowOpenResConversion: Scalars['Boolean']['output'];
  allowRouteLevelLocations: Scalars['Boolean']['output'];
  creditCardCardsNotAccepted?: Maybe<Array<Scalars['String']['output']>>;
  creditCardEnabled?: Maybe<Scalars['Boolean']['output']>;
  creditCardExternalUrl?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  customerRequestEnabled: Scalars['Boolean']['output'];
  dateFormat?: Maybe<Scalars['String']['output']>;
  defaultCcProcessorId?: Maybe<Scalars['Int']['output']>;
  defaultCharterGratuityPercent?: Maybe<Scalars['Float']['output']>;
  defaultGroupGratuityPercent?: Maybe<Scalars['Float']['output']>;
  defaultPaymentType?: Maybe<Scalars['Int']['output']>;
  defaultRoundTrip?: Maybe<Scalars['Boolean']['output']>;
  defaultSearchCenter?: Maybe<LatLng>;
  defaultServiceArea?: Maybe<Scalars['Int']['output']>;
  directBillEnabled?: Maybe<Scalars['Boolean']['output']>;
  disableDirectBill?: Maybe<Scalars['Boolean']['output']>;
  disableProfileCreditCards?: Maybe<Scalars['Boolean']['output']>;
  disableProfileLocations?: Maybe<Scalars['Boolean']['output']>;
  enableFrequentRiderPurchase?: Maybe<Scalars['Boolean']['output']>;
  enablePassengerDetails?: Maybe<Scalars['Boolean']['output']>;
  enableProfileLinkedGroups?: Maybe<Scalars['Boolean']['output']>;
  epicPassEnabled?: Maybe<Scalars['Boolean']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  googleAnalyticsId?: Maybe<Scalars['String']['output']>;
  googleApiKey?: Maybe<Scalars['String']['output']>;
  googleMapsDisabled?: Maybe<Scalars['Boolean']['output']>;
  gratuityPercentages: Array<GratuityPercentage>;
  groupLoginEnabled?: Maybe<Scalars['Boolean']['output']>;
  gtmId?: Maybe<Scalars['String']['output']>;
  hideCreateProfileSuggestion?: Maybe<Scalars['Boolean']['output']>;
  hideDropoffTime: Scalars['Boolean']['output'];
  hideFlightNumber?: Maybe<Scalars['Boolean']['output']>;
  hideFlightType?: Maybe<Scalars['Boolean']['output']>;
  hideGroupProfileActions?: Maybe<Scalars['Boolean']['output']>;
  hideLoginSuggestion?: Maybe<Scalars['Boolean']['output']>;
  hidePickupDateInCart: Scalars['Boolean']['output'];
  hideTerminal?: Maybe<Scalars['Boolean']['output']>;
  hideUserProfileActions?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  linkedGroupFields?: Maybe<Array<Scalars['String']['output']>>;
  locationBiasRadius?: Maybe<Scalars['Int']['output']>;
  locationBiasStrictBounds?: Maybe<Scalars['Boolean']['output']>;
  locationMode?: Maybe<LocationMode>;
  locationTypeOptions?: Maybe<Array<LocationTypeOption>>;
  lockGroupProfile?: Maybe<Scalars['Boolean']['output']>;
  marketingCodes?: Maybe<Array<FieldValue>>;
  marketingCodes2?: Maybe<Array<FieldValue>>;
  marketingCodes3?: Maybe<Array<FieldValue>>;
  openReservationMode?: Maybe<OpenResMode>;
  passengerDetailsRequired?: Maybe<Scalars['Boolean']['output']>;
  pudsAsPeople?: Maybe<Scalars['Boolean']['output']>;
  requireCardOnFileCvv?: Maybe<Scalars['Boolean']['output']>;
  requireLoginForBooking?: Maybe<Scalars['Boolean']['output']>;
  resVerifyValidationModes: Array<FieldValue>;
  shopperReference?: Maybe<Scalars['String']['output']>;
  showCcaddress: Scalars['Boolean']['output'];
  showCcvv: Scalars['Boolean']['output'];
  showCczip: Scalars['Boolean']['output'];
  showCheckoutPointsSection: Scalars['Boolean']['output'];
  showCreditCardOnDirectBill: Scalars['Boolean']['output'];
  showExtraStopsComments: Scalars['Boolean']['output'];
  showExtraStopsName: Scalars['Boolean']['output'];
  showGratuity: Scalars['Boolean']['output'];
  showMarketingCode: Scalars['Boolean']['output'];
  showMarketingCode2: Scalars['Boolean']['output'];
  showMarketingCode3: Scalars['Boolean']['output'];
  showMarketingCode3InCc: Scalars['Boolean']['output'];
  showProfileFrequentRiderPoints: Scalars['Boolean']['output'];
  singleServiceAutoSelect?: Maybe<Scalars['Boolean']['output']>;
  specialInfoPassengerAlias?: Maybe<Scalars['String']['output']>;
  timeFormat: TimeFormat;
  topLocationsMode: TopLocationsMode;
  universalAnalyticsId?: Maybe<Scalars['String']['output']>;
  universalLocationsMode: Scalars['Boolean']['output'];
  useJsonCart: Scalars['Boolean']['output'];
};

export type Contact = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  newPassword?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  telephone2?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type Content = {
  __typename?: 'Content';
  beAddressDetailsLabel: Scalars['String']['output'];
  beAirlineLabel: Scalars['String']['output'];
  beAltphoneLabel: Scalars['String']['output'];
  beApplyCouponButton: Scalars['String']['output'];
  beApplyCouponLabel: Scalars['String']['output'];
  beAutocompleteMoreOptionsButton: Scalars['String']['output'];
  beBagsDescription: Scalars['String']['output'];
  beBagsHeader: Scalars['String']['output'];
  beBagsLabel: Scalars['String']['output'];
  beBagsUrl: Scalars['String']['output'];
  beBagsUrlLabel: Scalars['String']['output'];
  beBookAnotherButton: Scalars['String']['output'];
  beBookButton: Scalars['String']['output'];
  beBookHeaderButton: Scalars['String']['output'];
  beBookLoadingMsg: Scalars['String']['output'];
  beBookReturnTripDescription: Scalars['String']['output'];
  beBookReturnTripLabel: Scalars['String']['output'];
  beBookingInfoSectionHeader: Scalars['String']['output'];
  beCancelButton: Scalars['String']['output'];
  beCancelConfirmationCancelButton: Scalars['String']['output'];
  beCancelConfirmationMsg: Scalars['String']['output'];
  beCancelResSuccess: Scalars['String']['output'];
  beCanceledMsg: Scalars['String']['output'];
  beCcAddressLabel: Scalars['String']['output'];
  beCcCvvLabel: Scalars['String']['output'];
  beCcExpLabel: Scalars['String']['output'];
  beCcNameLabel: Scalars['String']['output'];
  beCcNumberLabel: Scalars['String']['output'];
  beCcPostalcodeLabel: Scalars['String']['output'];
  beChangepwNewPasswordLabel: Scalars['String']['output'];
  beChangepwPasswordLabel: Scalars['String']['output'];
  beChangepwSubmitButton: Scalars['String']['output'];
  beChangepwSuccessMsg: Scalars['String']['output'];
  beCheckoutTitle: Scalars['String']['output'];
  beConfirmDialogDefaultCancelButton: Scalars['String']['output'];
  beConfirmDialogDefaultTitle: Scalars['String']['output'];
  beConfirmationHead: Scalars['String']['output'];
  beConfirmationTitle: Scalars['String']['output'];
  beContactGuestCheckout: Scalars['String']['output'];
  beContactPassengersHeader: Scalars['String']['output'];
  beContactPassengersNameLabel: Scalars['String']['output'];
  beContactPassengersText: Scalars['String']['output'];
  beContactSectionTitle: Scalars['String']['output'];
  beContinueButton: Scalars['String']['output'];
  beContinueToCcPageButton: Scalars['String']['output'];
  beConvertOpenButton: Scalars['String']['output'];
  beConvertOpenCancelButton: Scalars['String']['output'];
  beConvertOpenCancelConfirmation: Scalars['String']['output'];
  beConvertOpenMessage: Scalars['String']['output'];
  beConvertOpenSuccessMessage: Scalars['String']['output'];
  beCouponAppliedMsg: Scalars['String']['output'];
  beCreateNewAccountButton: Scalars['String']['output'];
  beCreateNewAccountTitle: Scalars['String']['output'];
  beCrossStreetLabel: Scalars['String']['output'];
  beCustRequestFlightTime: Scalars['String']['output'];
  beCustRequestPickupTime: Scalars['String']['output'];
  beDropoffDirectionsLabel: Scalars['String']['output'];
  beDropoffLocLabel: Scalars['String']['output'];
  beEditBackButton: Scalars['String']['output'];
  beEditLegButton: Scalars['String']['output'];
  beEditOpenResButton: Scalars['String']['output'];
  beEditResButton: Scalars['String']['output'];
  beEditResidPrefix: Scalars['String']['output'];
  beEditStopDialogConfirmButton: Scalars['String']['output'];
  beEditStopDialogConfirmMessage: Scalars['String']['output'];
  beEmailLabel: Scalars['String']['output'];
  beEmailProfileCheckLoginButton: Scalars['String']['output'];
  beEmailProfileCheckMsg: Scalars['String']['output'];
  beEpicPassAppliedMsg: Scalars['String']['output'];
  beEpicPassIdLabel: Scalars['String']['output'];
  beEpicPassSubmitBtn: Scalars['String']['output'];
  beErrAirline: Scalars['String']['output'];
  beErrAltphone: Scalars['String']['output'];
  beErrAltphoneFormat: Scalars['String']['output'];
  beErrBadCoupon: Scalars['String']['output'];
  beErrBagCountMax: Scalars['String']['output'];
  beErrCantVerify: Scalars['String']['output'];
  beErrCcAddress: Scalars['String']['output'];
  beErrCcCvv: Scalars['String']['output'];
  beErrCcExp: Scalars['String']['output'];
  beErrCcName: Scalars['String']['output'];
  beErrCcNumber: Scalars['String']['output'];
  beErrCcNumberInvalid: Scalars['String']['output'];
  beErrCcNumberType: Scalars['String']['output'];
  beErrCcPostalcode: Scalars['String']['output'];
  beErrEmail: Scalars['String']['output'];
  beErrEmailFormat: Scalars['String']['output'];
  beErrEpicLogin: Scalars['String']['output'];
  beErrFaxNumberFormat: Scalars['String']['output'];
  beErrFieldRequired: Scalars['String']['output'];
  beErrFlightCityArrivals: Scalars['String']['output'];
  beErrFlightCityDepartures: Scalars['String']['output'];
  beErrFlightNumArrivals: Scalars['String']['output'];
  beErrFlightNumDepartures: Scalars['String']['output'];
  beErrGroupLogin: Scalars['String']['output'];
  beErrGroupPasswordLogin: Scalars['String']['output'];
  beErrLinkedGroups: Scalars['String']['output'];
  beErrLocTooGeneral: Scalars['String']['output'];
  beErrLookupEmailFormat: Scalars['String']['output'];
  beErrMarketingCode: Scalars['String']['output'];
  beErrMarketingCode2: Scalars['String']['output'];
  beErrMarketingCode3: Scalars['String']['output'];
  beErrMaxPassengers: Scalars['String']['output'];
  beErrName: Scalars['String']['output'];
  beErrNoFareKey: Scalars['String']['output'];
  beErrNoLocsFound: Scalars['String']['output'];
  beErrNoLocsFoundFixed: Scalars['String']['output'];
  beErrNoService: Scalars['String']['output'];
  beErrNoServiceTitle: Scalars['String']['output'];
  beErrPassengers: Scalars['String']['output'];
  beErrPasswordMinLength: Scalars['String']['output'];
  beErrPasswordUpdate: Scalars['String']['output'];
  beErrPhone: Scalars['String']['output'];
  beErrPhoneFormat: Scalars['String']['output'];
  beErrProfileCcAdd: Scalars['String']['output'];
  beErrProfileCcRemove: Scalars['String']['output'];
  beErrProfileLocationsAdd: Scalars['String']['output'];
  beErrProfileLocationsDelete: Scalars['String']['output'];
  beErrProfileLocationsUpdate: Scalars['String']['output'];
  beErrProfileUpdate: Scalars['String']['output'];
  beErrPudPersonCcRemove: Scalars['String']['output'];
  beErrResNotCanceled: Scalars['String']['output'];
  beErrResNotConverted: Scalars['String']['output'];
  beErrResetpwGeneral: Scalars['String']['output'];
  beErrSessionExpired: Scalars['String']['output'];
  beErrSpecialInfoMin: Scalars['String']['output'];
  beErrSpecialInstr: Scalars['String']['output'];
  beErrSpecialInstr2: Scalars['String']['output'];
  beErrStopsComments: Scalars['String']['output'];
  beErrStopsName: Scalars['String']['output'];
  beErrStopsReprice: Scalars['String']['output'];
  beErrSystemError: Scalars['String']['output'];
  beErrTerms: Scalars['String']['output'];
  beErrUserLogin: Scalars['String']['output'];
  beErrUsernameBad: Scalars['String']['output'];
  beExternalCcMessage: Scalars['String']['output'];
  beExtraStopLabel: Scalars['String']['output'];
  beFaxNumberLabel: Scalars['String']['output'];
  beFirstLegHeader: Scalars['String']['output'];
  beFlightCityArrivalsLabel: Scalars['String']['output'];
  beFlightCityDeparturesLabel: Scalars['String']['output'];
  beFlightDateArrLabel: Scalars['String']['output'];
  beFlightDateDepLabel: Scalars['String']['output'];
  beFlightDateLabel: Scalars['String']['output'];
  beFlightNumberLabel: Scalars['String']['output'];
  beFlightSectionExtrasSubtitle: Scalars['String']['output'];
  beFlightSectionFlightSubtitle: Scalars['String']['output'];
  beFlightSectionTitle: Scalars['String']['output'];
  beFlightTimeArrLabel: Scalars['String']['output'];
  beFlightTimeDepLabel: Scalars['String']['output'];
  beFlightTimeLabel: Scalars['String']['output'];
  beFlightTypeInternationalLabel: Scalars['String']['output'];
  beForgotPwButton: Scalars['String']['output'];
  beFrpBookAnotherButton: Scalars['String']['output'];
  beFrpBookButton: Scalars['String']['output'];
  beFrpBookLoadingMsg: Scalars['String']['output'];
  beFrpButton: Scalars['String']['output'];
  beFrpConfirmationHead: Scalars['String']['output'];
  beFrpConfirmationTitle: Scalars['String']['output'];
  beFrpFreeRides: Scalars['String']['output'];
  beFrpGoodThru: Scalars['String']['output'];
  beFrpNoPrograms: Scalars['String']['output'];
  beFrpQuantityLabel: Scalars['String']['output'];
  beFrpStartDateLabel: Scalars['String']['output'];
  beFrpSubmitBtn: Scalars['String']['output'];
  beGratuityIncludedMsg: Scalars['String']['output'];
  beGratuityRtGratuityIsLabel: Scalars['String']['output'];
  beGratuitySectionGrpSvcContent: Scalars['String']['output'];
  beGratuitySectionTitle: Scalars['String']['output'];
  beGratuityZeroDefaultLabel: Scalars['String']['output'];
  beGroupLoginCodeLabel: Scalars['String']['output'];
  beGroupLoginPrompt: Scalars['String']['output'];
  beGroupLoginSubmitBtn: Scalars['String']['output'];
  beGroupLoginSubmitButton: Scalars['String']['output'];
  beGroupLogoutLabel: Scalars['String']['output'];
  beGroupPasswordLabel: Scalars['String']['output'];
  beGroupPwBackButton: Scalars['String']['output'];
  beHeaderProfileButton: Scalars['String']['output'];
  beLocAmenIconH: Scalars['String']['output'];
  beLocAmenIconNP: Scalars['String']['output'];
  beLocAmenIconP: Scalars['String']['output'];
  beLocAmenIconR: Scalars['String']['output'];
  beLocAmenIconV: Scalars['String']['output'];
  beLocationDialogCommonCatsHeader: Scalars['String']['output'];
  beLocationDialogTopLocHeader: Scalars['String']['output'];
  beLocationSectionTitle: Scalars['String']['output'];
  beLocationStringLabel: Scalars['String']['output'];
  beLocationtypeNamePuds: Scalars['String']['output'];
  beLoginSubmitButton: Scalars['String']['output'];
  beLoginTitle: Scalars['String']['output'];
  beLogoutButton: Scalars['String']['output'];
  beLogoutConfirmationButton: Scalars['String']['output'];
  beLogoutConfirmationMsg: Scalars['String']['output'];
  beLogoutConfirmationTitle: Scalars['String']['output'];
  beMadeByLabel: Scalars['String']['output'];
  beMakeOneWayResButton: Scalars['String']['output'];
  beManageTripsButton: Scalars['String']['output'];
  beMapPopupLinkLabel: Scalars['String']['output'];
  beMarketingCode2Label: Scalars['String']['output'];
  beMarketingCode3Label: Scalars['String']['output'];
  beMarketingCodeLabel: Scalars['String']['output'];
  beNameLabel: Scalars['String']['output'];
  beNearbyLocsAway: Scalars['String']['output'];
  beNearbyLocsFeet: Scalars['String']['output'];
  beNearbyLocsHeaderMsgLocAvailable: Scalars['String']['output'];
  beNearbyLocsHeaderMsgLocNotAvailable: Scalars['String']['output'];
  beNearbyLocsHeaderPrefix: Scalars['String']['output'];
  beNearbyLocsMiles: Scalars['String']['output'];
  beNearbyLocsSectHeaderNearbyLocs: Scalars['String']['output'];
  beNearbyLocsSectHeaderReqLoc: Scalars['String']['output'];
  beNearbyLocsSectSubheadNearbyLocs: Scalars['String']['output'];
  beNearbyLocsSectSubheadReqLoc: Scalars['String']['output'];
  beNewProfileBackButton: Scalars['String']['output'];
  beNewProfileSubmitButton: Scalars['String']['output'];
  beNewProfileTitle: Scalars['String']['output'];
  beNewTotalLabel: Scalars['String']['output'];
  bePaginationOf: Scalars['String']['output'];
  bePassengersHeader: Scalars['String']['output'];
  bePasswordAriaHide: Scalars['String']['output'];
  bePasswordAriaShow: Scalars['String']['output'];
  bePasswordLabel: Scalars['String']['output'];
  bePaymentCcDialogSaveButton: Scalars['String']['output'];
  bePaymentCcDialogTitle: Scalars['String']['output'];
  bePaymentCcDifferentCardLabel: Scalars['String']['output'];
  bePaymentCcSectionTitle: Scalars['String']['output'];
  bePaymentCcTokenizedEndingIn: Scalars['String']['output'];
  bePaymentCcTokenizedExpires: Scalars['String']['output'];
  bePaymentDbSectionTitle: Scalars['String']['output'];
  bePaymentDirectbillPayment: Scalars['String']['output'];
  bePaymentPaidWithPoints: Scalars['String']['output'];
  bePaymentRemoveButton: Scalars['String']['output'];
  bePaymentSectionTitle: Scalars['String']['output'];
  bePaymentnotesCc: Scalars['String']['output'];
  bePaymentnotesCc2?: Maybe<Scalars['String']['output']>;
  bePaymentnotesDb?: Maybe<Scalars['String']['output']>;
  bePaymentnotesFr: Scalars['String']['output'];
  bePhoneLabel: Scalars['String']['output'];
  bePickupDateLabel: Scalars['String']['output'];
  bePickupDirectionsLabel: Scalars['String']['output'];
  bePickupLocLabel: Scalars['String']['output'];
  bePickupTimeArrive: Scalars['String']['output'];
  bePickupTimeAvailableSeats: Scalars['String']['output'];
  bePickupTimeFlightHours: Scalars['String']['output'];
  bePickupTimeFlightMinutes: Scalars['String']['output'];
  bePickupTimeFlightPreArr: Scalars['String']['output'];
  bePickupTimeFlightPreDep: Scalars['String']['output'];
  bePickupTimeFlightSufArr: Scalars['String']['output'];
  bePickupTimeFlightSufDep: Scalars['String']['output'];
  bePickupTimeLabel: Scalars['String']['output'];
  bePickupTimeOffPeak: Scalars['String']['output'];
  bePickupTimeShortNotice: Scalars['String']['output'];
  bePickupTimeShowAdtlTimes: Scalars['String']['output'];
  bePickupTimeShowButton: Scalars['String']['output'];
  bePickuptimeSectionTitle: Scalars['String']['output'];
  bePointsDontUsePtsLabel: Scalars['String']['output'];
  bePointsNewTotalLabel: Scalars['String']['output'];
  bePointsNumPointsLabel: Scalars['String']['output'];
  bePointsPointsAvailSfx: Scalars['String']['output'];
  bePointsSectionTitle: Scalars['String']['output'];
  beProfileAccountButton: Scalars['String']['output'];
  beProfileAltphoneLabel: Scalars['String']['output'];
  beProfileCcAddSubmitButton: Scalars['String']['output'];
  beProfileCcAddSuccessMsg: Scalars['String']['output'];
  beProfileCcAddTitle: Scalars['String']['output'];
  beProfileCcRemoveDialogMessage: Scalars['String']['output'];
  beProfileCcRemoveDialogSubmitButton: Scalars['String']['output'];
  beProfileCcRemoveDialogTitle: Scalars['String']['output'];
  beProfileCcRemoveSuccessMsg: Scalars['String']['output'];
  beProfileCcSavedCardsTitle: Scalars['String']['output'];
  beProfileContactSectionTitle: Scalars['String']['output'];
  beProfileContactTab: Scalars['String']['output'];
  beProfileEmailLabel: Scalars['String']['output'];
  beProfileHomeTitle: Scalars['String']['output'];
  beProfileLgLabelClientid: Scalars['String']['output'];
  beProfileLgLabelData1: Scalars['String']['output'];
  beProfileLgLabelData2: Scalars['String']['output'];
  beProfileLgLabelGroupid: Scalars['String']['output'];
  beProfileLgLabelWebid: Scalars['String']['output'];
  beProfileLinkedGroupsCancelButton: Scalars['String']['output'];
  beProfileLinkedGroupsChangeButton: Scalars['String']['output'];
  beProfileLinkedGroupsSubmitButton: Scalars['String']['output'];
  beProfileLinkedGroupsSuccessMsg: Scalars['String']['output'];
  beProfileLinkedGroupsTab: Scalars['String']['output'];
  beProfileLinkedGroupsTitle: Scalars['String']['output'];
  beProfileLinkedGroupsValidatedLabel: Scalars['String']['output'];
  beProfileLocationsAddButton: Scalars['String']['output'];
  beProfileLocationsAddSuccess: Scalars['String']['output'];
  beProfileLocationsDeleteSuccess: Scalars['String']['output'];
  beProfileLocationsEditButton: Scalars['String']['output'];
  beProfileLocationsFieldLabel: Scalars['String']['output'];
  beProfileLocationsNewLocSubmitButton: Scalars['String']['output'];
  beProfileLocationsNewLocTitle: Scalars['String']['output'];
  beProfileLocationsNewUpdateLocCancelButton: Scalars['String']['output'];
  beProfileLocationsRemoveButton: Scalars['String']['output'];
  beProfileLocationsRemoveDialogCancelButton: Scalars['String']['output'];
  beProfileLocationsRemoveDialogConfirmButton: Scalars['String']['output'];
  beProfileLocationsRemoveDialogConfirmMessage: Scalars['String']['output'];
  beProfileLocationsRemoveDialogTitle: Scalars['String']['output'];
  beProfileLocationsTab: Scalars['String']['output'];
  beProfileLocationsTitle: Scalars['String']['output'];
  beProfileLocationsUpdateLocSubmitButton: Scalars['String']['output'];
  beProfileLocationsUpdateLocTitle: Scalars['String']['output'];
  beProfileLocationsUpdateSuccess: Scalars['String']['output'];
  beProfileNameLabel: Scalars['String']['output'];
  beProfilePasswordLabel: Scalars['String']['output'];
  beProfilePasswordTab: Scalars['String']['output'];
  beProfilePasswordTitle: Scalars['String']['output'];
  beProfilePaymentTab: Scalars['String']['output'];
  beProfilePhoneLabel: Scalars['String']['output'];
  beProfilePointsTab: Scalars['String']['output'];
  beProfilePointsTableResidPrefix: Scalars['String']['output'];
  beProfilePointsTitle: Scalars['String']['output'];
  beProfilePointsTransactionsTitle: Scalars['String']['output'];
  beProfileResNoResMessage: Scalars['String']['output'];
  beProfileResNoResMessageTitle: Scalars['String']['output'];
  beProfileResOpenTab: Scalars['String']['output'];
  beProfileResPastTab: Scalars['String']['output'];
  beProfileResUpcomingTab: Scalars['String']['output'];
  beProfileResViewDetailsButton: Scalars['String']['output'];
  beProfileResViewDetailsOpenButton: Scalars['String']['output'];
  beProfileReservationsTab: Scalars['String']['output'];
  beProfileUpdateSubmitButton: Scalars['String']['output'];
  beProfileUpdateSuccessMsg: Scalars['String']['output'];
  bePudPersonAltphoneLabel: Scalars['String']['output'];
  bePudPersonCcRemoveDialogMessage: Scalars['String']['output'];
  bePudPersonCcRemoveDialogSubmitButton: Scalars['String']['output'];
  bePudPersonCcRemoveDialogTitle: Scalars['String']['output'];
  bePudPersonCcRemoveSuccessMsg: Scalars['String']['output'];
  bePudPersonCcSectionTitle: Scalars['String']['output'];
  bePudPersonContactSectionTitle: Scalars['String']['output'];
  bePudPersonEmailLabel: Scalars['String']['output'];
  bePudPersonFaxLabel: Scalars['String']['output'];
  bePudPersonLabel: Scalars['String']['output'];
  bePudPersonNameLabel: Scalars['String']['output'];
  bePudPersonPhoneLabel: Scalars['String']['output'];
  beReferralsHead: Scalars['String']['output'];
  beRemoveCouponLabel: Scalars['String']['output'];
  beRemoveLegButton: Scalars['String']['output'];
  beRequiredPlaceholder: Scalars['String']['output'];
  beResetpwContent: Scalars['String']['output'];
  beResetpwNewPasswordLabel: Scalars['String']['output'];
  beResetpwSubmitButton: Scalars['String']['output'];
  beResetpwSuccessMsg: Scalars['String']['output'];
  beResetpwTitle: Scalars['String']['output'];
  beReslookupHead: Scalars['String']['output'];
  beReslookupResnumLabel: Scalars['String']['output'];
  beReslookupValidationTypeLabel: Scalars['String']['output'];
  beReslookupValidationValueLabel: Scalars['String']['output'];
  beRessummaryAmountPaidLabel: Scalars['String']['output'];
  beRessummaryBackButton: Scalars['String']['output'];
  beRessummaryCancelledLabel: Scalars['String']['output'];
  beRessummaryDirectbillPayment: Scalars['String']['output'];
  beRessummaryFlightSectionTitle: Scalars['String']['output'];
  beRessummaryHead: Scalars['String']['output'];
  beRessummaryPickupAtLabel: Scalars['String']['output'];
  beRessummaryPointsUsedLabel: Scalars['String']['output'];
  beRessummaryTotalLabel: Scalars['String']['output'];
  beReturnTripHeader: Scalars['String']['output'];
  beSelectNoOptions: Scalars['String']['output'];
  beSendResetpwBackButton: Scalars['String']['output'];
  beSendResetpwContent: Scalars['String']['output'];
  beSendResetpwSubmitButton: Scalars['String']['output'];
  beSendResetpwSuccessMsg: Scalars['String']['output'];
  beSendResetpwTitle: Scalars['String']['output'];
  beServiceExtraEachLabel: Scalars['String']['output'];
  beServiceExtrasHeader: Scalars['String']['output'];
  beServicePsgrsMaximum: Scalars['String']['output'];
  beServiceSelectButton: Scalars['String']['output'];
  beServiceStartingAt: Scalars['String']['output'];
  beSidebarHeader: Scalars['String']['output'];
  beSidebarPointsUsedLabel: Scalars['String']['output'];
  beSidebarResidLabel: Scalars['String']['output'];
  beSidebarTotalLabel: Scalars['String']['output'];
  beSpecialInstr2Label: Scalars['String']['output'];
  beSpecialInstrLabel: Scalars['String']['output'];
  beSrvextraSelectBlank: Scalars['String']['output'];
  beStopsAddButton: Scalars['String']['output'];
  beStopsCommentsLabel: Scalars['String']['output'];
  beStopsHeader: Scalars['String']['output'];
  beStopsNameLabel: Scalars['String']['output'];
  beStopsNotAllowed: Scalars['String']['output'];
  beStopsRemoveButton: Scalars['String']['output'];
  beStopsSectionTitle: Scalars['String']['output'];
  beStopsStopPrefix: Scalars['String']['output'];
  beSuggestcreateConfirm: Scalars['String']['output'];
  beSuggestcreateContent: Scalars['String']['output'];
  beSuggestcreateSaveButton: Scalars['String']['output'];
  beSuggestcreateTitle: Scalars['String']['output'];
  beSuggestloginContent: Scalars['String']['output'];
  beSuggestloginLoginButton: Scalars['String']['output'];
  beSuggestloginTitle: Scalars['String']['output'];
  beTermsConditionsLabel: Scalars['String']['output'];
  beTermsConditionsUrl: Scalars['String']['output'];
  beTermsConditionsUrlLabel: Scalars['String']['output'];
  beUsernameLabel: Scalars['String']['output'];
  beVarianceNegativeLabel: Scalars['String']['output'];
  beVariancePositiveLabel: Scalars['String']['output'];
  beVarianceZero: Scalars['String']['output'];
  beWebSubfareACaption: Scalars['String']['output'];
  beWebSubfareBCaption: Scalars['String']['output'];
  beWebSubfareCCaption: Scalars['String']['output'];
  beWebSubfareDCaption: Scalars['String']['output'];
  beWebSubfareECaption: Scalars['String']['output'];
  beWebSubfareSummary: Scalars['String']['output'];
  beWebSubfaresContent: Scalars['String']['output'];
  beWebSubfaresHeader: Scalars['String']['output'];
  charterName?: Maybe<Scalars['String']['output']>;
  daErrFieldRequired: Scalars['String']['output'];
  daErrSystemError: Scalars['String']['output'];
  daErrorDialogOkBtn: Scalars['String']['output'];
  daLoginSubmitButton: Scalars['String']['output'];
  daLoginTitle: Scalars['String']['output'];
  daPasswordLabel: Scalars['String']['output'];
  daRequiredPlaceholder: Scalars['String']['output'];
  daUsernameLabel: Scalars['String']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  landingMessage?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  logo2?: Maybe<Scalars['String']['output']>;
  serviceAreaName?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ConvertRes */
export type ConvertResInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  resId: Scalars['Int']['input'];
};

/** Autogenerated return type of ConvertRes */
export type ConvertResPayload = {
  __typename?: 'ConvertResPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Defaults = {
  __typename?: 'Defaults';
  creditCards?: Maybe<Array<TokenizedCreditCard>>;
  email?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  gratuityPercents?: Maybe<Array<Scalars['Float']['output']>>;
  id: Scalars['ID']['output'];
  marketingCode?: Maybe<Scalars['String']['output']>;
  marketingCode2?: Maybe<Scalars['String']['output']>;
  marketingCode3?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
  telephone2?: Maybe<Scalars['String']['output']>;
};

export type Desktop = {
  __typename?: 'Desktop';
  fileName?: Maybe<Scalars['String']['output']>;
  hotkeyAlias?: Maybe<Scalars['String']['output']>;
  iconName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  remoteKey?: Maybe<Scalars['String']['output']>;
  showRefresh?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type DesktopsReply = {
  __typename?: 'DesktopsReply';
  desktops?: Maybe<Array<Desktop>>;
  error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type Driver = {
  __typename?: 'Driver';
  displayName?: Maybe<Scalars['String']['output']>;
  employeeId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type EpicPassReturn = {
  __typename?: 'EpicPassReturn';
  valid: Scalars['Boolean']['output'];
};

export enum FareDisplayMode {
  /** Default */
  Default = 'default',
  /** Gross Only */
  GrossOnly = 'gross_only'
}

export type FareKeyLookupReturn = {
  __typename?: 'FareKeyLookupReturn';
  error?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  fklRequest?: Maybe<Scalars['String']['output']>;
  fklResponse?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  lookupType?: Maybe<Scalars['Int']['output']>;
  nearbyLocations?: Maybe<Array<Location>>;
};

export type Field = {
  __typename?: 'Field';
  defaultValue?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fieldName: Scalars['String']['output'];
  fieldType: FieldType;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  maxLength: Scalars['Int']['output'];
  minLength: Scalars['Int']['output'];
  raw: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
};

export enum FieldType {
  /** Boolean */
  Boolean = 'boolean',
  /** Date */
  Date = 'date',
  /** Ignore */
  Ignore = 'ignore',
  /** Numeric */
  Numeric = 'numeric',
  /** Value list combo box (fixed) */
  Select = 'select',
  /** Text */
  Text = 'text',
  /** Title text */
  Title = 'title'
}

export type FieldValue = {
  __typename?: 'FieldValue';
  field: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type FixedLocationType = {
  __typename?: 'FixedLocationType';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  locationCount: Scalars['Int']['output'];
  locations?: Maybe<Array<Location>>;
  type: Scalars['String']['output'];
  typeString?: Maybe<Scalars['String']['output']>;
};

export type Flight = {
  airline?: InputMaybe<Scalars['String']['input']>;
  flightNumber?: InputMaybe<Scalars['String']['input']>;
  flightTime?: InputMaybe<Scalars['String']['input']>;
  flightType?: InputMaybe<Scalars['String']['input']>;
};

export type FrequentRiderPoints = {
  __typename?: 'FrequentRiderPoints';
  availablePoints?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  programId?: Maybe<Scalars['Int']['output']>;
  totalCredits?: Maybe<Scalars['Int']['output']>;
  totalDebits?: Maybe<Scalars['Int']['output']>;
  transactions?: Maybe<Array<FrequentRiderPointsTransaction>>;
};

export type FrequentRiderPointsTransaction = {
  __typename?: 'FrequentRiderPointsTransaction';
  comments?: Maybe<Scalars['String']['output']>;
  debitCredit?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  programId?: Maybe<Scalars['Int']['output']>;
  redemptionType?: Maybe<Scalars['String']['output']>;
  resId?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transactionDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type FrequentRiderProgram = {
  __typename?: 'FrequentRiderProgram';
  cost: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  raw?: Maybe<Scalars['String']['output']>;
  redemptionDefaultDate?: Maybe<Scalars['String']['output']>;
  redemptionDuration?: Maybe<Scalars['String']['output']>;
  redemptionMaxUsage?: Maybe<Scalars['Int']['output']>;
  redemptionType: Scalars['String']['output'];
  sellFarePer?: Maybe<Scalars['Float']['output']>;
  sellMaxQuantity?: Maybe<Scalars['Int']['output']>;
  sellMinQuantity?: Maybe<Scalars['Int']['output']>;
  sellType?: Maybe<ProgramSell>;
};

/** Autogenerated input type of FrequentRiderProgramPurchase */
export type FrequentRiderProgramPurchaseInput = {
  booking: FrequentRiderProgramPurchaseType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  frpProgramCost?: InputMaybe<Scalars['Float']['input']>;
  frpProgramEndDate?: InputMaybe<Scalars['String']['input']>;
  frpProgramId: Scalars['Int']['input'];
  frpProgramQuantity?: InputMaybe<Scalars['Int']['input']>;
  frpProgramStartDate?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Scalars['Int']['input']>;
};

export type FrequentRiderProgramPurchaseLeg = {
  marketingCodes?: InputMaybe<MarketingCodes>;
  profiles?: InputMaybe<Profiles>;
};

/** Autogenerated return type of FrequentRiderProgramPurchase */
export type FrequentRiderProgramPurchasePayload = {
  __typename?: 'FrequentRiderProgramPurchasePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  resId?: Maybe<Scalars['String']['output']>;
};

export type FrequentRiderProgramPurchaseType = {
  contact?: InputMaybe<BookContact>;
  payment: Payment;
  res: FrequentRiderProgramPurchaseLeg;
};

export type Gdf = {
  __typename?: 'Gdf';
  columnDefinitions?: Maybe<Array<ColumnDefinition>>;
  data?: Maybe<Array<Array<Scalars['String']['output']>>>;
  error?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<Properties>;
};

export type GratuityPercentage = {
  __typename?: 'GratuityPercentage';
  label?: Maybe<Scalars['String']['output']>;
  percent: Scalars['Float']['output'];
};

export enum HideFareMode {
  /** Always */
  Always = 'always',
  /** Never */
  Never = 'never'
}

export enum HideSubfareMode {
  /** Always */
  Always = 'always',
  /** Never */
  Never = 'never'
}

export type Hotkey = {
  __typename?: 'Hotkey';
  bgColor?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  functionCode?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  params?: Maybe<Scalars['String']['output']>;
  textColor?: Maybe<Scalars['String']['output']>;
  viewAlias?: Maybe<Scalars['String']['output']>;
};

export type HotkeysReply = {
  __typename?: 'HotkeysReply';
  error?: Maybe<Scalars['String']['output']>;
  hotkeys?: Maybe<Array<Hotkey>>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type InputFieldValue = {
  field: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InputLatLng = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
};

export type LatLng = {
  __typename?: 'LatLng';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type Loc = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  latLng?: InputMaybe<InputLatLng>;
  name?: InputMaybe<Scalars['String']['input']>;
  sector?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type Location = {
  __typename?: 'Location';
  address?: Maybe<Scalars['String']['output']>;
  addressDetails?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  crossStreet?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  directions?: Maybe<Scalars['String']['output']>;
  displayAddress?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  fklRequest?: Maybe<Scalars['String']['output']>;
  fklResponse?: Maybe<Scalars['String']['output']>;
  fullState?: Maybe<Scalars['String']['output']>;
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  icons?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  latLng?: Maybe<LatLng>;
  metadata: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  pickupPoint?: Maybe<Scalars['String']['output']>;
  pickupPoints?: Maybe<Array<PickupPoint>>;
  raw?: Maybe<Scalars['String']['output']>;
  requireCrossStreet?: Maybe<Scalars['Boolean']['output']>;
  sector?: Maybe<Scalars['String']['output']>;
  serviceAreas: Array<Scalars['Int']['output']>;
  showAddressDetails?: Maybe<Scalars['Boolean']['output']>;
  showCrossStreet?: Maybe<Scalars['Boolean']['output']>;
  showFlightDate: Scalars['Boolean']['output'];
  showFlightNumber: Scalars['Boolean']['output'];
  showFlightType: Scalars['Boolean']['output'];
  state?: Maybe<Scalars['String']['output']>;
  string?: Maybe<Scalars['String']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
  transportationHub: Scalars['Boolean']['output'];
  type?: Maybe<Scalars['String']['output']>;
  typeString?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type LocationList = {
  __typename?: 'LocationList';
  locations: Array<Location>;
  pages: Scalars['Int']['output'];
  totalItems: Scalars['Int']['output'];
};

export enum LocationMode {
  /** Show all location types */
  All = 'all',
  /** Show all locations, up to 4 per category */
  AllLocations = 'all_locations',
  /** Never display location types */
  None = 'none',
  /** Use location type config */
  UseConfig = 'use_config'
}

export type LocationTypeOption = {
  __typename?: 'LocationTypeOption';
  image: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Autogenerated input type of LoginProfile */
export type LoginProfileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

/** Autogenerated return type of LoginProfile */
export type LoginProfilePayload = {
  __typename?: 'LoginProfilePayload';
  attachedGroup?: Maybe<Scalars['Int']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of LogoutProfile */
export type LogoutProfileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

/** Autogenerated return type of LogoutProfile */
export type LogoutProfilePayload = {
  __typename?: 'LogoutProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of LogoutUser */
export type LogoutUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
};

/** Autogenerated return type of LogoutUser */
export type LogoutUserPayload = {
  __typename?: 'LogoutUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  displayError?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  jwt?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MadeBy = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum MadeByMode {
  /** Any value. required */
  Any = 'any',
  /** Authorized list, required */
  AuthorizedList = 'authorized_list',
  /** Hide */
  Hide = 'hide'
}

export type MarketingCodes = {
  marketingCode?: InputMaybe<Scalars['String']['input']>;
  marketingCode2?: InputMaybe<Scalars['String']['input']>;
  marketingCode3?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  book?: Maybe<BookPayload>;
  cancelRes?: Maybe<CancelResPayload>;
  convertRes?: Maybe<ConvertResPayload>;
  frequentRiderProgramPurchase?: Maybe<FrequentRiderProgramPurchasePayload>;
  loginProfile?: Maybe<LoginProfilePayload>;
  logoutProfile?: Maybe<LogoutProfilePayload>;
  logoutUser?: Maybe<LogoutUserPayload>;
  processHotkey?: Maybe<ProcessHotkeyPayload>;
  /** Process PID */
  processPid?: Maybe<ProcessPid>;
  profileAdd?: Maybe<ProfileAddPayload>;
  rateMyRideSubmit?: Maybe<RateMyRideSubmitPayload>;
  repriceService?: Maybe<RepriceServicePayload>;
  savePassword?: Maybe<SavePasswordPayload>;
  savePasswordWithPid?: Maybe<SavePasswordWithPidPayload>;
  sendPasswordReset?: Maybe<SendPasswordResetPayload>;
  tokenize?: Maybe<TokenizePayload>;
  userProfileAddCc?: Maybe<UserProfileAddCcPayload>;
  userProfileAddPud?: Maybe<UserProfileAddPudPayload>;
  userProfileAddValpayCc?: Maybe<UserProfileAddValpayCcPayload>;
  userProfileDeleteCc?: Maybe<UserProfileDeleteCcPayload>;
  userProfileDeletePud?: Maybe<UserProfileDeletePudPayload>;
  userProfileDeletePudCc?: Maybe<UserProfileDeletePudCcPayload>;
  userProfileLinkGroup?: Maybe<UserProfileLinkGroupPayload>;
  userProfileUpdate?: Maybe<UserProfileUpdatePayload>;
  userProfileUpdatePud?: Maybe<UserProfileUpdatePudPayload>;
  validateUser?: Maybe<ValidateUserPayload>;
  verifyRes?: Maybe<VerifyResPayload>;
};


export type MutationBookArgs = {
  input: BookInput;
};


export type MutationCancelResArgs = {
  input: CancelResInput;
};


export type MutationConvertResArgs = {
  input: ConvertResInput;
};


export type MutationFrequentRiderProgramPurchaseArgs = {
  input: FrequentRiderProgramPurchaseInput;
};


export type MutationLoginProfileArgs = {
  input: LoginProfileInput;
};


export type MutationLogoutProfileArgs = {
  input: LogoutProfileInput;
};


export type MutationLogoutUserArgs = {
  input: LogoutUserInput;
};


export type MutationProcessHotkeyArgs = {
  input: ProcessHotkeyInput;
};


export type MutationProcessPidArgs = {
  pid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProfileAddArgs = {
  input: ProfileAddInput;
};


export type MutationRateMyRideSubmitArgs = {
  input: RateMyRideSubmitInput;
};


export type MutationRepriceServiceArgs = {
  input: RepriceServiceInput;
};


export type MutationSavePasswordArgs = {
  input: SavePasswordInput;
};


export type MutationSavePasswordWithPidArgs = {
  input: SavePasswordWithPidInput;
};


export type MutationSendPasswordResetArgs = {
  input: SendPasswordResetInput;
};


export type MutationTokenizeArgs = {
  input: TokenizeInput;
};


export type MutationUserProfileAddCcArgs = {
  input: UserProfileAddCcInput;
};


export type MutationUserProfileAddPudArgs = {
  input: UserProfileAddPudInput;
};


export type MutationUserProfileAddValpayCcArgs = {
  input: UserProfileAddValpayCcInput;
};


export type MutationUserProfileDeleteCcArgs = {
  input: UserProfileDeleteCcInput;
};


export type MutationUserProfileDeletePudArgs = {
  input: UserProfileDeletePudInput;
};


export type MutationUserProfileDeletePudCcArgs = {
  input: UserProfileDeletePudCcInput;
};


export type MutationUserProfileLinkGroupArgs = {
  input: UserProfileLinkGroupInput;
};


export type MutationUserProfileUpdateArgs = {
  input: UserProfileUpdateInput;
};


export type MutationUserProfileUpdatePudArgs = {
  input: UserProfileUpdatePudInput;
};


export type MutationValidateUserArgs = {
  input: ValidateUserInput;
};


export type MutationVerifyResArgs = {
  input: VerifyResInput;
};

export enum OpenResMode {
  /** Disabled - Open reservations not allowed */
  Disabled = 'disabled',
  /** Enabled - Open reservations allowed */
  Enabled = 'enabled',
  /** Enabled - Open reservations allowed, collect date */
  EnabledCollectDate = 'enabled_collect_date'
}

export type Passenger = {
  __typename?: 'Passenger';
  fieldName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  maxPassengers: Scalars['Int']['output'];
  popup?: Maybe<Scalars['String']['output']>;
  raw?: Maybe<Scalars['String']['output']>;
};

export type Payment = {
  chargeTo?: InputMaybe<Scalars['String']['input']>;
  creditCard?: InputMaybe<BookCreditCard>;
  shopperReference?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  typeId: Scalars['String']['input'];
  variance?: InputMaybe<Scalars['Float']['input']>;
};

export type PickupExtra = {
  __typename?: 'PickupExtra';
  charge?: Maybe<Scalars['Float']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type PickupPoint = {
  __typename?: 'PickupPoint';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Autogenerated input type of ProcessHotkey */
export type ProcessHotkeyInput = {
  additionalParamString?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hotkeyId: Scalars['Int']['input'];
  referenceId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of ProcessHotkey */
export type ProcessHotkeyPayload = {
  __typename?: 'ProcessHotkeyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ProcessPid = {
  __typename?: 'ProcessPid';
  charter?: Maybe<Scalars['Int']['output']>;
  group?: Maybe<Scalars['Int']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  sales?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<Scalars['Int']['output']>;
};

export type Profile = {
  __typename?: 'Profile';
  contactInfo?: Maybe<ProfileContact>;
  creditCards?: Maybe<Array<TokenizedCreditCard>>;
  id: Scalars['ID']['output'];
  linkedGroupName?: Maybe<Scalars['String']['output']>;
  locations?: Maybe<Array<Pud>>;
};

/** Autogenerated input type of ProfileAdd */
export type ProfileAddInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  linkedReservations?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  telephone?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ProfileAdd */
export type ProfileAddPayload = {
  __typename?: 'ProfileAddPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ProfileContact = {
  __typename?: 'ProfileContact';
  altPhone?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type ProfilePud = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressDetails?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  creditCard?: InputMaybe<ProfilePudCreditCard>;
  crossStreet?: InputMaybe<Scalars['String']['input']>;
  directions?: InputMaybe<Scalars['String']['input']>;
  displayAddress?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  latLng?: InputMaybe<InputLatLng>;
  name?: InputMaybe<Scalars['String']['input']>;
  pudName?: InputMaybe<Scalars['String']['input']>;
  sector?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  telephone2?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type ProfilePudCreditCard = {
  address?: InputMaybe<Scalars['String']['input']>;
  expiration: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  number: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileUpdateProfileType = {
  contact?: InputMaybe<Contact>;
  linkedReservations?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Profiles = {
  charter?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  sales?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export enum ProgramSell {
  /** Disabled */
  Disabled = 'disabled',
  /** Fixed price via standard template */
  FixedViaTemplate = 'fixed_via_template',
  /** Per point via program configuration */
  PerPoint = 'per_point',
  /** Unknown */
  Unknown = 'unknown'
}

export type Properties = {
  __typename?: 'Properties';
  fileName: Scalars['String']['output'];
  gridType: Scalars['String']['output'];
  quickFilters?: Maybe<Array<QuickFilter>>;
};

export type Pud = {
  __typename?: 'Pud';
  address?: Maybe<Scalars['String']['output']>;
  addressDetails?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  creditCard?: Maybe<TokenizedCreditCard>;
  crossStreet?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  directions?: Maybe<Scalars['String']['output']>;
  displayAddress?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  fklRequest?: Maybe<Scalars['String']['output']>;
  fklResponse?: Maybe<Scalars['String']['output']>;
  fullState?: Maybe<Scalars['String']['output']>;
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  icons?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  latLng?: Maybe<LatLng>;
  metadata: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  pickupPoint?: Maybe<Scalars['String']['output']>;
  pickupPoints?: Maybe<Array<PickupPoint>>;
  pudName?: Maybe<Scalars['String']['output']>;
  raw?: Maybe<Scalars['String']['output']>;
  requireCrossStreet?: Maybe<Scalars['Boolean']['output']>;
  sector?: Maybe<Scalars['String']['output']>;
  serviceAreas: Array<Scalars['Int']['output']>;
  showAddressDetails?: Maybe<Scalars['Boolean']['output']>;
  showCrossStreet?: Maybe<Scalars['Boolean']['output']>;
  showFlightDate: Scalars['Boolean']['output'];
  showFlightNumber: Scalars['Boolean']['output'];
  showFlightType: Scalars['Boolean']['output'];
  state?: Maybe<Scalars['String']['output']>;
  string?: Maybe<Scalars['String']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
  telephone2?: Maybe<Scalars['String']['output']>;
  transportationHub: Scalars['Boolean']['output'];
  type?: Maybe<Scalars['String']['output']>;
  typeString?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type PudPerson = {
  __typename?: 'PudPerson';
  address?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /** List of airlines */
  airlines: Array<Airline>;
  /** Colors */
  colors: Colors;
  /** Configuration */
  config: Config;
  /** Content */
  content: Content;
  /** Default values/settings based off the loaded profiles, etc. */
  defaults: Defaults;
  /** Desktops */
  desktops: DesktopsReply;
  /** Validate Epic Pass ID */
  epicPassValidate: EpicPassReturn;
  /** Validate Epic Pass based off pickup date */
  epicPassValidateDate: EpicPassReturn;
  /** Fare key lookup */
  fareKeyLookup: FareKeyLookupReturn;
  /** Fixed location types, used for the BE location dropdown to show locations / fixed location types. */
  fixedLocationTypes: Array<FixedLocationType>;
  /** Frequent rider points */
  frequentRiderPoints: Array<FrequentRiderPoints>;
  /** Frequent rider programs */
  frequentRiderPrograms: Array<FrequentRiderProgram>;
  /** Hotkeys */
  hotkeys: HotkeysReply;
  /** Location record */
  location?: Maybe<Location>;
  /** Locations for a given type */
  locationList: LocationList;
  /** Locations especially filtered for autocomplete results */
  locationsForAutocomplete: Array<Location>;
  /** List of available passenger types */
  passengerTypes: Array<Passenger>;
  /** Profile preferred locations */
  profilePreferredLocations: Array<Location>;
  /** Profile reservations */
  profileReservations: Array<Reservation>;
  /** People extracted from PUDs */
  pudPeople: Array<PudPerson>;
  /** Rate My Ride template */
  rateMyRideTemplate: RateMyRideTemplate;
  /** Read GDF */
  readGdf: Gdf;
  /** Referral links */
  referralLinks: Array<ReferralLink>;
  /** Reservation record */
  reservation?: Maybe<Reservation>;
  /** List of available service extras */
  serviceExtras: Array<ServiceExtra>;
  /** List of available services */
  services: Array<Service>;
  /** Special info */
  specialInfo: Array<Field>;
  /** Tokens */
  tokens: Array<Token>;
  /** Profile record */
  userProfile?: Maybe<Profile>;
  /** Check if user profile record exists */
  userProfileExists: UserProfileExists;
  /** ValPay Configuration */
  valpayConfig: ValpayConfig;
  /** List of GPS waypoints */
  waypoints: Array<Waypoint>;
};


export type QueryAirlinesArgs = {
  airportCode: Scalars['String']['input'];
  serviceArea?: InputMaybe<Scalars['Int']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryConfigArgs = {
  charterProfile?: InputMaybe<Scalars['Int']['input']>;
  groupProfile?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  serviceArea?: InputMaybe<Scalars['Int']['input']>;
  userProfile?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryContentArgs = {
  charterProfile?: InputMaybe<Scalars['Int']['input']>;
  groupProfile?: InputMaybe<Scalars['Int']['input']>;
  serviceArea?: InputMaybe<Scalars['Int']['input']>;
  showToken?: InputMaybe<Scalars['Boolean']['input']>;
  tokenGroup?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDefaultsArgs = {
  groupProfile?: InputMaybe<Scalars['Int']['input']>;
  pudId?: InputMaybe<Scalars['Int']['input']>;
  userProfile?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDesktopsArgs = {
  userId: Scalars['String']['input'];
};


export type QueryEpicPassValidateArgs = {
  passId: Scalars['String']['input'];
};


export type QueryEpicPassValidateDateArgs = {
  passId: Scalars['String']['input'];
  pickupDate: Scalars['String']['input'];
};


export type QueryFareKeyLookupArgs = {
  displayAddress?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fareCode?: InputMaybe<Scalars['String']['input']>;
  googleObject?: InputMaybe<Scalars['String']['input']>;
  groupProfile?: InputMaybe<Scalars['Int']['input']>;
  serviceAreas?: InputMaybe<Array<Scalars['Int']['input']>>;
  sourceType?: InputMaybe<Scalars['Int']['input']>;
  typeString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFixedLocationTypesArgs = {
  charterProfile?: InputMaybe<Scalars['Int']['input']>;
  groupProfile?: InputMaybe<Scalars['Int']['input']>;
  hidePuds?: InputMaybe<Scalars['Boolean']['input']>;
  pudId?: InputMaybe<Scalars['Int']['input']>;
  serviceArea?: InputMaybe<Scalars['Int']['input']>;
  userProfile?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFrequentRiderPointsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryHotkeysArgs = {
  viewAlias: Scalars['String']['input'];
};


export type QueryLocationArgs = {
  fareCode: Scalars['String']['input'];
  groupProfile?: InputMaybe<Scalars['Int']['input']>;
  serviceArea?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLocationListArgs = {
  charterProfile?: InputMaybe<Scalars['Int']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  groupProfile?: InputMaybe<Scalars['Int']['input']>;
  locationType: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  serviceArea?: InputMaybe<Scalars['Int']['input']>;
  userProfile?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLocationsForAutocompleteArgs = {
  groupProfile?: InputMaybe<Scalars['Int']['input']>;
  returnAll?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  serviceArea?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPassengerTypesArgs = {
  groupProfile?: InputMaybe<Scalars['Int']['input']>;
  passengerTypesAlias?: InputMaybe<Scalars['String']['input']>;
  serviceArea?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProfilePreferredLocationsArgs = {
  groupProfile?: InputMaybe<Scalars['Int']['input']>;
  userProfile?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProfileReservationsArgs = {
  dateRange?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};


export type QueryPudPeopleArgs = {
  userProfile?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRateMyRideTemplateArgs = {
  pid: Scalars['String']['input'];
};


export type QueryReadGdfArgs = {
  desktopId: Scalars['String']['input'];
  quickFilterId?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};


export type QueryReferralLinksArgs = {
  flightCity?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReservationArgs = {
  pid?: InputMaybe<Scalars['String']['input']>;
  resId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryServiceExtrasArgs = {
  groupProfile?: InputMaybe<Scalars['Int']['input']>;
  serviceArea?: InputMaybe<Scalars['Int']['input']>;
  serviceExtrasAlias?: InputMaybe<Scalars['String']['input']>;
};


export type QueryServicesArgs = {
  res: ServicesResType;
  sourceType?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySpecialInfoArgs = {
  groupProfile?: InputMaybe<Scalars['Int']['input']>;
  siAlias?: InputMaybe<Scalars['String']['input']>;
  userProfile?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserProfileArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUserProfileExistsArgs = {
  email: Scalars['String']['input'];
};


export type QueryValpayConfigArgs = {
  processorId?: InputMaybe<Scalars['Int']['input']>;
  shopperReference?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWaypointsArgs = {
  filters?: InputMaybe<Array<InputFieldValue>>;
  siteId?: InputMaybe<Scalars['String']['input']>;
};

export type QuickFilter = {
  __typename?: 'QuickFilter';
  caption: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

/** Autogenerated input type of RateMyRideSubmit */
export type RateMyRideSubmitInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  submission: RmrSubmissionType;
};

/** Autogenerated return type of RateMyRideSubmit */
export type RateMyRideSubmitPayload = {
  __typename?: 'RateMyRideSubmitPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  successMessage?: Maybe<Scalars['String']['output']>;
};

export type RateMyRideTemplate = {
  __typename?: 'RateMyRideTemplate';
  content: RmrContent;
  id: Scalars['ID']['output'];
  options: RmrOptions;
  ratingCategories: Array<RmrRatingCategory>;
  resId: Scalars['String']['output'];
  reservation: RmrReservation;
};

export type ReferralLink = {
  __typename?: 'ReferralLink';
  alias: Scalars['String']['output'];
  boldText?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  linkText?: Maybe<Scalars['String']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  popup?: Maybe<Scalars['String']['output']>;
  priority: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  webItems?: Maybe<Array<Scalars['String']['output']>>;
};

export type Reprice = {
  __typename?: 'Reprice';
  bagCountMax?: Maybe<Scalars['Int']['output']>;
  fareComponents: Array<FieldValue>;
  fareDisplay?: Maybe<Scalars['Float']['output']>;
  gratuityFare?: Maybe<Scalars['Float']['output']>;
  payments?: Maybe<ServicePayment>;
  times?: Maybe<Array<ServiceTime>>;
  webSubfares?: Maybe<Array<FieldValue>>;
};

/** Autogenerated input type of RepriceService */
export type RepriceServiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  recalcEntireFare?: InputMaybe<Scalars['Boolean']['input']>;
  res: ServicesResType;
  sourceType?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of RepriceService */
export type RepriceServicePayload = {
  __typename?: 'RepriceServicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['Boolean']['output']>;
  reprice?: Maybe<Reprice>;
};

export type Res = {
  bagCount?: InputMaybe<Scalars['Int']['input']>;
  dropoff: BookLoc;
  dropoffTime?: InputMaybe<Scalars['String']['input']>;
  epicPassValidated?: InputMaybe<Scalars['Boolean']['input']>;
  fareComponents?: InputMaybe<Array<InputFieldValue>>;
  flags?: InputMaybe<Scalars['String']['input']>;
  flight?: InputMaybe<BookFlight>;
  jobType?: InputMaybe<Scalars['Int']['input']>;
  marketingCodes?: InputMaybe<MarketingCodes>;
  mileage?: InputMaybe<Scalars['Float']['input']>;
  passengerDetails?: InputMaybe<Array<BookPassengerDetails>>;
  passengerTypesAlias?: InputMaybe<Scalars['String']['input']>;
  passengers?: InputMaybe<Array<InputFieldValue>>;
  payments?: InputMaybe<BookLegPaymentsType>;
  perPassengerRates?: InputMaybe<Scalars['String']['input']>;
  pickup: BookLoc;
  pickupExtra?: InputMaybe<Scalars['String']['input']>;
  pickupTime?: InputMaybe<Scalars['String']['input']>;
  profiles?: InputMaybe<Profiles>;
  resId?: InputMaybe<Scalars['String']['input']>;
  resIdInternal?: InputMaybe<Scalars['Int']['input']>;
  returnTripStatus?: InputMaybe<Scalars['String']['input']>;
  serviceArea?: InputMaybe<Scalars['Int']['input']>;
  serviceExtras?: InputMaybe<Array<InputFieldValue>>;
  serviceExtrasAlias?: InputMaybe<Scalars['String']['input']>;
  serviceType?: InputMaybe<Scalars['Int']['input']>;
  skedRun?: InputMaybe<Scalars['Int']['input']>;
  specialInfo?: InputMaybe<Array<InputFieldValue>>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  specialInstructions2?: InputMaybe<Scalars['String']['input']>;
  stops?: InputMaybe<Array<BookStop>>;
  travelTime?: InputMaybe<Scalars['Float']['input']>;
  userGratuityOverride?: InputMaybe<Scalars['Boolean']['input']>;
  userGratuityPercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type ResContact = {
  __typename?: 'ResContact';
  altPhone?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type ResFlight = {
  __typename?: 'ResFlight';
  airline?: Maybe<Scalars['String']['output']>;
  flightCity?: Maybe<Scalars['String']['output']>;
  flightNumber?: Maybe<Scalars['String']['output']>;
  flightTime?: Maybe<Scalars['String']['output']>;
  flightType?: Maybe<Scalars['String']['output']>;
  terminal?: Maybe<Scalars['String']['output']>;
};

export type ResMadeBy = {
  __typename?: 'ResMadeBy';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type ResOptions = {
  __typename?: 'ResOptions';
  allowOpenResConversion: Scalars['Boolean']['output'];
};

export type ResOther = {
  __typename?: 'ResOther';
  idNumber?: Maybe<Scalars['String']['output']>;
  madeBy?: Maybe<ResMadeBy>;
  marketingCode?: Maybe<Scalars['String']['output']>;
  marketingCode2?: Maybe<Scalars['String']['output']>;
  marketingCode3?: Maybe<Scalars['String']['output']>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  specialInstructions2?: Maybe<Scalars['String']['output']>;
};

export type ResPayment = {
  __typename?: 'ResPayment';
  chargeTo?: Maybe<Scalars['String']['output']>;
  creditCard?: Maybe<TokenizedCreditCard>;
  shopperReference?: Maybe<Scalars['String']['output']>;
  typeId?: Maybe<Scalars['String']['output']>;
  variance?: Maybe<Scalars['Float']['output']>;
};

export type ResProfiles = {
  __typename?: 'ResProfiles';
  charter?: Maybe<Scalars['Int']['output']>;
  coupon?: Maybe<Scalars['Int']['output']>;
  couponWeb?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['Int']['output']>;
  sales?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<Scalars['Int']['output']>;
};

export type ResStop = {
  __typename?: 'ResStop';
  comments?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Reservation = {
  __typename?: 'Reservation';
  bagCount: Scalars['Int']['output'];
  cancellable: Scalars['Boolean']['output'];
  cancelled: Scalars['Boolean']['output'];
  compId?: Maybe<Scalars['Int']['output']>;
  contactInfo: ResContact;
  dropoff: Location;
  editable: Scalars['Boolean']['output'];
  epicPassId?: Maybe<Scalars['String']['output']>;
  epicPassValidated?: Maybe<Scalars['Boolean']['output']>;
  flags?: Maybe<Scalars['String']['output']>;
  flight?: Maybe<ResFlight>;
  id: Scalars['ID']['output'];
  itineraryId?: Maybe<Scalars['String']['output']>;
  jobNumber?: Maybe<Scalars['String']['output']>;
  jobType?: Maybe<Scalars['Int']['output']>;
  open?: Maybe<Scalars['Boolean']['output']>;
  operation?: Maybe<Scalars['String']['output']>;
  options?: Maybe<ResOptions>;
  other?: Maybe<ResOther>;
  passengers: Array<FieldValue>;
  payment?: Maybe<ResPayment>;
  pickup: Location;
  profiles?: Maybe<ResProfiles>;
  resId?: Maybe<Scalars['String']['output']>;
  resIdInternal?: Maybe<Scalars['Int']['output']>;
  returnTripStatus?: Maybe<Scalars['String']['output']>;
  service?: Maybe<Service>;
  serviceArea?: Maybe<Scalars['Int']['output']>;
  serviceExtras: Array<FieldValue>;
  sourceType?: Maybe<Scalars['Int']['output']>;
  stops?: Maybe<Array<ResStop>>;
  totalOriginal?: Maybe<Scalars['Float']['output']>;
  userGratuityOverride?: Maybe<Scalars['Boolean']['output']>;
  userGratuityPercentage?: Maybe<Scalars['Float']['output']>;
};

export type RmrContent = {
  __typename?: 'RmrContent';
  commentsLabel?: Maybe<Scalars['String']['output']>;
  creditCardExpLabel?: Maybe<Scalars['String']['output']>;
  creditCardNameLabel?: Maybe<Scalars['String']['output']>;
  creditCardNumLabel?: Maybe<Scalars['String']['output']>;
  creditCardSecCodeLabel?: Maybe<Scalars['String']['output']>;
  creditCardZipLabel?: Maybe<Scalars['String']['output']>;
  defaultGratuities?: Maybe<Array<RmrDefaultGratuity>>;
  displayedMessage?: Maybe<Scalars['String']['output']>;
  genericSubmitError?: Maybe<Scalars['String']['output']>;
  gratuityAddTipLabel?: Maybe<Scalars['String']['output']>;
  gratuityMessage?: Maybe<Scalars['String']['output']>;
  gratuityNoTip?: Maybe<Scalars['String']['output']>;
  headerMessage?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
};

export type RmrCreditCard = {
  encryptedCardNumber?: InputMaybe<Scalars['String']['input']>;
  encryptedExpiryMonth?: InputMaybe<Scalars['String']['input']>;
  encryptedExpiryYear?: InputMaybe<Scalars['String']['input']>;
  encryptedSecurityCode?: InputMaybe<Scalars['String']['input']>;
  expiration?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  securityCode?: InputMaybe<Scalars['String']['input']>;
  shopperReference?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type RmrDefaultGratuity = {
  __typename?: 'RmrDefaultGratuity';
  text: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type RmrOptions = {
  __typename?: 'RmrOptions';
  allowCreditCardEntry: Scalars['Boolean']['output'];
  formLocked: Scalars['Boolean']['output'];
  maxGratuityPercent?: Maybe<Scalars['Float']['output']>;
  requireCvvForCardOnFile: Scalars['Boolean']['output'];
  sectionOrder: Array<Scalars['String']['output']>;
  showComments: Scalars['Boolean']['output'];
  showCreditCard: Scalars['Boolean']['output'];
  showGratuitySection: Scalars['Boolean']['output'];
  showRatings: Scalars['Boolean']['output'];
};

export type RmrRating = {
  name: Scalars['String']['input'];
  value: Scalars['Int']['input'];
};

export type RmrRatingCategory = {
  __typename?: 'RmrRatingCategory';
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type RmrReservation = {
  __typename?: 'RmrReservation';
  ccNumberLast4?: Maybe<Scalars['String']['output']>;
  ccToken?: Maybe<Scalars['String']['output']>;
  ccType?: Maybe<Scalars['String']['output']>;
  dropoff?: Maybe<Scalars['String']['output']>;
  fare?: Maybe<Scalars['Float']['output']>;
  gratuitySubFare?: Maybe<Scalars['Float']['output']>;
  includedGratuity?: Maybe<Scalars['Float']['output']>;
  pickup?: Maybe<Scalars['String']['output']>;
  resDate?: Maybe<Scalars['String']['output']>;
  shopperReference?: Maybe<Scalars['String']['output']>;
};

export type RmrSubmissionType = {
  cardOnFile?: InputMaybe<Scalars['Boolean']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  creditCard?: InputMaybe<RmrCreditCard>;
  gratuity?: InputMaybe<Scalars['Float']['input']>;
  ratings: Array<RmrRating>;
  resId: Scalars['String']['input'];
};

export enum RoundTripPricingMode {
  /** Never */
  Never = 'never',
  /** Recalculate */
  Recalculate = 'recalculate',
  /** Regenerate */
  Regenerate = 'regenerate'
}

/** Autogenerated input type of SavePassword */
export type SavePasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currentPassword: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  newPassword: Scalars['String']['input'];
};

/** Autogenerated return type of SavePassword */
export type SavePasswordPayload = {
  __typename?: 'SavePasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SavePasswordWithPid */
export type SavePasswordWithPidInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  pid: Scalars['String']['input'];
};

/** Autogenerated return type of SavePasswordWithPid */
export type SavePasswordWithPidPayload = {
  __typename?: 'SavePasswordWithPidPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SendPasswordReset */
export type SendPasswordResetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  resetPasswordUrl: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

/** Autogenerated return type of SendPasswordReset */
export type SendPasswordResetPayload = {
  __typename?: 'SendPasswordResetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Service = {
  __typename?: 'Service';
  bagCountMax?: Maybe<Scalars['Int']['output']>;
  defaultBaggage?: Maybe<Scalars['Int']['output']>;
  defaultServiceGratuityPercent?: Maybe<Scalars['Float']['output']>;
  fare?: Maybe<Scalars['Float']['output']>;
  fareCalculationMode?: Maybe<Scalars['String']['output']>;
  fareComponents: Array<FieldValue>;
  fareDisplay?: Maybe<Scalars['Float']['output']>;
  fareDisplayMode?: Maybe<FareDisplayMode>;
  gratuityFare?: Maybe<Scalars['Float']['output']>;
  hideBaggage?: Maybe<Scalars['Boolean']['output']>;
  hideFareMode?: Maybe<HideFareMode>;
  hideFlightInfo?: Maybe<Scalars['Boolean']['output']>;
  hideMaximumPassengers?: Maybe<Scalars['Boolean']['output']>;
  hideRoundtrip?: Maybe<Scalars['Boolean']['output']>;
  hideSubfareMode?: Maybe<HideSubfareMode>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  includedGratuity?: Maybe<Scalars['Float']['output']>;
  items: Array<Scalars['String']['output']>;
  madeByMode?: Maybe<MadeByMode>;
  maxPassengers: Scalars['Int']['output'];
  mileage?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  passengerTypesAlias?: Maybe<Scalars['String']['output']>;
  perPassengerRates?: Maybe<Scalars['String']['output']>;
  pickupExtras?: Maybe<Array<PickupExtra>>;
  processorId?: Maybe<Scalars['Int']['output']>;
  raw?: Maybe<Scalars['String']['output']>;
  roundtripPricingMode?: Maybe<RoundTripPricingMode>;
  selectedPickupExtra?: Maybe<PickupExtra>;
  selectedTime?: Maybe<ServiceTime>;
  serviceExtrasAlias?: Maybe<Scalars['String']['output']>;
  serviceTimeNotes?: Maybe<Scalars['String']['output']>;
  serviceType: Scalars['Int']['output'];
  showExtraStops?: Maybe<Scalars['Boolean']['output']>;
  showGratuity?: Maybe<Scalars['Boolean']['output']>;
  times: Array<ServiceTime>;
  totalGratuity?: Maybe<Scalars['Float']['output']>;
  travelTime?: Maybe<Scalars['Float']['output']>;
  webSubfares: Array<FieldValue>;
};

export type ServiceExtra = {
  __typename?: 'ServiceExtra';
  defaultToBlank?: Maybe<Scalars['Boolean']['output']>;
  defaultValue?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  fieldName: Scalars['String']['output'];
  fixedAmount: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  maximum?: Maybe<Scalars['Int']['output']>;
  popup?: Maybe<Scalars['String']['output']>;
  raw?: Maybe<Scalars['String']['output']>;
  surcharge?: Maybe<Scalars['Float']['output']>;
};

export type ServicePayment = {
  __typename?: 'ServicePayment';
  amountDue?: Maybe<Scalars['Float']['output']>;
  items?: Maybe<Array<ServicePaymentItem>>;
  totalPaymentAmount?: Maybe<Scalars['Float']['output']>;
};

export type ServicePaymentItem = {
  __typename?: 'ServicePaymentItem';
  paymentAmount?: Maybe<Scalars['Float']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  programId?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ServiceTime = {
  __typename?: 'ServiceTime';
  availableSeats?: Maybe<Scalars['Int']['output']>;
  dropoffTime?: Maybe<Scalars['String']['output']>;
  fareComponents: Array<FieldValue>;
  hasAdditionalCharges: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  offPeakCharge?: Maybe<Scalars['Float']['output']>;
  offpeak: Scalars['Boolean']['output'];
  pickupTime?: Maybe<Scalars['String']['output']>;
  raw?: Maybe<Scalars['String']['output']>;
  shortNoticeCharge?: Maybe<Scalars['Float']['output']>;
  showAvailablePassengers: Scalars['Boolean']['output'];
  skedRun?: Maybe<Scalars['Int']['output']>;
  suggested: Scalars['Boolean']['output'];
  unavailable: Scalars['Boolean']['output'];
  userGratuityPercentage?: Maybe<Scalars['Float']['output']>;
  yieldAdjustment?: Maybe<Scalars['Float']['output']>;
};

export type ServicesPaymentItemType = {
  paymentAmount?: InputMaybe<Scalars['Float']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  programId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ServicesPaymentType = {
  amountDue?: InputMaybe<Scalars['Float']['input']>;
  items?: InputMaybe<Array<ServicesPaymentItemType>>;
  totalPaymentAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type ServicesResType = {
  bagCount?: InputMaybe<Scalars['Int']['input']>;
  charterProfile?: InputMaybe<Scalars['Int']['input']>;
  compPickupTime?: InputMaybe<Scalars['String']['input']>;
  dropoff: Loc;
  epicPassValidated?: InputMaybe<Scalars['Boolean']['input']>;
  fareComponents?: InputMaybe<Array<InputFieldValue>>;
  flight?: InputMaybe<Flight>;
  groupProfile?: InputMaybe<Scalars['Int']['input']>;
  internalId?: InputMaybe<Scalars['Int']['input']>;
  mileage?: InputMaybe<Scalars['Float']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  passengers?: InputMaybe<Array<InputFieldValue>>;
  paymentType?: InputMaybe<Scalars['String']['input']>;
  payments?: InputMaybe<ServicesPaymentType>;
  perPassengerRates?: InputMaybe<Scalars['String']['input']>;
  pickup: Loc;
  pickupExtra?: InputMaybe<Scalars['String']['input']>;
  requestedPickupTime?: InputMaybe<Scalars['String']['input']>;
  reservationFlags?: InputMaybe<Scalars['String']['input']>;
  returnTripStatus?: InputMaybe<Scalars['String']['input']>;
  serviceArea?: InputMaybe<Scalars['Int']['input']>;
  serviceExtras?: InputMaybe<Array<InputFieldValue>>;
  serviceType?: InputMaybe<Scalars['Int']['input']>;
  stops?: InputMaybe<Array<Stop>>;
  travelTime?: InputMaybe<Scalars['Float']['input']>;
  userGratuity?: InputMaybe<Scalars['Float']['input']>;
  userGratuityOverride?: InputMaybe<Scalars['Boolean']['input']>;
  userGratuityPercentage?: InputMaybe<Scalars['Float']['input']>;
  userProfile?: InputMaybe<Scalars['Int']['input']>;
};

export type Stop = {
  comments?: InputMaybe<Scalars['String']['input']>;
  location: Loc;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum TimeFormat {
  /** 12 hour */
  Twelve = 'twelve',
  /** 24 hour */
  Twentyfour = 'twentyfour'
}

export type Token = {
  __typename?: 'Token';
  defaultToken: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of Tokenize */
export type TokenizeInput = {
  ccAddress?: InputMaybe<Scalars['String']['input']>;
  ccExpiration: Scalars['String']['input'];
  ccName?: InputMaybe<Scalars['String']['input']>;
  ccNumber: Scalars['String']['input'];
  ccPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of Tokenize */
export type TokenizePayload = {
  __typename?: 'TokenizePayload';
  ccExpiration?: Maybe<Scalars['String']['output']>;
  ccLast4?: Maybe<Scalars['String']['output']>;
  ccToken?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

export type TokenizedCreditCard = {
  __typename?: 'TokenizedCreditCard';
  expiration?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  localId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberLast4?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  refId?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  tokenType?: Maybe<Scalars['String']['output']>;
  typeCode?: Maybe<Scalars['String']['output']>;
  uniqueId?: Maybe<Scalars['String']['output']>;
};

export enum TopLocationsMode {
  /** Hide - Hide top locations */
  Hide = 'hide',
  /** Show - Show top locations */
  Show = 'show'
}

/** Autogenerated input type of UserProfileAddCc */
export type UserProfileAddCcInput = {
  ccAddress?: InputMaybe<Scalars['String']['input']>;
  ccExpiration: Scalars['String']['input'];
  ccName: Scalars['String']['input'];
  ccNumber: Scalars['String']['input'];
  ccPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of UserProfileAddCc */
export type UserProfileAddCcPayload = {
  __typename?: 'UserProfileAddCcPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UserProfileAddPud */
export type UserProfileAddPudInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  location: ProfilePud;
};

/** Autogenerated return type of UserProfileAddPud */
export type UserProfileAddPudPayload = {
  __typename?: 'UserProfileAddPudPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UserProfileAddValpayCc */
export type UserProfileAddValpayCcInput = {
  ccCardHolderName?: InputMaybe<Scalars['String']['input']>;
  ccPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  encryptedCardNumber: Scalars['String']['input'];
  encryptedExpiryMonth: Scalars['String']['input'];
  encryptedExpiryYear: Scalars['String']['input'];
  encryptedSecurityCode: Scalars['String']['input'];
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of UserProfileAddValpayCc */
export type UserProfileAddValpayCcPayload = {
  __typename?: 'UserProfileAddValpayCcPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UserProfileDeleteCc */
export type UserProfileDeleteCcInput = {
  ccId?: InputMaybe<Scalars['String']['input']>;
  ccLast4?: InputMaybe<Scalars['String']['input']>;
  ccRefId?: InputMaybe<Scalars['String']['input']>;
  ccToken?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of UserProfileDeleteCc */
export type UserProfileDeleteCcPayload = {
  __typename?: 'UserProfileDeleteCcPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UserProfileDeletePudCc */
export type UserProfileDeletePudCcInput = {
  ccId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  profileId: Scalars['Int']['input'];
  pudId: Scalars['Int']['input'];
};

/** Autogenerated return type of UserProfileDeletePudCc */
export type UserProfileDeletePudCcPayload = {
  __typename?: 'UserProfileDeletePudCcPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UserProfileDeletePud */
export type UserProfileDeletePudInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  locationId: Scalars['Int']['input'];
};

/** Autogenerated return type of UserProfileDeletePud */
export type UserProfileDeletePudPayload = {
  __typename?: 'UserProfileDeletePudPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UserProfileExists = {
  __typename?: 'UserProfileExists';
  exists?: Maybe<Scalars['Boolean']['output']>;
  hasPassword?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  profileId?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of UserProfileLinkGroup */
export type UserProfileLinkGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clientid?: InputMaybe<Scalars['String']['input']>;
  data1?: InputMaybe<Scalars['String']['input']>;
  data2?: InputMaybe<Scalars['String']['input']>;
  groupid?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  webid?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UserProfileLinkGroup */
export type UserProfileLinkGroupPayload = {
  __typename?: 'UserProfileLinkGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UserProfileUpdate */
export type UserProfileUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  updatedFields: ProfileUpdateProfileType;
};

/** Autogenerated return type of UserProfileUpdate */
export type UserProfileUpdatePayload = {
  __typename?: 'UserProfileUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UserProfileUpdatePud */
export type UserProfileUpdatePudInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<ProfilePud>;
  profileId: Scalars['Int']['input'];
};

/** Autogenerated return type of UserProfileUpdatePud */
export type UserProfileUpdatePudPayload = {
  __typename?: 'UserProfileUpdatePudPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ValidateUser */
export type ValidateUserInput = {
  appType: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

/** Autogenerated return type of ValidateUser */
export type ValidateUserPayload = {
  __typename?: 'ValidateUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  displayError?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  jwt?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ValpayConfig = {
  __typename?: 'ValpayConfig';
  clientKey?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  environment?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  paymentMethods?: Maybe<Scalars['String']['output']>;
};

export type Vehicle = {
  __typename?: 'Vehicle';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

/** Autogenerated input type of VerifyRes */
export type VerifyResInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  resId: Scalars['String']['input'];
  validationMode: Scalars['String']['input'];
  validationValue: Scalars['String']['input'];
};

/** Autogenerated return type of VerifyRes */
export type VerifyResPayload = {
  __typename?: 'VerifyResPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['Boolean']['output']>;
  resId?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Waypoint = {
  __typename?: 'Waypoint';
  driver?: Maybe<Driver>;
  heading?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  position?: Maybe<LatLng>;
  recordedTime?: Maybe<Scalars['String']['output']>;
  speed?: Maybe<Scalars['Int']['output']>;
  vehicle?: Maybe<Vehicle>;
};

export type AirlineFragment = { __typename?: 'Airline', id: string, name: string, domesticArrivalTerminal?: string | null, domesticDepartureTerminal?: string | null, intlArrivalTerminal?: string | null, intlDepartureTerminal?: string | null };

export type AirlinesQueryVariables = Exact<{
  airportCode: Scalars['String']['input'];
  groupProfile?: InputMaybe<Scalars['Int']['input']>;
  serviceArea?: InputMaybe<Scalars['Int']['input']>;
  showToken?: InputMaybe<Scalars['Boolean']['input']>;
  tokenGroup?: InputMaybe<Scalars['String']['input']>;
}>;


export type AirlinesQuery = { __typename?: 'Query', airlines: Array<{ __typename?: 'Airline', id: string, name: string, domesticArrivalTerminal?: string | null, domesticDepartureTerminal?: string | null, intlArrivalTerminal?: string | null, intlDepartureTerminal?: string | null }>, content: { __typename?: 'Content', id: string, beErrFieldRequired: string, beErrAirline: string, beAirlineLabel: string, beSelectNoOptions: string } };

export type AutocompleteLocationFragment = { __typename?: 'Location', id: string, displayAddress?: string | null, displayName?: string | null, code?: string | null, type?: string | null, typeString?: string | null };

export type AutocompleteLocationUniversalFragment = { __typename?: 'Location', id: string, displayAddress?: string | null, displayName?: string | null, code?: string | null, city?: string | null, fullState?: string | null, metadata: string, serviceAreas: Array<number>, state?: string | null, string?: string | null, type?: string | null, typeString?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null };

export type BookMutationVariables = Exact<{
  booking: BookBookingType;
  sourceType: Scalars['Int']['input'];
}>;


export type BookMutation = { __typename?: 'Mutation', book?: { __typename?: 'BookPayload', error?: string | null, itineraryId?: string | null, resErrors?: Array<string> | null, resIds?: Array<string> | null } | null };

export type CancelResMutationVariables = Exact<{
  resId: Scalars['Int']['input'];
}>;


export type CancelResMutation = { __typename?: 'Mutation', cancelRes?: { __typename?: 'CancelResPayload', success?: boolean | null } | null };

export type ColorsFragment = { __typename?: 'Colors', id: string, primaryColor: string, primaryHover: string, primaryText: string };

export type ColorsQueryVariables = Exact<{ [key: string]: never; }>;


export type ColorsQuery = { __typename?: 'Query', colors: { __typename?: 'Colors', id: string, primaryColor: string, primaryHover: string, primaryText: string } };

export type ConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type ConfigQuery = { __typename?: 'Query', config: { __typename?: 'Config', error?: string | null, currency: string, defaultServiceArea?: number | null, googleAnalyticsId?: string | null, googleApiKey?: string | null, gtmId?: string | null, requireLoginForBooking?: boolean | null } };

export type ConvertResMutationVariables = Exact<{
  resId: Scalars['Int']['input'];
}>;


export type ConvertResMutation = { __typename?: 'Mutation', convertRes?: { __typename?: 'ConvertResPayload', success?: boolean | null } | null };

export type DefaultsFragmentFragment = { __typename?: 'Defaults', id: string, email?: string | null, faxNumber?: string | null, gratuityPercents?: Array<number> | null, marketingCode?: string | null, marketingCode2?: string | null, marketingCode3?: string | null, name?: string | null, telephone?: string | null, telephone2?: string | null, creditCards?: Array<{ __typename?: 'TokenizedCreditCard', id?: string | null, expiration?: string | null, localId?: string | null, name?: string | null, numberLast4?: string | null, postalCode?: string | null, refId?: string | null, token?: string | null, tokenType?: string | null, typeCode?: string | null, uniqueId?: string | null }> | null };

export type DefaultsQueryVariables = Exact<{
  groupProfile?: InputMaybe<Scalars['Int']['input']>;
  userProfile?: InputMaybe<Scalars['Int']['input']>;
  pudId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DefaultsQuery = { __typename?: 'Query', defaults: { __typename?: 'Defaults', id: string, email?: string | null, faxNumber?: string | null, gratuityPercents?: Array<number> | null, marketingCode?: string | null, marketingCode2?: string | null, marketingCode3?: string | null, name?: string | null, telephone?: string | null, telephone2?: string | null, creditCards?: Array<{ __typename?: 'TokenizedCreditCard', id?: string | null, expiration?: string | null, localId?: string | null, name?: string | null, numberLast4?: string | null, postalCode?: string | null, refId?: string | null, token?: string | null, tokenType?: string | null, typeCode?: string | null, uniqueId?: string | null }> | null } };

export type EpicPassValidateQueryVariables = Exact<{
  passId: Scalars['String']['input'];
}>;


export type EpicPassValidateQuery = { __typename?: 'Query', epicPassValidate: { __typename?: 'EpicPassReturn', valid: boolean } };

export type EpicPassValidateDateQueryVariables = Exact<{
  passId: Scalars['String']['input'];
  pickupDate: Scalars['String']['input'];
}>;


export type EpicPassValidateDateQuery = { __typename?: 'Query', epicPassValidateDate: { __typename?: 'EpicPassReturn', valid: boolean } };

export type FareKeyLookupFragment = { __typename?: 'FareKeyLookupReturn', error?: string | null, errorMessage?: string | null, fklRequest?: string | null, fklResponse?: string | null, lookupType?: number | null, location?: { __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code?: string | null, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName?: string | null, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name?: string | null, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type?: string | null, typeString?: string | null, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null } | null, nearbyLocations?: Array<{ __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code?: string | null, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName?: string | null, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name?: string | null, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type?: string | null, typeString?: string | null, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null }> | null };

export type FareKeyLookupQueryVariables = Exact<{
  displayAddress?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  googleObject?: InputMaybe<Scalars['String']['input']>;
  typeString?: InputMaybe<Scalars['String']['input']>;
  fareCode?: InputMaybe<Scalars['String']['input']>;
  groupProfile?: InputMaybe<Scalars['Int']['input']>;
  serviceAreas?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  sourceType: Scalars['Int']['input'];
}>;


export type FareKeyLookupQuery = { __typename?: 'Query', fareKeyLookup: { __typename?: 'FareKeyLookupReturn', error?: string | null, errorMessage?: string | null, fklRequest?: string | null, fklResponse?: string | null, lookupType?: number | null, location?: { __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code?: string | null, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName?: string | null, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name?: string | null, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type?: string | null, typeString?: string | null, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null } | null, nearbyLocations?: Array<{ __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code?: string | null, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName?: string | null, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name?: string | null, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type?: string | null, typeString?: string | null, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null }> | null } };

export type FixedLocationTypeFragment = { __typename?: 'FixedLocationType', id: string, label: string, locationCount: number, type: string, typeString?: string | null, locations?: Array<{ __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code?: string | null, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName?: string | null, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name?: string | null, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type?: string | null, typeString?: string | null, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null }> | null };

export type FixedLocationTypesQueryVariables = Exact<{
  charterProfile?: InputMaybe<Scalars['Int']['input']>;
  groupProfile?: InputMaybe<Scalars['Int']['input']>;
  hidePuds?: InputMaybe<Scalars['Boolean']['input']>;
  pudId?: InputMaybe<Scalars['Int']['input']>;
  serviceArea?: InputMaybe<Scalars['Int']['input']>;
  userProfile?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FixedLocationTypesQuery = { __typename?: 'Query', fixedLocationTypes: Array<{ __typename?: 'FixedLocationType', id: string, label: string, locationCount: number, type: string, typeString?: string | null, locations?: Array<{ __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code?: string | null, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName?: string | null, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name?: string | null, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type?: string | null, typeString?: string | null, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null }> | null }> };

export type FrequentRiderPointsFragment = { __typename?: 'FrequentRiderPoints', availablePoints?: number | null, id: string, programId?: number | null, totalCredits?: number | null, totalDebits?: number | null, transactions?: Array<{ __typename?: 'FrequentRiderPointsTransaction', comments?: string | null, debitCredit?: string | null, description?: string | null, id: string, name?: string | null, points?: number | null, programId?: number | null, redemptionType?: string | null, resId?: number | null, status?: string | null, transactionDate?: any | null }> | null };

export type FrequentRiderPointsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type FrequentRiderPointsQuery = { __typename?: 'Query', frequentRiderPoints: Array<{ __typename?: 'FrequentRiderPoints', availablePoints?: number | null, id: string, programId?: number | null, totalCredits?: number | null, totalDebits?: number | null, transactions?: Array<{ __typename?: 'FrequentRiderPointsTransaction', comments?: string | null, debitCredit?: string | null, description?: string | null, id: string, name?: string | null, points?: number | null, programId?: number | null, redemptionType?: string | null, resId?: number | null, status?: string | null, transactionDate?: any | null }> | null }> };

export type FrequentRiderProgramFragmentFragment = { __typename?: 'FrequentRiderProgram', id: string, cost: number, name: string, redemptionType: string, description?: string | null, redemptionDuration?: string | null, redemptionDefaultDate?: string | null, redemptionMaxUsage?: number | null, raw?: string | null, sellFarePer?: number | null, sellMinQuantity?: number | null, sellMaxQuantity?: number | null, sellType?: ProgramSell | null };

export type FrequentRiderProgramPurchaseMutationVariables = Exact<{
  booking: FrequentRiderProgramPurchaseType;
  frpProgramId: Scalars['Int']['input'];
  frpProgramCost?: InputMaybe<Scalars['Float']['input']>;
  frpProgramQuantity?: InputMaybe<Scalars['Int']['input']>;
  frpProgramStartDate?: InputMaybe<Scalars['String']['input']>;
  frpProgramEndDate?: InputMaybe<Scalars['String']['input']>;
  sourceType: Scalars['Int']['input'];
}>;


export type FrequentRiderProgramPurchaseMutation = { __typename?: 'Mutation', frequentRiderProgramPurchase?: { __typename?: 'FrequentRiderProgramPurchasePayload', error?: string | null, resId?: string | null } | null };

export type FrequentRiderProgramsQueryVariables = Exact<{ [key: string]: never; }>;


export type FrequentRiderProgramsQuery = { __typename?: 'Query', frequentRiderPrograms: Array<{ __typename?: 'FrequentRiderProgram', id: string, cost: number, name: string, redemptionType: string, description?: string | null, redemptionDuration?: string | null, redemptionDefaultDate?: string | null, redemptionMaxUsage?: number | null, raw?: string | null, sellFarePer?: number | null, sellMinQuantity?: number | null, sellMaxQuantity?: number | null, sellType?: ProgramSell | null }> };

export type LocationFragment = { __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code?: string | null, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName?: string | null, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name?: string | null, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type?: string | null, typeString?: string | null, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null };

export type LocationQueryVariables = Exact<{
  fareCode: Scalars['String']['input'];
  groupProfile?: InputMaybe<Scalars['Int']['input']>;
  serviceArea?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LocationQuery = { __typename?: 'Query', location?: { __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code?: string | null, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName?: string | null, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name?: string | null, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type?: string | null, typeString?: string | null, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null } | null };

export type LocationListQueryVariables = Exact<{
  charterProfile?: InputMaybe<Scalars['Int']['input']>;
  groupProfile?: InputMaybe<Scalars['Int']['input']>;
  locationType: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  serviceArea?: InputMaybe<Scalars['Int']['input']>;
  userProfile?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LocationListQuery = { __typename?: 'Query', locationList: { __typename?: 'LocationList', pages: number, totalItems: number, locations: Array<{ __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code?: string | null, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName?: string | null, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name?: string | null, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type?: string | null, typeString?: string | null, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null }> } };

export type LocationsForAutocompleteQueryVariables = Exact<{
  groupProfile?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  serviceArea?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LocationsForAutocompleteQuery = { __typename?: 'Query', locationsForAutocomplete: Array<{ __typename?: 'Location', id: string, displayAddress?: string | null, displayName?: string | null, code?: string | null, type?: string | null, typeString?: string | null }> };

export type LocationsForAutocompleteUniversalQueryVariables = Exact<{
  groupProfile?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LocationsForAutocompleteUniversalQuery = { __typename?: 'Query', locationsForAutocomplete: Array<{ __typename?: 'Location', id: string, displayAddress?: string | null, displayName?: string | null, code?: string | null, city?: string | null, fullState?: string | null, metadata: string, serviceAreas: Array<number>, state?: string | null, string?: string | null, type?: string | null, typeString?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null }> };

export type LoginProfileMutationVariables = Exact<{
  id: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
}>;


export type LoginProfileMutation = { __typename?: 'Mutation', loginProfile?: { __typename?: 'LoginProfilePayload', error?: string | null, attachedGroup?: number | null, id?: number | null, success?: boolean | null, type?: string | null } | null };

export type LogoutProfileMutationVariables = Exact<{
  type: Scalars['String']['input'];
}>;


export type LogoutProfileMutation = { __typename?: 'Mutation', logoutProfile?: { __typename?: 'LogoutProfilePayload', error?: string | null, success?: boolean | null } | null };

export type PassengerFragment = { __typename?: 'Passenger', id: string, fieldName: string, label: string, maxPassengers: number, popup?: string | null, raw?: string | null };

export type PassengerTypesQueryVariables = Exact<{
  groupProfile?: InputMaybe<Scalars['Int']['input']>;
  passengerTypesAlias?: InputMaybe<Scalars['String']['input']>;
  serviceArea?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PassengerTypesQuery = { __typename?: 'Query', passengerTypes: Array<{ __typename?: 'Passenger', id: string, fieldName: string, label: string, maxPassengers: number, popup?: string | null, raw?: string | null }> };

export type ProcessPidMutationVariables = Exact<{
  pid: Scalars['String']['input'];
}>;


export type ProcessPidMutation = { __typename?: 'Mutation', processPid?: { __typename?: 'ProcessPid', mode?: string | null, charter?: number | null, user?: number | null, group?: number | null, sales?: number | null } | null };

export type ProfileAddMutationVariables = Exact<{
  email: Scalars['String']['input'];
  linkedReservations?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  telephone?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProfileAddMutation = { __typename?: 'Mutation', profileAdd?: { __typename?: 'ProfileAddPayload', errorMessage?: string | null, profileId?: number | null, success: boolean } | null };

export type ProfilePreferredLocationsQueryVariables = Exact<{
  userProfile?: InputMaybe<Scalars['Int']['input']>;
  groupProfile?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProfilePreferredLocationsQuery = { __typename?: 'Query', profilePreferredLocations: Array<{ __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code?: string | null, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName?: string | null, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name?: string | null, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type?: string | null, typeString?: string | null, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null }> };

export type ProfileReservationsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  dateRange?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProfileReservationsQuery = { __typename?: 'Query', profileReservations: Array<{ __typename?: 'Reservation', bagCount: number, cancellable: boolean, cancelled: boolean, compId?: number | null, editable: boolean, epicPassId?: string | null, epicPassValidated?: boolean | null, flags?: string | null, id: string, itineraryId?: string | null, jobNumber?: string | null, jobType?: number | null, open?: boolean | null, resId?: string | null, resIdInternal?: number | null, returnTripStatus?: string | null, serviceArea?: number | null, sourceType?: number | null, totalOriginal?: number | null, userGratuityOverride?: boolean | null, userGratuityPercentage?: number | null, contactInfo: { __typename?: 'ResContact', altPhone?: string | null, email?: string | null, name?: string | null, phone?: string | null }, dropoff: { __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code?: string | null, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName?: string | null, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name?: string | null, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type?: string | null, typeString?: string | null, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null }, flight?: { __typename?: 'ResFlight', airline?: string | null, flightCity?: string | null, flightNumber?: string | null, flightTime?: string | null, flightType?: string | null, terminal?: string | null } | null, options?: { __typename?: 'ResOptions', allowOpenResConversion: boolean } | null, other?: { __typename?: 'ResOther', idNumber?: string | null, marketingCode?: string | null, marketingCode2?: string | null, marketingCode3?: string | null, specialInstructions?: string | null, specialInstructions2?: string | null, madeBy?: { __typename?: 'ResMadeBy', email?: string | null, name?: string | null, phoneNumber?: string | null } | null } | null, passengers: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }>, payment?: { __typename?: 'ResPayment', chargeTo?: string | null, shopperReference?: string | null, typeId?: string | null, variance?: number | null, creditCard?: { __typename?: 'TokenizedCreditCard', expiration?: string | null, name?: string | null, numberLast4?: string | null, postalCode?: string | null, token?: string | null, typeCode?: string | null } | null } | null, pickup: { __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code?: string | null, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName?: string | null, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name?: string | null, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type?: string | null, typeString?: string | null, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null }, profiles?: { __typename?: 'ResProfiles', charter?: number | null, coupon?: number | null, couponWeb?: string | null, group?: number | null, sales?: number | null, user?: number | null } | null, service?: { __typename?: 'Service', perPassengerRates?: string | null, bagCountMax?: number | null, defaultBaggage?: number | null, defaultServiceGratuityPercent?: number | null, fareCalculationMode?: string | null, fareDisplay?: number | null, fareDisplayMode?: FareDisplayMode | null, gratuityFare?: number | null, hideBaggage?: boolean | null, hideFareMode?: HideFareMode | null, hideFlightInfo?: boolean | null, hideMaximumPassengers?: boolean | null, hideRoundtrip?: boolean | null, hideSubfareMode?: HideSubfareMode | null, image?: string | null, includedGratuity?: number | null, items: Array<string>, madeByMode?: MadeByMode | null, maxPassengers: number, mileage?: number | null, name?: string | null, passengerTypesAlias?: string | null, processorId?: number | null, raw?: string | null, roundtripPricingMode?: RoundTripPricingMode | null, serviceExtrasAlias?: string | null, serviceTimeNotes?: string | null, serviceType: number, showExtraStops?: boolean | null, showGratuity?: boolean | null, totalGratuity?: number | null, travelTime?: number | null, fareComponents: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }>, pickupExtras?: Array<{ __typename?: 'PickupExtra', charge?: number | null, default?: boolean | null, name?: string | null, value?: string | null }> | null, selectedPickupExtra?: { __typename?: 'PickupExtra', default?: boolean | null, charge?: number | null, name?: string | null, value?: string | null } | null, selectedTime?: { __typename?: 'ServiceTime', id: string, dropoffTime?: string | null, pickupTime?: string | null } | null, times: Array<{ __typename?: 'ServiceTime', id: string, availableSeats?: number | null, dropoffTime?: string | null, hasAdditionalCharges: boolean, offpeak: boolean, offPeakCharge?: number | null, pickupTime?: string | null, raw?: string | null, shortNoticeCharge?: number | null, showAvailablePassengers: boolean, skedRun?: number | null, suggested: boolean, unavailable: boolean, yieldAdjustment?: number | null, fareComponents: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }> }>, webSubfares: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }> } | null, serviceExtras: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }>, stops?: Array<{ __typename?: 'ResStop', name?: string | null, comments?: string | null, location?: { __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code?: string | null, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName?: string | null, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name?: string | null, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type?: string | null, typeString?: string | null, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null } | null }> | null }> };

export type PudFragmentFragment = { __typename?: 'Pud', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code?: string | null, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName?: string | null, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name?: string | null, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type?: string | null, typeString?: string | null, zip?: string | null, pudName?: string | null, email?: string | null, telephone2?: string | null, faxNumber?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null, creditCard?: { __typename?: 'TokenizedCreditCard', id?: string | null, expiration?: string | null, name?: string | null, numberLast4?: string | null, postalCode?: string | null, token?: string | null, typeCode?: string | null } | null };

export type PudPeopleQueryVariables = Exact<{
  userProfile?: InputMaybe<Scalars['Int']['input']>;
  groupProfile?: InputMaybe<Scalars['Int']['input']>;
  serviceArea?: InputMaybe<Scalars['Int']['input']>;
  showToken?: InputMaybe<Scalars['Boolean']['input']>;
  tokenGroup?: InputMaybe<Scalars['String']['input']>;
}>;


export type PudPeopleQuery = { __typename?: 'Query', pudPeople: Array<{ __typename?: 'PudPerson', id: string, name?: string | null, address?: string | null }>, config: { __typename?: 'Config', pudsAsPeople?: boolean | null }, content: { __typename?: 'Content', id: string, bePudPersonLabel: string, beSelectNoOptions: string } };

export type ReferralLinkFragment = { __typename?: 'ReferralLink', id: string, priority: number, enabled: boolean, alias: string, title?: string | null, description?: string | null, popup?: string | null, imageUrl?: string | null, linkText?: string | null, linkUrl?: string | null, boldText?: string | null, webItems?: Array<string> | null };

export type ReferralLinksQueryVariables = Exact<{
  flightCity?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReferralLinksQuery = { __typename?: 'Query', referralLinks: Array<{ __typename?: 'ReferralLink', id: string, priority: number, enabled: boolean, alias: string, title?: string | null, description?: string | null, popup?: string | null, imageUrl?: string | null, linkText?: string | null, linkUrl?: string | null, boldText?: string | null, webItems?: Array<string> | null }> };

export type RepriceServiceMutationVariables = Exact<{
  recalcEntireFare?: InputMaybe<Scalars['Boolean']['input']>;
  res: ServicesResType;
  sourceType: Scalars['Int']['input'];
}>;


export type RepriceServiceMutation = { __typename?: 'Mutation', repriceService?: { __typename?: 'RepriceServicePayload', error?: boolean | null, reprice?: { __typename?: 'Reprice', bagCountMax?: number | null, fareDisplay?: number | null, gratuityFare?: number | null, fareComponents: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }>, payments?: { __typename?: 'ServicePayment', totalPaymentAmount?: number | null, amountDue?: number | null, items?: Array<{ __typename?: 'ServicePaymentItem', paymentAmount?: number | null, points?: number | null, programId?: number | null, type?: string | null }> | null } | null, times?: Array<{ __typename?: 'ServiceTime', id: string, availableSeats?: number | null, dropoffTime?: string | null, hasAdditionalCharges: boolean, offpeak: boolean, offPeakCharge?: number | null, pickupTime?: string | null, raw?: string | null, shortNoticeCharge?: number | null, showAvailablePassengers: boolean, skedRun?: number | null, suggested: boolean, unavailable: boolean, yieldAdjustment?: number | null, fareComponents: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }> }> | null, webSubfares?: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }> | null } | null } | null };

export type ResFlightFragment = { __typename?: 'ResFlight', airline?: string | null, flightCity?: string | null, flightNumber?: string | null, flightTime?: string | null, flightType?: string | null, terminal?: string | null };

export type ReservationFragmentFragment = { __typename?: 'Reservation', bagCount: number, cancellable: boolean, cancelled: boolean, compId?: number | null, editable: boolean, epicPassId?: string | null, epicPassValidated?: boolean | null, flags?: string | null, id: string, itineraryId?: string | null, jobNumber?: string | null, jobType?: number | null, open?: boolean | null, resId?: string | null, resIdInternal?: number | null, returnTripStatus?: string | null, serviceArea?: number | null, sourceType?: number | null, totalOriginal?: number | null, userGratuityOverride?: boolean | null, userGratuityPercentage?: number | null, contactInfo: { __typename?: 'ResContact', altPhone?: string | null, email?: string | null, name?: string | null, phone?: string | null }, dropoff: { __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code?: string | null, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName?: string | null, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name?: string | null, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type?: string | null, typeString?: string | null, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null }, flight?: { __typename?: 'ResFlight', airline?: string | null, flightCity?: string | null, flightNumber?: string | null, flightTime?: string | null, flightType?: string | null, terminal?: string | null } | null, options?: { __typename?: 'ResOptions', allowOpenResConversion: boolean } | null, other?: { __typename?: 'ResOther', idNumber?: string | null, marketingCode?: string | null, marketingCode2?: string | null, marketingCode3?: string | null, specialInstructions?: string | null, specialInstructions2?: string | null, madeBy?: { __typename?: 'ResMadeBy', email?: string | null, name?: string | null, phoneNumber?: string | null } | null } | null, passengers: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }>, payment?: { __typename?: 'ResPayment', chargeTo?: string | null, shopperReference?: string | null, typeId?: string | null, variance?: number | null, creditCard?: { __typename?: 'TokenizedCreditCard', expiration?: string | null, name?: string | null, numberLast4?: string | null, postalCode?: string | null, token?: string | null, typeCode?: string | null } | null } | null, pickup: { __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code?: string | null, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName?: string | null, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name?: string | null, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type?: string | null, typeString?: string | null, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null }, profiles?: { __typename?: 'ResProfiles', charter?: number | null, coupon?: number | null, couponWeb?: string | null, group?: number | null, sales?: number | null, user?: number | null } | null, service?: { __typename?: 'Service', perPassengerRates?: string | null, bagCountMax?: number | null, defaultBaggage?: number | null, defaultServiceGratuityPercent?: number | null, fareCalculationMode?: string | null, fareDisplay?: number | null, fareDisplayMode?: FareDisplayMode | null, gratuityFare?: number | null, hideBaggage?: boolean | null, hideFareMode?: HideFareMode | null, hideFlightInfo?: boolean | null, hideMaximumPassengers?: boolean | null, hideRoundtrip?: boolean | null, hideSubfareMode?: HideSubfareMode | null, image?: string | null, includedGratuity?: number | null, items: Array<string>, madeByMode?: MadeByMode | null, maxPassengers: number, mileage?: number | null, name?: string | null, passengerTypesAlias?: string | null, processorId?: number | null, raw?: string | null, roundtripPricingMode?: RoundTripPricingMode | null, serviceExtrasAlias?: string | null, serviceTimeNotes?: string | null, serviceType: number, showExtraStops?: boolean | null, showGratuity?: boolean | null, totalGratuity?: number | null, travelTime?: number | null, fareComponents: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }>, pickupExtras?: Array<{ __typename?: 'PickupExtra', charge?: number | null, default?: boolean | null, name?: string | null, value?: string | null }> | null, selectedPickupExtra?: { __typename?: 'PickupExtra', default?: boolean | null, charge?: number | null, name?: string | null, value?: string | null } | null, selectedTime?: { __typename?: 'ServiceTime', id: string, dropoffTime?: string | null, pickupTime?: string | null } | null, times: Array<{ __typename?: 'ServiceTime', id: string, availableSeats?: number | null, dropoffTime?: string | null, hasAdditionalCharges: boolean, offpeak: boolean, offPeakCharge?: number | null, pickupTime?: string | null, raw?: string | null, shortNoticeCharge?: number | null, showAvailablePassengers: boolean, skedRun?: number | null, suggested: boolean, unavailable: boolean, yieldAdjustment?: number | null, fareComponents: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }> }>, webSubfares: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }> } | null, serviceExtras: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }>, stops?: Array<{ __typename?: 'ResStop', name?: string | null, comments?: string | null, location?: { __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code?: string | null, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName?: string | null, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name?: string | null, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type?: string | null, typeString?: string | null, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null } | null }> | null };

export type ReservationQueryVariables = Exact<{
  pid?: InputMaybe<Scalars['String']['input']>;
  resId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ReservationQuery = { __typename?: 'Query', reservation?: { __typename?: 'Reservation', bagCount: number, cancellable: boolean, cancelled: boolean, compId?: number | null, editable: boolean, epicPassId?: string | null, epicPassValidated?: boolean | null, flags?: string | null, id: string, itineraryId?: string | null, jobNumber?: string | null, jobType?: number | null, open?: boolean | null, resId?: string | null, resIdInternal?: number | null, returnTripStatus?: string | null, serviceArea?: number | null, sourceType?: number | null, totalOriginal?: number | null, userGratuityOverride?: boolean | null, userGratuityPercentage?: number | null, contactInfo: { __typename?: 'ResContact', altPhone?: string | null, email?: string | null, name?: string | null, phone?: string | null }, dropoff: { __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code?: string | null, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName?: string | null, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name?: string | null, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type?: string | null, typeString?: string | null, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null }, flight?: { __typename?: 'ResFlight', airline?: string | null, flightCity?: string | null, flightNumber?: string | null, flightTime?: string | null, flightType?: string | null, terminal?: string | null } | null, options?: { __typename?: 'ResOptions', allowOpenResConversion: boolean } | null, other?: { __typename?: 'ResOther', idNumber?: string | null, marketingCode?: string | null, marketingCode2?: string | null, marketingCode3?: string | null, specialInstructions?: string | null, specialInstructions2?: string | null, madeBy?: { __typename?: 'ResMadeBy', email?: string | null, name?: string | null, phoneNumber?: string | null } | null } | null, passengers: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }>, payment?: { __typename?: 'ResPayment', chargeTo?: string | null, shopperReference?: string | null, typeId?: string | null, variance?: number | null, creditCard?: { __typename?: 'TokenizedCreditCard', expiration?: string | null, name?: string | null, numberLast4?: string | null, postalCode?: string | null, token?: string | null, typeCode?: string | null } | null } | null, pickup: { __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code?: string | null, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName?: string | null, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name?: string | null, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type?: string | null, typeString?: string | null, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null }, profiles?: { __typename?: 'ResProfiles', charter?: number | null, coupon?: number | null, couponWeb?: string | null, group?: number | null, sales?: number | null, user?: number | null } | null, service?: { __typename?: 'Service', perPassengerRates?: string | null, bagCountMax?: number | null, defaultBaggage?: number | null, defaultServiceGratuityPercent?: number | null, fareCalculationMode?: string | null, fareDisplay?: number | null, fareDisplayMode?: FareDisplayMode | null, gratuityFare?: number | null, hideBaggage?: boolean | null, hideFareMode?: HideFareMode | null, hideFlightInfo?: boolean | null, hideMaximumPassengers?: boolean | null, hideRoundtrip?: boolean | null, hideSubfareMode?: HideSubfareMode | null, image?: string | null, includedGratuity?: number | null, items: Array<string>, madeByMode?: MadeByMode | null, maxPassengers: number, mileage?: number | null, name?: string | null, passengerTypesAlias?: string | null, processorId?: number | null, raw?: string | null, roundtripPricingMode?: RoundTripPricingMode | null, serviceExtrasAlias?: string | null, serviceTimeNotes?: string | null, serviceType: number, showExtraStops?: boolean | null, showGratuity?: boolean | null, totalGratuity?: number | null, travelTime?: number | null, fareComponents: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }>, pickupExtras?: Array<{ __typename?: 'PickupExtra', charge?: number | null, default?: boolean | null, name?: string | null, value?: string | null }> | null, selectedPickupExtra?: { __typename?: 'PickupExtra', default?: boolean | null, charge?: number | null, name?: string | null, value?: string | null } | null, selectedTime?: { __typename?: 'ServiceTime', id: string, dropoffTime?: string | null, pickupTime?: string | null } | null, times: Array<{ __typename?: 'ServiceTime', id: string, availableSeats?: number | null, dropoffTime?: string | null, hasAdditionalCharges: boolean, offpeak: boolean, offPeakCharge?: number | null, pickupTime?: string | null, raw?: string | null, shortNoticeCharge?: number | null, showAvailablePassengers: boolean, skedRun?: number | null, suggested: boolean, unavailable: boolean, yieldAdjustment?: number | null, fareComponents: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }> }>, webSubfares: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }> } | null, serviceExtras: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }>, stops?: Array<{ __typename?: 'ResStop', name?: string | null, comments?: string | null, location?: { __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code?: string | null, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName?: string | null, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name?: string | null, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type?: string | null, typeString?: string | null, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null } | null }> | null } | null };

export type SavePasswordMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type SavePasswordMutation = { __typename?: 'Mutation', savePassword?: { __typename?: 'SavePasswordPayload', errorMessage?: string | null, success: boolean } | null };

export type SavePasswordWithPidMutationVariables = Exact<{
  password: Scalars['String']['input'];
  pid: Scalars['String']['input'];
}>;


export type SavePasswordWithPidMutation = { __typename?: 'Mutation', savePasswordWithPid?: { __typename?: 'SavePasswordWithPidPayload', errorMessage?: string | null, success: boolean } | null };

export type SendPasswordResetMutationVariables = Exact<{
  username: Scalars['String']['input'];
  resetPasswordUrl: Scalars['String']['input'];
}>;


export type SendPasswordResetMutation = { __typename?: 'Mutation', sendPasswordReset?: { __typename?: 'SendPasswordResetPayload', errorType?: string | null, success: boolean } | null };

export type ServiceFragmentFragment = { __typename?: 'Service', perPassengerRates?: string | null, bagCountMax?: number | null, defaultBaggage?: number | null, defaultServiceGratuityPercent?: number | null, fareCalculationMode?: string | null, fareDisplay?: number | null, fareDisplayMode?: FareDisplayMode | null, gratuityFare?: number | null, hideBaggage?: boolean | null, hideFareMode?: HideFareMode | null, hideFlightInfo?: boolean | null, hideMaximumPassengers?: boolean | null, hideRoundtrip?: boolean | null, hideSubfareMode?: HideSubfareMode | null, image?: string | null, includedGratuity?: number | null, items: Array<string>, madeByMode?: MadeByMode | null, maxPassengers: number, mileage?: number | null, name?: string | null, passengerTypesAlias?: string | null, processorId?: number | null, raw?: string | null, roundtripPricingMode?: RoundTripPricingMode | null, serviceExtrasAlias?: string | null, serviceTimeNotes?: string | null, serviceType: number, showExtraStops?: boolean | null, showGratuity?: boolean | null, totalGratuity?: number | null, travelTime?: number | null, fareComponents: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }>, pickupExtras?: Array<{ __typename?: 'PickupExtra', charge?: number | null, default?: boolean | null, name?: string | null, value?: string | null }> | null, selectedPickupExtra?: { __typename?: 'PickupExtra', default?: boolean | null, charge?: number | null, name?: string | null, value?: string | null } | null, selectedTime?: { __typename?: 'ServiceTime', id: string, dropoffTime?: string | null, pickupTime?: string | null } | null, times: Array<{ __typename?: 'ServiceTime', id: string, availableSeats?: number | null, dropoffTime?: string | null, hasAdditionalCharges: boolean, offpeak: boolean, offPeakCharge?: number | null, pickupTime?: string | null, raw?: string | null, shortNoticeCharge?: number | null, showAvailablePassengers: boolean, skedRun?: number | null, suggested: boolean, unavailable: boolean, yieldAdjustment?: number | null, fareComponents: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }> }>, webSubfares: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }> };

export type ServiceExtraFragment = { __typename?: 'ServiceExtra', id: string, defaultToBlank?: boolean | null, defaultValue?: number | null, description?: string | null, enabled?: boolean | null, fieldName: string, fixedAmount: boolean, image?: string | null, label?: string | null, maximum?: number | null, popup?: string | null, raw?: string | null, surcharge?: number | null };

export type ExtrasQueryVariables = Exact<{
  groupProfile?: InputMaybe<Scalars['Int']['input']>;
  serviceArea?: InputMaybe<Scalars['Int']['input']>;
  serviceExtrasAlias?: InputMaybe<Scalars['String']['input']>;
}>;


export type ExtrasQuery = { __typename?: 'Query', serviceExtras: Array<{ __typename?: 'ServiceExtra', id: string, defaultToBlank?: boolean | null, defaultValue?: number | null, description?: string | null, enabled?: boolean | null, fieldName: string, fixedAmount: boolean, image?: string | null, label?: string | null, maximum?: number | null, popup?: string | null, raw?: string | null, surcharge?: number | null }> };

export type ServiceTimeFragment = { __typename?: 'ServiceTime', id: string, availableSeats?: number | null, dropoffTime?: string | null, hasAdditionalCharges: boolean, offpeak: boolean, offPeakCharge?: number | null, pickupTime?: string | null, raw?: string | null, shortNoticeCharge?: number | null, showAvailablePassengers: boolean, skedRun?: number | null, suggested: boolean, unavailable: boolean, yieldAdjustment?: number | null, fareComponents: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }> };

export type ServicesQueryVariables = Exact<{
  res: ServicesResType;
  sourceType: Scalars['Int']['input'];
}>;


export type ServicesQuery = { __typename?: 'Query', services: Array<{ __typename?: 'Service', perPassengerRates?: string | null, bagCountMax?: number | null, defaultBaggage?: number | null, defaultServiceGratuityPercent?: number | null, fareCalculationMode?: string | null, fareDisplay?: number | null, fareDisplayMode?: FareDisplayMode | null, gratuityFare?: number | null, hideBaggage?: boolean | null, hideFareMode?: HideFareMode | null, hideFlightInfo?: boolean | null, hideMaximumPassengers?: boolean | null, hideRoundtrip?: boolean | null, hideSubfareMode?: HideSubfareMode | null, image?: string | null, includedGratuity?: number | null, items: Array<string>, madeByMode?: MadeByMode | null, maxPassengers: number, mileage?: number | null, name?: string | null, passengerTypesAlias?: string | null, processorId?: number | null, raw?: string | null, roundtripPricingMode?: RoundTripPricingMode | null, serviceExtrasAlias?: string | null, serviceTimeNotes?: string | null, serviceType: number, showExtraStops?: boolean | null, showGratuity?: boolean | null, totalGratuity?: number | null, travelTime?: number | null, fareComponents: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }>, pickupExtras?: Array<{ __typename?: 'PickupExtra', charge?: number | null, default?: boolean | null, name?: string | null, value?: string | null }> | null, selectedPickupExtra?: { __typename?: 'PickupExtra', default?: boolean | null, charge?: number | null, name?: string | null, value?: string | null } | null, selectedTime?: { __typename?: 'ServiceTime', id: string, dropoffTime?: string | null, pickupTime?: string | null } | null, times: Array<{ __typename?: 'ServiceTime', id: string, availableSeats?: number | null, dropoffTime?: string | null, hasAdditionalCharges: boolean, offpeak: boolean, offPeakCharge?: number | null, pickupTime?: string | null, raw?: string | null, shortNoticeCharge?: number | null, showAvailablePassengers: boolean, skedRun?: number | null, suggested: boolean, unavailable: boolean, yieldAdjustment?: number | null, fareComponents: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }> }>, webSubfares: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }> }> };

export type SpecialInfoQueryVariables = Exact<{
  groupProfile?: InputMaybe<Scalars['Int']['input']>;
  siAlias?: InputMaybe<Scalars['String']['input']>;
  userProfile?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SpecialInfoQuery = { __typename?: 'Query', specialInfo: Array<{ __typename?: 'Field', id: string, defaultValue?: string | null, description?: string | null, fieldName: string, fieldType: FieldType, label: string, maxLength: number, minLength: number, raw: string, required: boolean }> };

export type TokenFragment = { __typename?: 'Token', id: string, name: string, description?: string | null, defaultToken: boolean, value?: string | null };

export type TokenizeMutationVariables = Exact<{
  ccNumber: Scalars['String']['input'];
  ccExpiration: Scalars['String']['input'];
  ccName?: InputMaybe<Scalars['String']['input']>;
  ccPostalCode?: InputMaybe<Scalars['String']['input']>;
  ccAddress?: InputMaybe<Scalars['String']['input']>;
}>;


export type TokenizeMutation = { __typename?: 'Mutation', tokenize?: { __typename?: 'TokenizePayload', error?: string | null, ccToken?: string | null, ccLast4?: string | null, ccExpiration?: string | null } | null };

export type TokensQueryVariables = Exact<{ [key: string]: never; }>;


export type TokensQuery = { __typename?: 'Query', tokens: Array<{ __typename?: 'Token', id: string, name: string, description?: string | null, defaultToken: boolean, value?: string | null }> };

export type ProfileFragmentFragment = { __typename?: 'Profile', linkedGroupName?: string | null, contactInfo?: { __typename?: 'ProfileContact', altPhone?: string | null, email?: string | null, name?: string | null, phone?: string | null } | null, creditCards?: Array<{ __typename?: 'TokenizedCreditCard', id?: string | null, expiration?: string | null, localId?: string | null, name?: string | null, numberLast4?: string | null, refId?: string | null, token?: string | null, tokenType?: string | null, typeCode?: string | null, uniqueId?: string | null }> | null, locations?: Array<{ __typename?: 'Pud', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code?: string | null, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName?: string | null, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name?: string | null, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type?: string | null, typeString?: string | null, zip?: string | null, pudName?: string | null, email?: string | null, telephone2?: string | null, faxNumber?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null, creditCard?: { __typename?: 'TokenizedCreditCard', id?: string | null, expiration?: string | null, name?: string | null, numberLast4?: string | null, postalCode?: string | null, token?: string | null, typeCode?: string | null } | null }> | null };

export type UserProfileQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type UserProfileQuery = { __typename?: 'Query', userProfile?: { __typename?: 'Profile', linkedGroupName?: string | null, contactInfo?: { __typename?: 'ProfileContact', altPhone?: string | null, email?: string | null, name?: string | null, phone?: string | null } | null, creditCards?: Array<{ __typename?: 'TokenizedCreditCard', id?: string | null, expiration?: string | null, localId?: string | null, name?: string | null, numberLast4?: string | null, refId?: string | null, token?: string | null, tokenType?: string | null, typeCode?: string | null, uniqueId?: string | null }> | null, locations?: Array<{ __typename?: 'Pud', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code?: string | null, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName?: string | null, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name?: string | null, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type?: string | null, typeString?: string | null, zip?: string | null, pudName?: string | null, email?: string | null, telephone2?: string | null, faxNumber?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null, creditCard?: { __typename?: 'TokenizedCreditCard', id?: string | null, expiration?: string | null, name?: string | null, numberLast4?: string | null, postalCode?: string | null, token?: string | null, typeCode?: string | null } | null }> | null } | null };

export type UserProfileAddCcMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  ccNumber: Scalars['String']['input'];
  ccExpiration: Scalars['String']['input'];
  ccName: Scalars['String']['input'];
  ccPostalCode?: InputMaybe<Scalars['String']['input']>;
  ccAddress?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserProfileAddCcMutation = { __typename?: 'Mutation', userProfileAddCc?: { __typename?: 'UserProfileAddCcPayload', success: boolean, errorMessage?: string | null } | null };

export type UserProfileAddPudMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  location: ProfilePud;
}>;


export type UserProfileAddPudMutation = { __typename?: 'Mutation', userProfileAddPud?: { __typename?: 'UserProfileAddPudPayload', success: boolean, errorMessage?: string | null } | null };

export type UserProfileAddValpayCcMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  encryptedCardNumber: Scalars['String']['input'];
  encryptedExpiryMonth: Scalars['String']['input'];
  encryptedExpiryYear: Scalars['String']['input'];
  encryptedSecurityCode: Scalars['String']['input'];
  ccCardHolderName?: InputMaybe<Scalars['String']['input']>;
  ccPostalCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserProfileAddValpayCcMutation = { __typename?: 'Mutation', userProfileAddValpayCc?: { __typename?: 'UserProfileAddValpayCcPayload', success: boolean, errorMessage?: string | null } | null };

export type UserProfileDeleteCcMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  ccId?: InputMaybe<Scalars['String']['input']>;
  ccRefId?: InputMaybe<Scalars['String']['input']>;
  ccToken?: InputMaybe<Scalars['String']['input']>;
  ccLast4?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserProfileDeleteCcMutation = { __typename?: 'Mutation', userProfileDeleteCc?: { __typename?: 'UserProfileDeleteCcPayload', success: boolean, errorMessage?: string | null } | null };

export type UserProfileDeletePudMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  locationId: Scalars['Int']['input'];
}>;


export type UserProfileDeletePudMutation = { __typename?: 'Mutation', userProfileDeletePud?: { __typename?: 'UserProfileDeletePudPayload', success: boolean, errorMessage?: string | null } | null };

export type UserProfileDeletePudCcMutationVariables = Exact<{
  profileId: Scalars['Int']['input'];
  pudId: Scalars['Int']['input'];
  ccId: Scalars['Int']['input'];
}>;


export type UserProfileDeletePudCcMutation = { __typename?: 'Mutation', userProfileDeletePudCc?: { __typename?: 'UserProfileDeletePudCcPayload', success: boolean, errorMessage?: string | null } | null };

export type UserProfileExistsQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type UserProfileExistsQuery = { __typename?: 'Query', userProfileExists: { __typename?: 'UserProfileExists', id: string, exists?: boolean | null, hasPassword?: boolean | null, profileId?: number | null } };

export type UserProfileLinkGroupMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  clientid?: InputMaybe<Scalars['String']['input']>;
  data1?: InputMaybe<Scalars['String']['input']>;
  data2?: InputMaybe<Scalars['String']['input']>;
  groupid?: InputMaybe<Scalars['String']['input']>;
  webid?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserProfileLinkGroupMutation = { __typename?: 'Mutation', userProfileLinkGroup?: { __typename?: 'UserProfileLinkGroupPayload', success: boolean } | null };

export type UserProfileUpdateMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  updatedFields: ProfileUpdateProfileType;
}>;


export type UserProfileUpdateMutation = { __typename?: 'Mutation', userProfileUpdate?: { __typename?: 'UserProfileUpdatePayload', success: boolean } | null };

export type UserProfileUpdatePudMutationVariables = Exact<{
  profileId: Scalars['Int']['input'];
  location?: InputMaybe<ProfilePud>;
}>;


export type UserProfileUpdatePudMutation = { __typename?: 'Mutation', userProfileUpdatePud?: { __typename?: 'UserProfileUpdatePudPayload', success: boolean, errorMessage?: string | null } | null };

export type ValpayConfigQueryVariables = Exact<{
  processorId?: InputMaybe<Scalars['Int']['input']>;
  shopperReference?: InputMaybe<Scalars['String']['input']>;
}>;


export type ValpayConfigQuery = { __typename?: 'Query', valpayConfig: { __typename?: 'ValpayConfig', id?: string | null, clientKey?: string | null, enabled: boolean, environment?: string | null, error?: string | null, paymentMethods?: string | null } };

export type VerifyResMutationVariables = Exact<{
  resId: Scalars['String']['input'];
  validationMode: Scalars['String']['input'];
  validationValue: Scalars['String']['input'];
}>;


export type VerifyResMutation = { __typename?: 'Mutation', verifyRes?: { __typename?: 'VerifyResPayload', error?: boolean | null, resId?: number | null, success?: boolean | null } | null };

export const AirlineFragmentDoc = gql`
    fragment Airline on Airline {
  id
  name
  domesticArrivalTerminal
  domesticDepartureTerminal
  intlArrivalTerminal
  intlDepartureTerminal
}
    `;
export const AutocompleteLocationFragmentDoc = gql`
    fragment AutocompleteLocation on Location {
  id
  displayAddress
  displayName
  code
  type
  typeString
}
    `;
export const AutocompleteLocationUniversalFragmentDoc = gql`
    fragment AutocompleteLocationUniversal on Location {
  id
  displayAddress
  displayName
  code
  city
  fullState
  latLng {
    lat
    lng
  }
  metadata
  serviceAreas
  state
  string
  type
  typeString
}
    `;
export const ColorsFragmentDoc = gql`
    fragment Colors on Colors {
  id
  primaryColor
  primaryHover
  primaryText
}
    `;
export const DefaultsFragmentFragmentDoc = gql`
    fragment DefaultsFragment on Defaults {
  id
  creditCards {
    id
    expiration
    localId
    name
    numberLast4
    postalCode
    refId
    token
    tokenType
    typeCode
    uniqueId
  }
  email
  faxNumber
  gratuityPercents
  marketingCode
  marketingCode2
  marketingCode3
  name
  telephone
  telephone2
  name
}
    `;
export const LocationFragmentDoc = gql`
    fragment Location on Location {
  id
  address
  addressDetails
  city
  code
  country
  county
  crossStreet
  description
  directions
  displayAddress
  displayName
  distance
  fklRequest
  fklResponse
  googlePlaceId
  icons
  latLng {
    lat
    lng
  }
  metadata
  name
  raw
  requireCrossStreet
  sector
  serviceAreas
  showAddressDetails
  showCrossStreet
  showFlightDate
  showFlightNumber
  showFlightType
  state
  string
  telephone
  transportationHub
  type
  typeString
  zip
}
    `;
export const FareKeyLookupFragmentDoc = gql`
    fragment FareKeyLookup on FareKeyLookupReturn {
  error
  errorMessage
  fklRequest
  fklResponse
  location {
    ...Location
  }
  lookupType
  nearbyLocations {
    ...Location
  }
}
    ${LocationFragmentDoc}`;
export const FixedLocationTypeFragmentDoc = gql`
    fragment FixedLocationType on FixedLocationType {
  id
  label
  locationCount
  locations {
    ...Location
  }
  type
  typeString
}
    ${LocationFragmentDoc}`;
export const FrequentRiderPointsFragmentDoc = gql`
    fragment FrequentRiderPoints on FrequentRiderPoints {
  availablePoints
  id
  programId
  totalCredits
  totalDebits
  transactions {
    comments
    debitCredit
    description
    id
    name
    points
    programId
    redemptionType
    resId
    status
    transactionDate
  }
}
    `;
export const FrequentRiderProgramFragmentFragmentDoc = gql`
    fragment FrequentRiderProgramFragment on FrequentRiderProgram {
  id
  cost
  name
  redemptionType
  description
  redemptionDuration
  redemptionDefaultDate
  redemptionMaxUsage
  raw
  sellFarePer
  sellMinQuantity
  sellMaxQuantity
  sellType
}
    `;
export const PassengerFragmentDoc = gql`
    fragment Passenger on Passenger {
  id
  fieldName
  label
  maxPassengers
  popup
  raw
}
    `;
export const ReferralLinkFragmentDoc = gql`
    fragment ReferralLink on ReferralLink {
  id
  priority
  enabled
  alias
  title
  description
  popup
  imageUrl
  linkText
  linkUrl
  boldText
  webItems
}
    `;
export const ResFlightFragmentDoc = gql`
    fragment ResFlight on ResFlight {
  airline
  flightCity
  flightNumber
  flightTime
  flightType
  terminal
}
    `;
export const ServiceTimeFragmentDoc = gql`
    fragment ServiceTime on ServiceTime {
  id
  availableSeats
  dropoffTime
  fareComponents {
    field
    value
  }
  hasAdditionalCharges
  offpeak
  offPeakCharge
  pickupTime
  raw
  shortNoticeCharge
  showAvailablePassengers
  skedRun
  suggested
  unavailable
  yieldAdjustment
}
    `;
export const ServiceFragmentFragmentDoc = gql`
    fragment ServiceFragment on Service {
  perPassengerRates
  bagCountMax
  defaultBaggage
  defaultServiceGratuityPercent
  fareCalculationMode
  fareComponents {
    field
    value
  }
  fareDisplay
  fareDisplayMode
  gratuityFare
  hideBaggage
  hideFareMode
  hideFlightInfo
  hideMaximumPassengers
  hideRoundtrip
  hideSubfareMode
  image
  includedGratuity
  items
  madeByMode
  maxPassengers
  mileage
  name
  passengerTypesAlias
  pickupExtras {
    charge
    default
    name
    value
  }
  processorId
  raw
  roundtripPricingMode
  selectedPickupExtra {
    default
    charge
    name
    value
  }
  selectedTime {
    id
    dropoffTime
    pickupTime
  }
  serviceExtrasAlias
  serviceTimeNotes
  serviceType
  showExtraStops
  showGratuity
  times {
    ...ServiceTime
  }
  totalGratuity
  travelTime
  webSubfares {
    field
    value
  }
}
    ${ServiceTimeFragmentDoc}`;
export const ReservationFragmentFragmentDoc = gql`
    fragment ReservationFragment on Reservation {
  bagCount
  cancellable
  cancelled
  compId
  contactInfo {
    altPhone
    email
    name
    phone
  }
  dropoff {
    ...Location
  }
  editable
  epicPassId
  epicPassValidated
  flags
  flight {
    ...ResFlight
  }
  id
  itineraryId
  jobNumber
  jobType
  open
  options {
    allowOpenResConversion
  }
  other {
    idNumber
    madeBy {
      email
      name
      phoneNumber
    }
    marketingCode
    marketingCode2
    marketingCode3
    specialInstructions
    specialInstructions2
  }
  passengers {
    field
    value
  }
  payment {
    chargeTo
    creditCard {
      expiration
      name
      numberLast4
      postalCode
      token
      typeCode
    }
    shopperReference
    typeId
    variance
  }
  pickup {
    ...Location
  }
  profiles {
    charter
    coupon
    couponWeb
    group
    sales
    user
  }
  resId
  resIdInternal
  returnTripStatus
  service {
    ...ServiceFragment
  }
  serviceArea
  serviceExtras {
    field
    value
  }
  stops {
    location {
      ...Location
    }
    name
    comments
  }
  sourceType
  totalOriginal
  userGratuityOverride
  userGratuityPercentage
}
    ${LocationFragmentDoc}
${ResFlightFragmentDoc}
${ServiceFragmentFragmentDoc}`;
export const ServiceExtraFragmentDoc = gql`
    fragment ServiceExtra on ServiceExtra {
  id
  defaultToBlank
  defaultValue
  description
  enabled
  fieldName
  fixedAmount
  image
  label
  maximum
  popup
  raw
  surcharge
}
    `;
export const TokenFragmentDoc = gql`
    fragment Token on Token {
  id
  name
  description
  defaultToken
  value
}
    `;
export const PudFragmentFragmentDoc = gql`
    fragment PudFragment on Pud {
  id
  address
  addressDetails
  city
  code
  country
  county
  crossStreet
  description
  directions
  displayAddress
  displayName
  distance
  fklRequest
  fklResponse
  googlePlaceId
  icons
  latLng {
    lat
    lng
  }
  metadata
  name
  raw
  requireCrossStreet
  sector
  serviceAreas
  showAddressDetails
  showCrossStreet
  showFlightDate
  showFlightNumber
  showFlightType
  state
  string
  telephone
  transportationHub
  type
  typeString
  zip
  pudName
  email
  telephone2
  faxNumber
  creditCard {
    id
    expiration
    name
    numberLast4
    postalCode
    token
    typeCode
  }
}
    `;
export const ProfileFragmentFragmentDoc = gql`
    fragment ProfileFragment on Profile {
  contactInfo {
    altPhone
    email
    name
    phone
  }
  creditCards {
    id
    expiration
    localId
    name
    numberLast4
    refId
    token
    tokenType
    typeCode
    uniqueId
  }
  linkedGroupName
  locations {
    ...PudFragment
  }
}
    ${PudFragmentFragmentDoc}`;
export const AirlinesDocument = gql`
    query airlines($airportCode: String!, $groupProfile: Int, $serviceArea: Int, $showToken: Boolean, $tokenGroup: String) {
  airlines(airportCode: $airportCode, serviceArea: $serviceArea) {
    ...Airline
  }
  content(
    groupProfile: $groupProfile
    serviceArea: $serviceArea
    showToken: $showToken
    tokenGroup: $tokenGroup
  ) {
    id
    beErrFieldRequired
    beErrAirline
    beAirlineLabel
    beSelectNoOptions
  }
}
    ${AirlineFragmentDoc}`;

/**
 * __useAirlinesQuery__
 *
 * To run a query within a React component, call `useAirlinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAirlinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAirlinesQuery({
 *   variables: {
 *      airportCode: // value for 'airportCode'
 *      groupProfile: // value for 'groupProfile'
 *      serviceArea: // value for 'serviceArea'
 *      showToken: // value for 'showToken'
 *      tokenGroup: // value for 'tokenGroup'
 *   },
 * });
 */
export function useAirlinesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AirlinesQuery, AirlinesQueryVariables> & ({ variables: AirlinesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AirlinesQuery, AirlinesQueryVariables>(AirlinesDocument, options);
      }
export function useAirlinesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AirlinesQuery, AirlinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AirlinesQuery, AirlinesQueryVariables>(AirlinesDocument, options);
        }
export function useAirlinesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AirlinesQuery, AirlinesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AirlinesQuery, AirlinesQueryVariables>(AirlinesDocument, options);
        }
export type AirlinesQueryHookResult = ReturnType<typeof useAirlinesQuery>;
export type AirlinesLazyQueryHookResult = ReturnType<typeof useAirlinesLazyQuery>;
export type AirlinesSuspenseQueryHookResult = ReturnType<typeof useAirlinesSuspenseQuery>;
export type AirlinesQueryResult = Apollo.QueryResult<AirlinesQuery, AirlinesQueryVariables>;
export const BookDocument = gql`
    mutation Book($booking: BookBookingType!, $sourceType: Int!) {
  book(input: {booking: $booking, sourceType: $sourceType}) {
    error
    itineraryId
    resErrors
    resIds
  }
}
    `;
export type BookMutationFn = Apollo.MutationFunction<BookMutation, BookMutationVariables>;

/**
 * __useBookMutation__
 *
 * To run a mutation, you first call `useBookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookMutation, { data, loading, error }] = useBookMutation({
 *   variables: {
 *      booking: // value for 'booking'
 *      sourceType: // value for 'sourceType'
 *   },
 * });
 */
export function useBookMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BookMutation, BookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BookMutation, BookMutationVariables>(BookDocument, options);
      }
export type BookMutationHookResult = ReturnType<typeof useBookMutation>;
export type BookMutationResult = Apollo.MutationResult<BookMutation>;
export type BookMutationOptions = Apollo.BaseMutationOptions<BookMutation, BookMutationVariables>;
export const CancelResDocument = gql`
    mutation CancelRes($resId: Int!) {
  cancelRes(input: {resId: $resId}) {
    success
  }
}
    `;
export type CancelResMutationFn = Apollo.MutationFunction<CancelResMutation, CancelResMutationVariables>;

/**
 * __useCancelResMutation__
 *
 * To run a mutation, you first call `useCancelResMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelResMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelResMutation, { data, loading, error }] = useCancelResMutation({
 *   variables: {
 *      resId: // value for 'resId'
 *   },
 * });
 */
export function useCancelResMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelResMutation, CancelResMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelResMutation, CancelResMutationVariables>(CancelResDocument, options);
      }
export type CancelResMutationHookResult = ReturnType<typeof useCancelResMutation>;
export type CancelResMutationResult = Apollo.MutationResult<CancelResMutation>;
export type CancelResMutationOptions = Apollo.BaseMutationOptions<CancelResMutation, CancelResMutationVariables>;
export const ColorsDocument = gql`
    query colors {
  colors {
    ...Colors
  }
}
    ${ColorsFragmentDoc}`;

/**
 * __useColorsQuery__
 *
 * To run a query within a React component, call `useColorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useColorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useColorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useColorsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ColorsQuery, ColorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ColorsQuery, ColorsQueryVariables>(ColorsDocument, options);
      }
export function useColorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ColorsQuery, ColorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ColorsQuery, ColorsQueryVariables>(ColorsDocument, options);
        }
export function useColorsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ColorsQuery, ColorsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ColorsQuery, ColorsQueryVariables>(ColorsDocument, options);
        }
export type ColorsQueryHookResult = ReturnType<typeof useColorsQuery>;
export type ColorsLazyQueryHookResult = ReturnType<typeof useColorsLazyQuery>;
export type ColorsSuspenseQueryHookResult = ReturnType<typeof useColorsSuspenseQuery>;
export type ColorsQueryResult = Apollo.QueryResult<ColorsQuery, ColorsQueryVariables>;
export const ConfigDocument = gql`
    query config {
  config {
    error
    currency
    defaultServiceArea
    googleAnalyticsId
    googleApiKey
    gtmId
    requireLoginForBooking
  }
}
    `;

/**
 * __useConfigQuery__
 *
 * To run a query within a React component, call `useConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useConfigQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ConfigQuery, ConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConfigQuery, ConfigQueryVariables>(ConfigDocument, options);
      }
export function useConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConfigQuery, ConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConfigQuery, ConfigQueryVariables>(ConfigDocument, options);
        }
export function useConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConfigQuery, ConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConfigQuery, ConfigQueryVariables>(ConfigDocument, options);
        }
export type ConfigQueryHookResult = ReturnType<typeof useConfigQuery>;
export type ConfigLazyQueryHookResult = ReturnType<typeof useConfigLazyQuery>;
export type ConfigSuspenseQueryHookResult = ReturnType<typeof useConfigSuspenseQuery>;
export type ConfigQueryResult = Apollo.QueryResult<ConfigQuery, ConfigQueryVariables>;
export const ConvertResDocument = gql`
    mutation ConvertRes($resId: Int!) {
  convertRes(input: {resId: $resId}) {
    success
  }
}
    `;
export type ConvertResMutationFn = Apollo.MutationFunction<ConvertResMutation, ConvertResMutationVariables>;

/**
 * __useConvertResMutation__
 *
 * To run a mutation, you first call `useConvertResMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConvertResMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [convertResMutation, { data, loading, error }] = useConvertResMutation({
 *   variables: {
 *      resId: // value for 'resId'
 *   },
 * });
 */
export function useConvertResMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConvertResMutation, ConvertResMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConvertResMutation, ConvertResMutationVariables>(ConvertResDocument, options);
      }
export type ConvertResMutationHookResult = ReturnType<typeof useConvertResMutation>;
export type ConvertResMutationResult = Apollo.MutationResult<ConvertResMutation>;
export type ConvertResMutationOptions = Apollo.BaseMutationOptions<ConvertResMutation, ConvertResMutationVariables>;
export const DefaultsDocument = gql`
    query defaults($groupProfile: Int, $userProfile: Int, $pudId: Int) {
  defaults(groupProfile: $groupProfile, userProfile: $userProfile, pudId: $pudId) {
    ...DefaultsFragment
  }
}
    ${DefaultsFragmentFragmentDoc}`;

/**
 * __useDefaultsQuery__
 *
 * To run a query within a React component, call `useDefaultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefaultsQuery({
 *   variables: {
 *      groupProfile: // value for 'groupProfile'
 *      userProfile: // value for 'userProfile'
 *      pudId: // value for 'pudId'
 *   },
 * });
 */
export function useDefaultsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DefaultsQuery, DefaultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DefaultsQuery, DefaultsQueryVariables>(DefaultsDocument, options);
      }
export function useDefaultsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DefaultsQuery, DefaultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DefaultsQuery, DefaultsQueryVariables>(DefaultsDocument, options);
        }
export function useDefaultsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DefaultsQuery, DefaultsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DefaultsQuery, DefaultsQueryVariables>(DefaultsDocument, options);
        }
export type DefaultsQueryHookResult = ReturnType<typeof useDefaultsQuery>;
export type DefaultsLazyQueryHookResult = ReturnType<typeof useDefaultsLazyQuery>;
export type DefaultsSuspenseQueryHookResult = ReturnType<typeof useDefaultsSuspenseQuery>;
export type DefaultsQueryResult = Apollo.QueryResult<DefaultsQuery, DefaultsQueryVariables>;
export const EpicPassValidateDocument = gql`
    query epicPassValidate($passId: String!) {
  epicPassValidate(passId: $passId) {
    valid
  }
}
    `;

/**
 * __useEpicPassValidateQuery__
 *
 * To run a query within a React component, call `useEpicPassValidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpicPassValidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpicPassValidateQuery({
 *   variables: {
 *      passId: // value for 'passId'
 *   },
 * });
 */
export function useEpicPassValidateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EpicPassValidateQuery, EpicPassValidateQueryVariables> & ({ variables: EpicPassValidateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EpicPassValidateQuery, EpicPassValidateQueryVariables>(EpicPassValidateDocument, options);
      }
export function useEpicPassValidateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EpicPassValidateQuery, EpicPassValidateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EpicPassValidateQuery, EpicPassValidateQueryVariables>(EpicPassValidateDocument, options);
        }
export function useEpicPassValidateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EpicPassValidateQuery, EpicPassValidateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EpicPassValidateQuery, EpicPassValidateQueryVariables>(EpicPassValidateDocument, options);
        }
export type EpicPassValidateQueryHookResult = ReturnType<typeof useEpicPassValidateQuery>;
export type EpicPassValidateLazyQueryHookResult = ReturnType<typeof useEpicPassValidateLazyQuery>;
export type EpicPassValidateSuspenseQueryHookResult = ReturnType<typeof useEpicPassValidateSuspenseQuery>;
export type EpicPassValidateQueryResult = Apollo.QueryResult<EpicPassValidateQuery, EpicPassValidateQueryVariables>;
export const EpicPassValidateDateDocument = gql`
    query epicPassValidateDate($passId: String!, $pickupDate: String!) {
  epicPassValidateDate(passId: $passId, pickupDate: $pickupDate) {
    valid
  }
}
    `;

/**
 * __useEpicPassValidateDateQuery__
 *
 * To run a query within a React component, call `useEpicPassValidateDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpicPassValidateDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpicPassValidateDateQuery({
 *   variables: {
 *      passId: // value for 'passId'
 *      pickupDate: // value for 'pickupDate'
 *   },
 * });
 */
export function useEpicPassValidateDateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EpicPassValidateDateQuery, EpicPassValidateDateQueryVariables> & ({ variables: EpicPassValidateDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EpicPassValidateDateQuery, EpicPassValidateDateQueryVariables>(EpicPassValidateDateDocument, options);
      }
export function useEpicPassValidateDateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EpicPassValidateDateQuery, EpicPassValidateDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EpicPassValidateDateQuery, EpicPassValidateDateQueryVariables>(EpicPassValidateDateDocument, options);
        }
export function useEpicPassValidateDateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EpicPassValidateDateQuery, EpicPassValidateDateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EpicPassValidateDateQuery, EpicPassValidateDateQueryVariables>(EpicPassValidateDateDocument, options);
        }
export type EpicPassValidateDateQueryHookResult = ReturnType<typeof useEpicPassValidateDateQuery>;
export type EpicPassValidateDateLazyQueryHookResult = ReturnType<typeof useEpicPassValidateDateLazyQuery>;
export type EpicPassValidateDateSuspenseQueryHookResult = ReturnType<typeof useEpicPassValidateDateSuspenseQuery>;
export type EpicPassValidateDateQueryResult = Apollo.QueryResult<EpicPassValidateDateQuery, EpicPassValidateDateQueryVariables>;
export const FareKeyLookupDocument = gql`
    query fareKeyLookup($displayAddress: String, $displayName: String, $googleObject: String, $typeString: String, $fareCode: String, $groupProfile: Int, $serviceAreas: [Int!], $sourceType: Int!) {
  fareKeyLookup(
    displayAddress: $displayAddress
    displayName: $displayName
    googleObject: $googleObject
    groupProfile: $groupProfile
    typeString: $typeString
    fareCode: $fareCode
    serviceAreas: $serviceAreas
    sourceType: $sourceType
  ) {
    ...FareKeyLookup
  }
}
    ${FareKeyLookupFragmentDoc}`;

/**
 * __useFareKeyLookupQuery__
 *
 * To run a query within a React component, call `useFareKeyLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useFareKeyLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFareKeyLookupQuery({
 *   variables: {
 *      displayAddress: // value for 'displayAddress'
 *      displayName: // value for 'displayName'
 *      googleObject: // value for 'googleObject'
 *      typeString: // value for 'typeString'
 *      fareCode: // value for 'fareCode'
 *      groupProfile: // value for 'groupProfile'
 *      serviceAreas: // value for 'serviceAreas'
 *      sourceType: // value for 'sourceType'
 *   },
 * });
 */
export function useFareKeyLookupQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FareKeyLookupQuery, FareKeyLookupQueryVariables> & ({ variables: FareKeyLookupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FareKeyLookupQuery, FareKeyLookupQueryVariables>(FareKeyLookupDocument, options);
      }
export function useFareKeyLookupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FareKeyLookupQuery, FareKeyLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FareKeyLookupQuery, FareKeyLookupQueryVariables>(FareKeyLookupDocument, options);
        }
export function useFareKeyLookupSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FareKeyLookupQuery, FareKeyLookupQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FareKeyLookupQuery, FareKeyLookupQueryVariables>(FareKeyLookupDocument, options);
        }
export type FareKeyLookupQueryHookResult = ReturnType<typeof useFareKeyLookupQuery>;
export type FareKeyLookupLazyQueryHookResult = ReturnType<typeof useFareKeyLookupLazyQuery>;
export type FareKeyLookupSuspenseQueryHookResult = ReturnType<typeof useFareKeyLookupSuspenseQuery>;
export type FareKeyLookupQueryResult = Apollo.QueryResult<FareKeyLookupQuery, FareKeyLookupQueryVariables>;
export const FixedLocationTypesDocument = gql`
    query fixedLocationTypes($charterProfile: Int, $groupProfile: Int, $hidePuds: Boolean, $pudId: Int, $serviceArea: Int, $userProfile: Int) {
  fixedLocationTypes(
    charterProfile: $charterProfile
    groupProfile: $groupProfile
    hidePuds: $hidePuds
    pudId: $pudId
    serviceArea: $serviceArea
    userProfile: $userProfile
  ) {
    ...FixedLocationType
  }
}
    ${FixedLocationTypeFragmentDoc}`;

/**
 * __useFixedLocationTypesQuery__
 *
 * To run a query within a React component, call `useFixedLocationTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFixedLocationTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFixedLocationTypesQuery({
 *   variables: {
 *      charterProfile: // value for 'charterProfile'
 *      groupProfile: // value for 'groupProfile'
 *      hidePuds: // value for 'hidePuds'
 *      pudId: // value for 'pudId'
 *      serviceArea: // value for 'serviceArea'
 *      userProfile: // value for 'userProfile'
 *   },
 * });
 */
export function useFixedLocationTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FixedLocationTypesQuery, FixedLocationTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FixedLocationTypesQuery, FixedLocationTypesQueryVariables>(FixedLocationTypesDocument, options);
      }
export function useFixedLocationTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FixedLocationTypesQuery, FixedLocationTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FixedLocationTypesQuery, FixedLocationTypesQueryVariables>(FixedLocationTypesDocument, options);
        }
export function useFixedLocationTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FixedLocationTypesQuery, FixedLocationTypesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FixedLocationTypesQuery, FixedLocationTypesQueryVariables>(FixedLocationTypesDocument, options);
        }
export type FixedLocationTypesQueryHookResult = ReturnType<typeof useFixedLocationTypesQuery>;
export type FixedLocationTypesLazyQueryHookResult = ReturnType<typeof useFixedLocationTypesLazyQuery>;
export type FixedLocationTypesSuspenseQueryHookResult = ReturnType<typeof useFixedLocationTypesSuspenseQuery>;
export type FixedLocationTypesQueryResult = Apollo.QueryResult<FixedLocationTypesQuery, FixedLocationTypesQueryVariables>;
export const FrequentRiderPointsDocument = gql`
    query frequentRiderPoints($id: Int!) {
  frequentRiderPoints(id: $id) {
    ...FrequentRiderPoints
  }
}
    ${FrequentRiderPointsFragmentDoc}`;

/**
 * __useFrequentRiderPointsQuery__
 *
 * To run a query within a React component, call `useFrequentRiderPointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFrequentRiderPointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFrequentRiderPointsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFrequentRiderPointsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FrequentRiderPointsQuery, FrequentRiderPointsQueryVariables> & ({ variables: FrequentRiderPointsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FrequentRiderPointsQuery, FrequentRiderPointsQueryVariables>(FrequentRiderPointsDocument, options);
      }
export function useFrequentRiderPointsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FrequentRiderPointsQuery, FrequentRiderPointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FrequentRiderPointsQuery, FrequentRiderPointsQueryVariables>(FrequentRiderPointsDocument, options);
        }
export function useFrequentRiderPointsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FrequentRiderPointsQuery, FrequentRiderPointsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FrequentRiderPointsQuery, FrequentRiderPointsQueryVariables>(FrequentRiderPointsDocument, options);
        }
export type FrequentRiderPointsQueryHookResult = ReturnType<typeof useFrequentRiderPointsQuery>;
export type FrequentRiderPointsLazyQueryHookResult = ReturnType<typeof useFrequentRiderPointsLazyQuery>;
export type FrequentRiderPointsSuspenseQueryHookResult = ReturnType<typeof useFrequentRiderPointsSuspenseQuery>;
export type FrequentRiderPointsQueryResult = Apollo.QueryResult<FrequentRiderPointsQuery, FrequentRiderPointsQueryVariables>;
export const FrequentRiderProgramPurchaseDocument = gql`
    mutation FrequentRiderProgramPurchase($booking: FrequentRiderProgramPurchaseType!, $frpProgramId: Int!, $frpProgramCost: Float, $frpProgramQuantity: Int, $frpProgramStartDate: String, $frpProgramEndDate: String, $sourceType: Int!) {
  frequentRiderProgramPurchase(
    input: {booking: $booking, frpProgramId: $frpProgramId, frpProgramCost: $frpProgramCost, frpProgramQuantity: $frpProgramQuantity, frpProgramStartDate: $frpProgramStartDate, frpProgramEndDate: $frpProgramEndDate, sourceType: $sourceType}
  ) {
    error
    resId
  }
}
    `;
export type FrequentRiderProgramPurchaseMutationFn = Apollo.MutationFunction<FrequentRiderProgramPurchaseMutation, FrequentRiderProgramPurchaseMutationVariables>;

/**
 * __useFrequentRiderProgramPurchaseMutation__
 *
 * To run a mutation, you first call `useFrequentRiderProgramPurchaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFrequentRiderProgramPurchaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [frequentRiderProgramPurchaseMutation, { data, loading, error }] = useFrequentRiderProgramPurchaseMutation({
 *   variables: {
 *      booking: // value for 'booking'
 *      frpProgramId: // value for 'frpProgramId'
 *      frpProgramCost: // value for 'frpProgramCost'
 *      frpProgramQuantity: // value for 'frpProgramQuantity'
 *      frpProgramStartDate: // value for 'frpProgramStartDate'
 *      frpProgramEndDate: // value for 'frpProgramEndDate'
 *      sourceType: // value for 'sourceType'
 *   },
 * });
 */
export function useFrequentRiderProgramPurchaseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FrequentRiderProgramPurchaseMutation, FrequentRiderProgramPurchaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FrequentRiderProgramPurchaseMutation, FrequentRiderProgramPurchaseMutationVariables>(FrequentRiderProgramPurchaseDocument, options);
      }
export type FrequentRiderProgramPurchaseMutationHookResult = ReturnType<typeof useFrequentRiderProgramPurchaseMutation>;
export type FrequentRiderProgramPurchaseMutationResult = Apollo.MutationResult<FrequentRiderProgramPurchaseMutation>;
export type FrequentRiderProgramPurchaseMutationOptions = Apollo.BaseMutationOptions<FrequentRiderProgramPurchaseMutation, FrequentRiderProgramPurchaseMutationVariables>;
export const FrequentRiderProgramsDocument = gql`
    query frequentRiderPrograms {
  frequentRiderPrograms {
    ...FrequentRiderProgramFragment
  }
}
    ${FrequentRiderProgramFragmentFragmentDoc}`;

/**
 * __useFrequentRiderProgramsQuery__
 *
 * To run a query within a React component, call `useFrequentRiderProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFrequentRiderProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFrequentRiderProgramsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFrequentRiderProgramsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FrequentRiderProgramsQuery, FrequentRiderProgramsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FrequentRiderProgramsQuery, FrequentRiderProgramsQueryVariables>(FrequentRiderProgramsDocument, options);
      }
export function useFrequentRiderProgramsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FrequentRiderProgramsQuery, FrequentRiderProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FrequentRiderProgramsQuery, FrequentRiderProgramsQueryVariables>(FrequentRiderProgramsDocument, options);
        }
export function useFrequentRiderProgramsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FrequentRiderProgramsQuery, FrequentRiderProgramsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FrequentRiderProgramsQuery, FrequentRiderProgramsQueryVariables>(FrequentRiderProgramsDocument, options);
        }
export type FrequentRiderProgramsQueryHookResult = ReturnType<typeof useFrequentRiderProgramsQuery>;
export type FrequentRiderProgramsLazyQueryHookResult = ReturnType<typeof useFrequentRiderProgramsLazyQuery>;
export type FrequentRiderProgramsSuspenseQueryHookResult = ReturnType<typeof useFrequentRiderProgramsSuspenseQuery>;
export type FrequentRiderProgramsQueryResult = Apollo.QueryResult<FrequentRiderProgramsQuery, FrequentRiderProgramsQueryVariables>;
export const LocationDocument = gql`
    query location($fareCode: String!, $groupProfile: Int, $serviceArea: Int) {
  location(
    fareCode: $fareCode
    groupProfile: $groupProfile
    serviceArea: $serviceArea
  ) {
    ...Location
  }
}
    ${LocationFragmentDoc}`;

/**
 * __useLocationQuery__
 *
 * To run a query within a React component, call `useLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationQuery({
 *   variables: {
 *      fareCode: // value for 'fareCode'
 *      groupProfile: // value for 'groupProfile'
 *      serviceArea: // value for 'serviceArea'
 *   },
 * });
 */
export function useLocationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LocationQuery, LocationQueryVariables> & ({ variables: LocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LocationQuery, LocationQueryVariables>(LocationDocument, options);
      }
export function useLocationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LocationQuery, LocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LocationQuery, LocationQueryVariables>(LocationDocument, options);
        }
export function useLocationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LocationQuery, LocationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LocationQuery, LocationQueryVariables>(LocationDocument, options);
        }
export type LocationQueryHookResult = ReturnType<typeof useLocationQuery>;
export type LocationLazyQueryHookResult = ReturnType<typeof useLocationLazyQuery>;
export type LocationSuspenseQueryHookResult = ReturnType<typeof useLocationSuspenseQuery>;
export type LocationQueryResult = Apollo.QueryResult<LocationQuery, LocationQueryVariables>;
export const LocationListDocument = gql`
    query locationList($charterProfile: Int, $groupProfile: Int, $locationType: String!, $page: Int, $count: Int, $search: String, $serviceArea: Int, $userProfile: Int) {
  locationList(
    charterProfile: $charterProfile
    groupProfile: $groupProfile
    locationType: $locationType
    page: $page
    count: $count
    search: $search
    serviceArea: $serviceArea
    userProfile: $userProfile
  ) {
    locations {
      ...Location
    }
    pages
    totalItems
  }
}
    ${LocationFragmentDoc}`;

/**
 * __useLocationListQuery__
 *
 * To run a query within a React component, call `useLocationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationListQuery({
 *   variables: {
 *      charterProfile: // value for 'charterProfile'
 *      groupProfile: // value for 'groupProfile'
 *      locationType: // value for 'locationType'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      search: // value for 'search'
 *      serviceArea: // value for 'serviceArea'
 *      userProfile: // value for 'userProfile'
 *   },
 * });
 */
export function useLocationListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LocationListQuery, LocationListQueryVariables> & ({ variables: LocationListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LocationListQuery, LocationListQueryVariables>(LocationListDocument, options);
      }
export function useLocationListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LocationListQuery, LocationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LocationListQuery, LocationListQueryVariables>(LocationListDocument, options);
        }
export function useLocationListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LocationListQuery, LocationListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LocationListQuery, LocationListQueryVariables>(LocationListDocument, options);
        }
export type LocationListQueryHookResult = ReturnType<typeof useLocationListQuery>;
export type LocationListLazyQueryHookResult = ReturnType<typeof useLocationListLazyQuery>;
export type LocationListSuspenseQueryHookResult = ReturnType<typeof useLocationListSuspenseQuery>;
export type LocationListQueryResult = Apollo.QueryResult<LocationListQuery, LocationListQueryVariables>;
export const LocationsForAutocompleteDocument = gql`
    query locationsForAutocomplete($groupProfile: Int, $searchTerm: String, $serviceArea: Int) {
  locationsForAutocomplete(
    groupProfile: $groupProfile
    searchTerm: $searchTerm
    serviceArea: $serviceArea
  ) {
    ...AutocompleteLocation
  }
}
    ${AutocompleteLocationFragmentDoc}`;

/**
 * __useLocationsForAutocompleteQuery__
 *
 * To run a query within a React component, call `useLocationsForAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsForAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsForAutocompleteQuery({
 *   variables: {
 *      groupProfile: // value for 'groupProfile'
 *      searchTerm: // value for 'searchTerm'
 *      serviceArea: // value for 'serviceArea'
 *   },
 * });
 */
export function useLocationsForAutocompleteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LocationsForAutocompleteQuery, LocationsForAutocompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LocationsForAutocompleteQuery, LocationsForAutocompleteQueryVariables>(LocationsForAutocompleteDocument, options);
      }
export function useLocationsForAutocompleteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LocationsForAutocompleteQuery, LocationsForAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LocationsForAutocompleteQuery, LocationsForAutocompleteQueryVariables>(LocationsForAutocompleteDocument, options);
        }
export function useLocationsForAutocompleteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LocationsForAutocompleteQuery, LocationsForAutocompleteQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LocationsForAutocompleteQuery, LocationsForAutocompleteQueryVariables>(LocationsForAutocompleteDocument, options);
        }
export type LocationsForAutocompleteQueryHookResult = ReturnType<typeof useLocationsForAutocompleteQuery>;
export type LocationsForAutocompleteLazyQueryHookResult = ReturnType<typeof useLocationsForAutocompleteLazyQuery>;
export type LocationsForAutocompleteSuspenseQueryHookResult = ReturnType<typeof useLocationsForAutocompleteSuspenseQuery>;
export type LocationsForAutocompleteQueryResult = Apollo.QueryResult<LocationsForAutocompleteQuery, LocationsForAutocompleteQueryVariables>;
export const LocationsForAutocompleteUniversalDocument = gql`
    query locationsForAutocompleteUniversal($groupProfile: Int) {
  locationsForAutocomplete(groupProfile: $groupProfile, returnAll: true) {
    ...AutocompleteLocationUniversal
  }
}
    ${AutocompleteLocationUniversalFragmentDoc}`;

/**
 * __useLocationsForAutocompleteUniversalQuery__
 *
 * To run a query within a React component, call `useLocationsForAutocompleteUniversalQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsForAutocompleteUniversalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsForAutocompleteUniversalQuery({
 *   variables: {
 *      groupProfile: // value for 'groupProfile'
 *   },
 * });
 */
export function useLocationsForAutocompleteUniversalQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LocationsForAutocompleteUniversalQuery, LocationsForAutocompleteUniversalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LocationsForAutocompleteUniversalQuery, LocationsForAutocompleteUniversalQueryVariables>(LocationsForAutocompleteUniversalDocument, options);
      }
export function useLocationsForAutocompleteUniversalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LocationsForAutocompleteUniversalQuery, LocationsForAutocompleteUniversalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LocationsForAutocompleteUniversalQuery, LocationsForAutocompleteUniversalQueryVariables>(LocationsForAutocompleteUniversalDocument, options);
        }
export function useLocationsForAutocompleteUniversalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LocationsForAutocompleteUniversalQuery, LocationsForAutocompleteUniversalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LocationsForAutocompleteUniversalQuery, LocationsForAutocompleteUniversalQueryVariables>(LocationsForAutocompleteUniversalDocument, options);
        }
export type LocationsForAutocompleteUniversalQueryHookResult = ReturnType<typeof useLocationsForAutocompleteUniversalQuery>;
export type LocationsForAutocompleteUniversalLazyQueryHookResult = ReturnType<typeof useLocationsForAutocompleteUniversalLazyQuery>;
export type LocationsForAutocompleteUniversalSuspenseQueryHookResult = ReturnType<typeof useLocationsForAutocompleteUniversalSuspenseQuery>;
export type LocationsForAutocompleteUniversalQueryResult = Apollo.QueryResult<LocationsForAutocompleteUniversalQuery, LocationsForAutocompleteUniversalQueryVariables>;
export const LoginProfileDocument = gql`
    mutation LoginProfile($id: String!, $password: String, $type: String!) {
  loginProfile(input: {id: $id, password: $password, type: $type}) {
    error
    attachedGroup
    id
    success
    type
  }
}
    `;
export type LoginProfileMutationFn = Apollo.MutationFunction<LoginProfileMutation, LoginProfileMutationVariables>;

/**
 * __useLoginProfileMutation__
 *
 * To run a mutation, you first call `useLoginProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginProfileMutation, { data, loading, error }] = useLoginProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      password: // value for 'password'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useLoginProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoginProfileMutation, LoginProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LoginProfileMutation, LoginProfileMutationVariables>(LoginProfileDocument, options);
      }
export type LoginProfileMutationHookResult = ReturnType<typeof useLoginProfileMutation>;
export type LoginProfileMutationResult = Apollo.MutationResult<LoginProfileMutation>;
export type LoginProfileMutationOptions = Apollo.BaseMutationOptions<LoginProfileMutation, LoginProfileMutationVariables>;
export const LogoutProfileDocument = gql`
    mutation LogoutProfile($type: String!) {
  logoutProfile(input: {type: $type}) {
    error
    success
  }
}
    `;
export type LogoutProfileMutationFn = Apollo.MutationFunction<LogoutProfileMutation, LogoutProfileMutationVariables>;

/**
 * __useLogoutProfileMutation__
 *
 * To run a mutation, you first call `useLogoutProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutProfileMutation, { data, loading, error }] = useLogoutProfileMutation({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useLogoutProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LogoutProfileMutation, LogoutProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LogoutProfileMutation, LogoutProfileMutationVariables>(LogoutProfileDocument, options);
      }
export type LogoutProfileMutationHookResult = ReturnType<typeof useLogoutProfileMutation>;
export type LogoutProfileMutationResult = Apollo.MutationResult<LogoutProfileMutation>;
export type LogoutProfileMutationOptions = Apollo.BaseMutationOptions<LogoutProfileMutation, LogoutProfileMutationVariables>;
export const PassengerTypesDocument = gql`
    query passengerTypes($groupProfile: Int, $passengerTypesAlias: String, $serviceArea: Int) {
  passengerTypes(
    groupProfile: $groupProfile
    passengerTypesAlias: $passengerTypesAlias
    serviceArea: $serviceArea
  ) {
    ...Passenger
  }
}
    ${PassengerFragmentDoc}`;

/**
 * __usePassengerTypesQuery__
 *
 * To run a query within a React component, call `usePassengerTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePassengerTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePassengerTypesQuery({
 *   variables: {
 *      groupProfile: // value for 'groupProfile'
 *      passengerTypesAlias: // value for 'passengerTypesAlias'
 *      serviceArea: // value for 'serviceArea'
 *   },
 * });
 */
export function usePassengerTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PassengerTypesQuery, PassengerTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PassengerTypesQuery, PassengerTypesQueryVariables>(PassengerTypesDocument, options);
      }
export function usePassengerTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PassengerTypesQuery, PassengerTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PassengerTypesQuery, PassengerTypesQueryVariables>(PassengerTypesDocument, options);
        }
export function usePassengerTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PassengerTypesQuery, PassengerTypesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PassengerTypesQuery, PassengerTypesQueryVariables>(PassengerTypesDocument, options);
        }
export type PassengerTypesQueryHookResult = ReturnType<typeof usePassengerTypesQuery>;
export type PassengerTypesLazyQueryHookResult = ReturnType<typeof usePassengerTypesLazyQuery>;
export type PassengerTypesSuspenseQueryHookResult = ReturnType<typeof usePassengerTypesSuspenseQuery>;
export type PassengerTypesQueryResult = Apollo.QueryResult<PassengerTypesQuery, PassengerTypesQueryVariables>;
export const ProcessPidDocument = gql`
    mutation processPid($pid: String!) {
  processPid(pid: $pid) {
    mode
    charter
    user
    group
    sales
  }
}
    `;
export type ProcessPidMutationFn = Apollo.MutationFunction<ProcessPidMutation, ProcessPidMutationVariables>;

/**
 * __useProcessPidMutation__
 *
 * To run a mutation, you first call `useProcessPidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessPidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processPidMutation, { data, loading, error }] = useProcessPidMutation({
 *   variables: {
 *      pid: // value for 'pid'
 *   },
 * });
 */
export function useProcessPidMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProcessPidMutation, ProcessPidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProcessPidMutation, ProcessPidMutationVariables>(ProcessPidDocument, options);
      }
export type ProcessPidMutationHookResult = ReturnType<typeof useProcessPidMutation>;
export type ProcessPidMutationResult = Apollo.MutationResult<ProcessPidMutation>;
export type ProcessPidMutationOptions = Apollo.BaseMutationOptions<ProcessPidMutation, ProcessPidMutationVariables>;
export const ProfileAddDocument = gql`
    mutation profileAdd($email: String!, $linkedReservations: [String!], $name: String, $password: String!, $telephone: String) {
  profileAdd(
    input: {email: $email, linkedReservations: $linkedReservations, name: $name, password: $password, telephone: $telephone}
  ) {
    errorMessage
    profileId
    success
  }
}
    `;
export type ProfileAddMutationFn = Apollo.MutationFunction<ProfileAddMutation, ProfileAddMutationVariables>;

/**
 * __useProfileAddMutation__
 *
 * To run a mutation, you first call `useProfileAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileAddMutation, { data, loading, error }] = useProfileAddMutation({
 *   variables: {
 *      email: // value for 'email'
 *      linkedReservations: // value for 'linkedReservations'
 *      name: // value for 'name'
 *      password: // value for 'password'
 *      telephone: // value for 'telephone'
 *   },
 * });
 */
export function useProfileAddMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProfileAddMutation, ProfileAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProfileAddMutation, ProfileAddMutationVariables>(ProfileAddDocument, options);
      }
export type ProfileAddMutationHookResult = ReturnType<typeof useProfileAddMutation>;
export type ProfileAddMutationResult = Apollo.MutationResult<ProfileAddMutation>;
export type ProfileAddMutationOptions = Apollo.BaseMutationOptions<ProfileAddMutation, ProfileAddMutationVariables>;
export const ProfilePreferredLocationsDocument = gql`
    query profilePreferredLocations($userProfile: Int, $groupProfile: Int) {
  profilePreferredLocations(
    userProfile: $userProfile
    groupProfile: $groupProfile
  ) {
    ...Location
  }
}
    ${LocationFragmentDoc}`;

/**
 * __useProfilePreferredLocationsQuery__
 *
 * To run a query within a React component, call `useProfilePreferredLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfilePreferredLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfilePreferredLocationsQuery({
 *   variables: {
 *      userProfile: // value for 'userProfile'
 *      groupProfile: // value for 'groupProfile'
 *   },
 * });
 */
export function useProfilePreferredLocationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProfilePreferredLocationsQuery, ProfilePreferredLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProfilePreferredLocationsQuery, ProfilePreferredLocationsQueryVariables>(ProfilePreferredLocationsDocument, options);
      }
export function useProfilePreferredLocationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProfilePreferredLocationsQuery, ProfilePreferredLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProfilePreferredLocationsQuery, ProfilePreferredLocationsQueryVariables>(ProfilePreferredLocationsDocument, options);
        }
export function useProfilePreferredLocationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProfilePreferredLocationsQuery, ProfilePreferredLocationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProfilePreferredLocationsQuery, ProfilePreferredLocationsQueryVariables>(ProfilePreferredLocationsDocument, options);
        }
export type ProfilePreferredLocationsQueryHookResult = ReturnType<typeof useProfilePreferredLocationsQuery>;
export type ProfilePreferredLocationsLazyQueryHookResult = ReturnType<typeof useProfilePreferredLocationsLazyQuery>;
export type ProfilePreferredLocationsSuspenseQueryHookResult = ReturnType<typeof useProfilePreferredLocationsSuspenseQuery>;
export type ProfilePreferredLocationsQueryResult = Apollo.QueryResult<ProfilePreferredLocationsQuery, ProfilePreferredLocationsQueryVariables>;
export const ProfileReservationsDocument = gql`
    query profileReservations($id: Int!, $dateRange: String) {
  profileReservations(id: $id, dateRange: $dateRange) {
    ...ReservationFragment
  }
}
    ${ReservationFragmentFragmentDoc}`;

/**
 * __useProfileReservationsQuery__
 *
 * To run a query within a React component, call `useProfileReservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileReservationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileReservationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useProfileReservationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProfileReservationsQuery, ProfileReservationsQueryVariables> & ({ variables: ProfileReservationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProfileReservationsQuery, ProfileReservationsQueryVariables>(ProfileReservationsDocument, options);
      }
export function useProfileReservationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProfileReservationsQuery, ProfileReservationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProfileReservationsQuery, ProfileReservationsQueryVariables>(ProfileReservationsDocument, options);
        }
export function useProfileReservationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProfileReservationsQuery, ProfileReservationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProfileReservationsQuery, ProfileReservationsQueryVariables>(ProfileReservationsDocument, options);
        }
export type ProfileReservationsQueryHookResult = ReturnType<typeof useProfileReservationsQuery>;
export type ProfileReservationsLazyQueryHookResult = ReturnType<typeof useProfileReservationsLazyQuery>;
export type ProfileReservationsSuspenseQueryHookResult = ReturnType<typeof useProfileReservationsSuspenseQuery>;
export type ProfileReservationsQueryResult = Apollo.QueryResult<ProfileReservationsQuery, ProfileReservationsQueryVariables>;
export const PudPeopleDocument = gql`
    query pudPeople($userProfile: Int, $groupProfile: Int, $serviceArea: Int, $showToken: Boolean, $tokenGroup: String) {
  pudPeople(userProfile: $userProfile) {
    id
    name
    address
  }
  config {
    pudsAsPeople
  }
  content(
    groupProfile: $groupProfile
    serviceArea: $serviceArea
    showToken: $showToken
    tokenGroup: $tokenGroup
  ) {
    id
    bePudPersonLabel
    beSelectNoOptions
  }
}
    `;

/**
 * __usePudPeopleQuery__
 *
 * To run a query within a React component, call `usePudPeopleQuery` and pass it any options that fit your needs.
 * When your component renders, `usePudPeopleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePudPeopleQuery({
 *   variables: {
 *      userProfile: // value for 'userProfile'
 *      groupProfile: // value for 'groupProfile'
 *      serviceArea: // value for 'serviceArea'
 *      showToken: // value for 'showToken'
 *      tokenGroup: // value for 'tokenGroup'
 *   },
 * });
 */
export function usePudPeopleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PudPeopleQuery, PudPeopleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PudPeopleQuery, PudPeopleQueryVariables>(PudPeopleDocument, options);
      }
export function usePudPeopleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PudPeopleQuery, PudPeopleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PudPeopleQuery, PudPeopleQueryVariables>(PudPeopleDocument, options);
        }
export function usePudPeopleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PudPeopleQuery, PudPeopleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PudPeopleQuery, PudPeopleQueryVariables>(PudPeopleDocument, options);
        }
export type PudPeopleQueryHookResult = ReturnType<typeof usePudPeopleQuery>;
export type PudPeopleLazyQueryHookResult = ReturnType<typeof usePudPeopleLazyQuery>;
export type PudPeopleSuspenseQueryHookResult = ReturnType<typeof usePudPeopleSuspenseQuery>;
export type PudPeopleQueryResult = Apollo.QueryResult<PudPeopleQuery, PudPeopleQueryVariables>;
export const ReferralLinksDocument = gql`
    query referralLinks($flightCity: String) {
  referralLinks(flightCity: $flightCity) {
    ...ReferralLink
  }
}
    ${ReferralLinkFragmentDoc}`;

/**
 * __useReferralLinksQuery__
 *
 * To run a query within a React component, call `useReferralLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferralLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferralLinksQuery({
 *   variables: {
 *      flightCity: // value for 'flightCity'
 *   },
 * });
 */
export function useReferralLinksQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReferralLinksQuery, ReferralLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReferralLinksQuery, ReferralLinksQueryVariables>(ReferralLinksDocument, options);
      }
export function useReferralLinksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReferralLinksQuery, ReferralLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReferralLinksQuery, ReferralLinksQueryVariables>(ReferralLinksDocument, options);
        }
export function useReferralLinksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReferralLinksQuery, ReferralLinksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReferralLinksQuery, ReferralLinksQueryVariables>(ReferralLinksDocument, options);
        }
export type ReferralLinksQueryHookResult = ReturnType<typeof useReferralLinksQuery>;
export type ReferralLinksLazyQueryHookResult = ReturnType<typeof useReferralLinksLazyQuery>;
export type ReferralLinksSuspenseQueryHookResult = ReturnType<typeof useReferralLinksSuspenseQuery>;
export type ReferralLinksQueryResult = Apollo.QueryResult<ReferralLinksQuery, ReferralLinksQueryVariables>;
export const RepriceServiceDocument = gql`
    mutation RepriceService($recalcEntireFare: Boolean, $res: ServicesResType!, $sourceType: Int!) {
  repriceService(
    input: {recalcEntireFare: $recalcEntireFare, res: $res, sourceType: $sourceType}
  ) {
    reprice {
      bagCountMax
      fareDisplay
      gratuityFare
      fareComponents {
        field
        value
      }
      payments {
        items {
          paymentAmount
          points
          programId
          type
        }
        totalPaymentAmount
        amountDue
      }
      times {
        ...ServiceTime
      }
      webSubfares {
        field
        value
      }
    }
    error
  }
}
    ${ServiceTimeFragmentDoc}`;
export type RepriceServiceMutationFn = Apollo.MutationFunction<RepriceServiceMutation, RepriceServiceMutationVariables>;

/**
 * __useRepriceServiceMutation__
 *
 * To run a mutation, you first call `useRepriceServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRepriceServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [repriceServiceMutation, { data, loading, error }] = useRepriceServiceMutation({
 *   variables: {
 *      recalcEntireFare: // value for 'recalcEntireFare'
 *      res: // value for 'res'
 *      sourceType: // value for 'sourceType'
 *   },
 * });
 */
export function useRepriceServiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RepriceServiceMutation, RepriceServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RepriceServiceMutation, RepriceServiceMutationVariables>(RepriceServiceDocument, options);
      }
export type RepriceServiceMutationHookResult = ReturnType<typeof useRepriceServiceMutation>;
export type RepriceServiceMutationResult = Apollo.MutationResult<RepriceServiceMutation>;
export type RepriceServiceMutationOptions = Apollo.BaseMutationOptions<RepriceServiceMutation, RepriceServiceMutationVariables>;
export const ReservationDocument = gql`
    query reservation($pid: String, $resId: Int) {
  reservation(pid: $pid, resId: $resId) {
    ...ReservationFragment
  }
}
    ${ReservationFragmentFragmentDoc}`;

/**
 * __useReservationQuery__
 *
 * To run a query within a React component, call `useReservationQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservationQuery({
 *   variables: {
 *      pid: // value for 'pid'
 *      resId: // value for 'resId'
 *   },
 * });
 */
export function useReservationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReservationQuery, ReservationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReservationQuery, ReservationQueryVariables>(ReservationDocument, options);
      }
export function useReservationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReservationQuery, ReservationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReservationQuery, ReservationQueryVariables>(ReservationDocument, options);
        }
export function useReservationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReservationQuery, ReservationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReservationQuery, ReservationQueryVariables>(ReservationDocument, options);
        }
export type ReservationQueryHookResult = ReturnType<typeof useReservationQuery>;
export type ReservationLazyQueryHookResult = ReturnType<typeof useReservationLazyQuery>;
export type ReservationSuspenseQueryHookResult = ReturnType<typeof useReservationSuspenseQuery>;
export type ReservationQueryResult = Apollo.QueryResult<ReservationQuery, ReservationQueryVariables>;
export const SavePasswordDocument = gql`
    mutation savePassword($id: Int!, $currentPassword: String!, $newPassword: String!) {
  savePassword(
    input: {id: $id, currentPassword: $currentPassword, newPassword: $newPassword}
  ) {
    errorMessage
    success
  }
}
    `;
export type SavePasswordMutationFn = Apollo.MutationFunction<SavePasswordMutation, SavePasswordMutationVariables>;

/**
 * __useSavePasswordMutation__
 *
 * To run a mutation, you first call `useSavePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePasswordMutation, { data, loading, error }] = useSavePasswordMutation({
 *   variables: {
 *      id: // value for 'id'
 *      currentPassword: // value for 'currentPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useSavePasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SavePasswordMutation, SavePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SavePasswordMutation, SavePasswordMutationVariables>(SavePasswordDocument, options);
      }
export type SavePasswordMutationHookResult = ReturnType<typeof useSavePasswordMutation>;
export type SavePasswordMutationResult = Apollo.MutationResult<SavePasswordMutation>;
export type SavePasswordMutationOptions = Apollo.BaseMutationOptions<SavePasswordMutation, SavePasswordMutationVariables>;
export const SavePasswordWithPidDocument = gql`
    mutation savePasswordWithPid($password: String!, $pid: String!) {
  savePasswordWithPid(input: {password: $password, pid: $pid}) {
    errorMessage
    success
  }
}
    `;
export type SavePasswordWithPidMutationFn = Apollo.MutationFunction<SavePasswordWithPidMutation, SavePasswordWithPidMutationVariables>;

/**
 * __useSavePasswordWithPidMutation__
 *
 * To run a mutation, you first call `useSavePasswordWithPidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePasswordWithPidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePasswordWithPidMutation, { data, loading, error }] = useSavePasswordWithPidMutation({
 *   variables: {
 *      password: // value for 'password'
 *      pid: // value for 'pid'
 *   },
 * });
 */
export function useSavePasswordWithPidMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SavePasswordWithPidMutation, SavePasswordWithPidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SavePasswordWithPidMutation, SavePasswordWithPidMutationVariables>(SavePasswordWithPidDocument, options);
      }
export type SavePasswordWithPidMutationHookResult = ReturnType<typeof useSavePasswordWithPidMutation>;
export type SavePasswordWithPidMutationResult = Apollo.MutationResult<SavePasswordWithPidMutation>;
export type SavePasswordWithPidMutationOptions = Apollo.BaseMutationOptions<SavePasswordWithPidMutation, SavePasswordWithPidMutationVariables>;
export const SendPasswordResetDocument = gql`
    mutation SendPasswordReset($username: String!, $resetPasswordUrl: String!) {
  sendPasswordReset(
    input: {username: $username, resetPasswordUrl: $resetPasswordUrl}
  ) {
    errorType
    success
  }
}
    `;
export type SendPasswordResetMutationFn = Apollo.MutationFunction<SendPasswordResetMutation, SendPasswordResetMutationVariables>;

/**
 * __useSendPasswordResetMutation__
 *
 * To run a mutation, you first call `useSendPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPasswordResetMutation, { data, loading, error }] = useSendPasswordResetMutation({
 *   variables: {
 *      username: // value for 'username'
 *      resetPasswordUrl: // value for 'resetPasswordUrl'
 *   },
 * });
 */
export function useSendPasswordResetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendPasswordResetMutation, SendPasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendPasswordResetMutation, SendPasswordResetMutationVariables>(SendPasswordResetDocument, options);
      }
export type SendPasswordResetMutationHookResult = ReturnType<typeof useSendPasswordResetMutation>;
export type SendPasswordResetMutationResult = Apollo.MutationResult<SendPasswordResetMutation>;
export type SendPasswordResetMutationOptions = Apollo.BaseMutationOptions<SendPasswordResetMutation, SendPasswordResetMutationVariables>;
export const ExtrasDocument = gql`
    query extras($groupProfile: Int, $serviceArea: Int, $serviceExtrasAlias: String) {
  serviceExtras(
    groupProfile: $groupProfile
    serviceArea: $serviceArea
    serviceExtrasAlias: $serviceExtrasAlias
  ) {
    ...ServiceExtra
  }
}
    ${ServiceExtraFragmentDoc}`;

/**
 * __useExtrasQuery__
 *
 * To run a query within a React component, call `useExtrasQuery` and pass it any options that fit your needs.
 * When your component renders, `useExtrasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExtrasQuery({
 *   variables: {
 *      groupProfile: // value for 'groupProfile'
 *      serviceArea: // value for 'serviceArea'
 *      serviceExtrasAlias: // value for 'serviceExtrasAlias'
 *   },
 * });
 */
export function useExtrasQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExtrasQuery, ExtrasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExtrasQuery, ExtrasQueryVariables>(ExtrasDocument, options);
      }
export function useExtrasLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExtrasQuery, ExtrasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExtrasQuery, ExtrasQueryVariables>(ExtrasDocument, options);
        }
export function useExtrasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExtrasQuery, ExtrasQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExtrasQuery, ExtrasQueryVariables>(ExtrasDocument, options);
        }
export type ExtrasQueryHookResult = ReturnType<typeof useExtrasQuery>;
export type ExtrasLazyQueryHookResult = ReturnType<typeof useExtrasLazyQuery>;
export type ExtrasSuspenseQueryHookResult = ReturnType<typeof useExtrasSuspenseQuery>;
export type ExtrasQueryResult = Apollo.QueryResult<ExtrasQuery, ExtrasQueryVariables>;
export const ServicesDocument = gql`
    query services($res: ServicesResType!, $sourceType: Int!) {
  services(res: $res, sourceType: $sourceType) {
    ...ServiceFragment
  }
}
    ${ServiceFragmentFragmentDoc}`;

/**
 * __useServicesQuery__
 *
 * To run a query within a React component, call `useServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServicesQuery({
 *   variables: {
 *      res: // value for 'res'
 *      sourceType: // value for 'sourceType'
 *   },
 * });
 */
export function useServicesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ServicesQuery, ServicesQueryVariables> & ({ variables: ServicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ServicesQuery, ServicesQueryVariables>(ServicesDocument, options);
      }
export function useServicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ServicesQuery, ServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ServicesQuery, ServicesQueryVariables>(ServicesDocument, options);
        }
export function useServicesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ServicesQuery, ServicesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ServicesQuery, ServicesQueryVariables>(ServicesDocument, options);
        }
export type ServicesQueryHookResult = ReturnType<typeof useServicesQuery>;
export type ServicesLazyQueryHookResult = ReturnType<typeof useServicesLazyQuery>;
export type ServicesSuspenseQueryHookResult = ReturnType<typeof useServicesSuspenseQuery>;
export type ServicesQueryResult = Apollo.QueryResult<ServicesQuery, ServicesQueryVariables>;
export const SpecialInfoDocument = gql`
    query specialInfo($groupProfile: Int, $siAlias: String, $userProfile: Int) {
  specialInfo(
    groupProfile: $groupProfile
    siAlias: $siAlias
    userProfile: $userProfile
  ) {
    id
    defaultValue
    description
    fieldName
    fieldType
    label
    maxLength
    minLength
    raw
    required
  }
}
    `;

/**
 * __useSpecialInfoQuery__
 *
 * To run a query within a React component, call `useSpecialInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpecialInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpecialInfoQuery({
 *   variables: {
 *      groupProfile: // value for 'groupProfile'
 *      siAlias: // value for 'siAlias'
 *      userProfile: // value for 'userProfile'
 *   },
 * });
 */
export function useSpecialInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SpecialInfoQuery, SpecialInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SpecialInfoQuery, SpecialInfoQueryVariables>(SpecialInfoDocument, options);
      }
export function useSpecialInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SpecialInfoQuery, SpecialInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SpecialInfoQuery, SpecialInfoQueryVariables>(SpecialInfoDocument, options);
        }
export function useSpecialInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SpecialInfoQuery, SpecialInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SpecialInfoQuery, SpecialInfoQueryVariables>(SpecialInfoDocument, options);
        }
export type SpecialInfoQueryHookResult = ReturnType<typeof useSpecialInfoQuery>;
export type SpecialInfoLazyQueryHookResult = ReturnType<typeof useSpecialInfoLazyQuery>;
export type SpecialInfoSuspenseQueryHookResult = ReturnType<typeof useSpecialInfoSuspenseQuery>;
export type SpecialInfoQueryResult = Apollo.QueryResult<SpecialInfoQuery, SpecialInfoQueryVariables>;
export const TokenizeDocument = gql`
    mutation Tokenize($ccNumber: String!, $ccExpiration: String!, $ccName: String, $ccPostalCode: String, $ccAddress: String) {
  tokenize(
    input: {ccNumber: $ccNumber, ccExpiration: $ccExpiration, ccName: $ccName, ccPostalCode: $ccPostalCode, ccAddress: $ccAddress}
  ) {
    error
    ccToken
    ccLast4
    ccExpiration
  }
}
    `;
export type TokenizeMutationFn = Apollo.MutationFunction<TokenizeMutation, TokenizeMutationVariables>;

/**
 * __useTokenizeMutation__
 *
 * To run a mutation, you first call `useTokenizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTokenizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tokenizeMutation, { data, loading, error }] = useTokenizeMutation({
 *   variables: {
 *      ccNumber: // value for 'ccNumber'
 *      ccExpiration: // value for 'ccExpiration'
 *      ccName: // value for 'ccName'
 *      ccPostalCode: // value for 'ccPostalCode'
 *      ccAddress: // value for 'ccAddress'
 *   },
 * });
 */
export function useTokenizeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TokenizeMutation, TokenizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TokenizeMutation, TokenizeMutationVariables>(TokenizeDocument, options);
      }
export type TokenizeMutationHookResult = ReturnType<typeof useTokenizeMutation>;
export type TokenizeMutationResult = Apollo.MutationResult<TokenizeMutation>;
export type TokenizeMutationOptions = Apollo.BaseMutationOptions<TokenizeMutation, TokenizeMutationVariables>;
export const TokensDocument = gql`
    query tokens {
  tokens {
    ...Token
  }
}
    ${TokenFragmentDoc}`;

/**
 * __useTokensQuery__
 *
 * To run a query within a React component, call `useTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTokensQuery({
 *   variables: {
 *   },
 * });
 */
export function useTokensQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TokensQuery, TokensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TokensQuery, TokensQueryVariables>(TokensDocument, options);
      }
export function useTokensLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TokensQuery, TokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TokensQuery, TokensQueryVariables>(TokensDocument, options);
        }
export function useTokensSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TokensQuery, TokensQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TokensQuery, TokensQueryVariables>(TokensDocument, options);
        }
export type TokensQueryHookResult = ReturnType<typeof useTokensQuery>;
export type TokensLazyQueryHookResult = ReturnType<typeof useTokensLazyQuery>;
export type TokensSuspenseQueryHookResult = ReturnType<typeof useTokensSuspenseQuery>;
export type TokensQueryResult = Apollo.QueryResult<TokensQuery, TokensQueryVariables>;
export const UserProfileDocument = gql`
    query userProfile($id: Int!) {
  userProfile(id: $id) {
    ...ProfileFragment
  }
}
    ${ProfileFragmentFragmentDoc}`;

/**
 * __useUserProfileQuery__
 *
 * To run a query within a React component, call `useUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserProfileQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserProfileQuery, UserProfileQueryVariables> & ({ variables: UserProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
      }
export function useUserProfileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
        }
export function useUserProfileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
        }
export type UserProfileQueryHookResult = ReturnType<typeof useUserProfileQuery>;
export type UserProfileLazyQueryHookResult = ReturnType<typeof useUserProfileLazyQuery>;
export type UserProfileSuspenseQueryHookResult = ReturnType<typeof useUserProfileSuspenseQuery>;
export type UserProfileQueryResult = Apollo.QueryResult<UserProfileQuery, UserProfileQueryVariables>;
export const UserProfileAddCcDocument = gql`
    mutation UserProfileAddCc($id: Int!, $ccNumber: String!, $ccExpiration: String!, $ccName: String!, $ccPostalCode: String, $ccAddress: String) {
  userProfileAddCc(
    input: {id: $id, ccNumber: $ccNumber, ccExpiration: $ccExpiration, ccName: $ccName, ccPostalCode: $ccPostalCode, ccAddress: $ccAddress}
  ) {
    success
    errorMessage
  }
}
    `;
export type UserProfileAddCcMutationFn = Apollo.MutationFunction<UserProfileAddCcMutation, UserProfileAddCcMutationVariables>;

/**
 * __useUserProfileAddCcMutation__
 *
 * To run a mutation, you first call `useUserProfileAddCcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserProfileAddCcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userProfileAddCcMutation, { data, loading, error }] = useUserProfileAddCcMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ccNumber: // value for 'ccNumber'
 *      ccExpiration: // value for 'ccExpiration'
 *      ccName: // value for 'ccName'
 *      ccPostalCode: // value for 'ccPostalCode'
 *      ccAddress: // value for 'ccAddress'
 *   },
 * });
 */
export function useUserProfileAddCcMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserProfileAddCcMutation, UserProfileAddCcMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserProfileAddCcMutation, UserProfileAddCcMutationVariables>(UserProfileAddCcDocument, options);
      }
export type UserProfileAddCcMutationHookResult = ReturnType<typeof useUserProfileAddCcMutation>;
export type UserProfileAddCcMutationResult = Apollo.MutationResult<UserProfileAddCcMutation>;
export type UserProfileAddCcMutationOptions = Apollo.BaseMutationOptions<UserProfileAddCcMutation, UserProfileAddCcMutationVariables>;
export const UserProfileAddPudDocument = gql`
    mutation UserProfileAddPud($id: Int!, $location: ProfilePud!) {
  userProfileAddPud(input: {id: $id, location: $location}) {
    success
    errorMessage
  }
}
    `;
export type UserProfileAddPudMutationFn = Apollo.MutationFunction<UserProfileAddPudMutation, UserProfileAddPudMutationVariables>;

/**
 * __useUserProfileAddPudMutation__
 *
 * To run a mutation, you first call `useUserProfileAddPudMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserProfileAddPudMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userProfileAddPudMutation, { data, loading, error }] = useUserProfileAddPudMutation({
 *   variables: {
 *      id: // value for 'id'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useUserProfileAddPudMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserProfileAddPudMutation, UserProfileAddPudMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserProfileAddPudMutation, UserProfileAddPudMutationVariables>(UserProfileAddPudDocument, options);
      }
export type UserProfileAddPudMutationHookResult = ReturnType<typeof useUserProfileAddPudMutation>;
export type UserProfileAddPudMutationResult = Apollo.MutationResult<UserProfileAddPudMutation>;
export type UserProfileAddPudMutationOptions = Apollo.BaseMutationOptions<UserProfileAddPudMutation, UserProfileAddPudMutationVariables>;
export const UserProfileAddValpayCcDocument = gql`
    mutation UserProfileAddValpayCc($id: Int!, $encryptedCardNumber: String!, $encryptedExpiryMonth: String!, $encryptedExpiryYear: String!, $encryptedSecurityCode: String!, $ccCardHolderName: String, $ccPostalCode: String) {
  userProfileAddValpayCc(
    input: {id: $id, encryptedCardNumber: $encryptedCardNumber, encryptedExpiryMonth: $encryptedExpiryMonth, encryptedExpiryYear: $encryptedExpiryYear, encryptedSecurityCode: $encryptedSecurityCode, ccCardHolderName: $ccCardHolderName, ccPostalCode: $ccPostalCode}
  ) {
    success
    errorMessage
  }
}
    `;
export type UserProfileAddValpayCcMutationFn = Apollo.MutationFunction<UserProfileAddValpayCcMutation, UserProfileAddValpayCcMutationVariables>;

/**
 * __useUserProfileAddValpayCcMutation__
 *
 * To run a mutation, you first call `useUserProfileAddValpayCcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserProfileAddValpayCcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userProfileAddValpayCcMutation, { data, loading, error }] = useUserProfileAddValpayCcMutation({
 *   variables: {
 *      id: // value for 'id'
 *      encryptedCardNumber: // value for 'encryptedCardNumber'
 *      encryptedExpiryMonth: // value for 'encryptedExpiryMonth'
 *      encryptedExpiryYear: // value for 'encryptedExpiryYear'
 *      encryptedSecurityCode: // value for 'encryptedSecurityCode'
 *      ccCardHolderName: // value for 'ccCardHolderName'
 *      ccPostalCode: // value for 'ccPostalCode'
 *   },
 * });
 */
export function useUserProfileAddValpayCcMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserProfileAddValpayCcMutation, UserProfileAddValpayCcMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserProfileAddValpayCcMutation, UserProfileAddValpayCcMutationVariables>(UserProfileAddValpayCcDocument, options);
      }
export type UserProfileAddValpayCcMutationHookResult = ReturnType<typeof useUserProfileAddValpayCcMutation>;
export type UserProfileAddValpayCcMutationResult = Apollo.MutationResult<UserProfileAddValpayCcMutation>;
export type UserProfileAddValpayCcMutationOptions = Apollo.BaseMutationOptions<UserProfileAddValpayCcMutation, UserProfileAddValpayCcMutationVariables>;
export const UserProfileDeleteCcDocument = gql`
    mutation UserProfileDeleteCc($id: Int!, $ccId: String, $ccRefId: String, $ccToken: String, $ccLast4: String) {
  userProfileDeleteCc(
    input: {id: $id, ccId: $ccId, ccRefId: $ccRefId, ccToken: $ccToken, ccLast4: $ccLast4}
  ) {
    success
    errorMessage
  }
}
    `;
export type UserProfileDeleteCcMutationFn = Apollo.MutationFunction<UserProfileDeleteCcMutation, UserProfileDeleteCcMutationVariables>;

/**
 * __useUserProfileDeleteCcMutation__
 *
 * To run a mutation, you first call `useUserProfileDeleteCcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserProfileDeleteCcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userProfileDeleteCcMutation, { data, loading, error }] = useUserProfileDeleteCcMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ccId: // value for 'ccId'
 *      ccRefId: // value for 'ccRefId'
 *      ccToken: // value for 'ccToken'
 *      ccLast4: // value for 'ccLast4'
 *   },
 * });
 */
export function useUserProfileDeleteCcMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserProfileDeleteCcMutation, UserProfileDeleteCcMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserProfileDeleteCcMutation, UserProfileDeleteCcMutationVariables>(UserProfileDeleteCcDocument, options);
      }
export type UserProfileDeleteCcMutationHookResult = ReturnType<typeof useUserProfileDeleteCcMutation>;
export type UserProfileDeleteCcMutationResult = Apollo.MutationResult<UserProfileDeleteCcMutation>;
export type UserProfileDeleteCcMutationOptions = Apollo.BaseMutationOptions<UserProfileDeleteCcMutation, UserProfileDeleteCcMutationVariables>;
export const UserProfileDeletePudDocument = gql`
    mutation UserProfileDeletePud($id: Int!, $locationId: Int!) {
  userProfileDeletePud(input: {id: $id, locationId: $locationId}) {
    success
    errorMessage
  }
}
    `;
export type UserProfileDeletePudMutationFn = Apollo.MutationFunction<UserProfileDeletePudMutation, UserProfileDeletePudMutationVariables>;

/**
 * __useUserProfileDeletePudMutation__
 *
 * To run a mutation, you first call `useUserProfileDeletePudMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserProfileDeletePudMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userProfileDeletePudMutation, { data, loading, error }] = useUserProfileDeletePudMutation({
 *   variables: {
 *      id: // value for 'id'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useUserProfileDeletePudMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserProfileDeletePudMutation, UserProfileDeletePudMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserProfileDeletePudMutation, UserProfileDeletePudMutationVariables>(UserProfileDeletePudDocument, options);
      }
export type UserProfileDeletePudMutationHookResult = ReturnType<typeof useUserProfileDeletePudMutation>;
export type UserProfileDeletePudMutationResult = Apollo.MutationResult<UserProfileDeletePudMutation>;
export type UserProfileDeletePudMutationOptions = Apollo.BaseMutationOptions<UserProfileDeletePudMutation, UserProfileDeletePudMutationVariables>;
export const UserProfileDeletePudCcDocument = gql`
    mutation UserProfileDeletePudCc($profileId: Int!, $pudId: Int!, $ccId: Int!) {
  userProfileDeletePudCc(
    input: {profileId: $profileId, pudId: $pudId, ccId: $ccId}
  ) {
    success
    errorMessage
  }
}
    `;
export type UserProfileDeletePudCcMutationFn = Apollo.MutationFunction<UserProfileDeletePudCcMutation, UserProfileDeletePudCcMutationVariables>;

/**
 * __useUserProfileDeletePudCcMutation__
 *
 * To run a mutation, you first call `useUserProfileDeletePudCcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserProfileDeletePudCcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userProfileDeletePudCcMutation, { data, loading, error }] = useUserProfileDeletePudCcMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      pudId: // value for 'pudId'
 *      ccId: // value for 'ccId'
 *   },
 * });
 */
export function useUserProfileDeletePudCcMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserProfileDeletePudCcMutation, UserProfileDeletePudCcMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserProfileDeletePudCcMutation, UserProfileDeletePudCcMutationVariables>(UserProfileDeletePudCcDocument, options);
      }
export type UserProfileDeletePudCcMutationHookResult = ReturnType<typeof useUserProfileDeletePudCcMutation>;
export type UserProfileDeletePudCcMutationResult = Apollo.MutationResult<UserProfileDeletePudCcMutation>;
export type UserProfileDeletePudCcMutationOptions = Apollo.BaseMutationOptions<UserProfileDeletePudCcMutation, UserProfileDeletePudCcMutationVariables>;
export const UserProfileExistsDocument = gql`
    query userProfileExists($email: String!) {
  userProfileExists(email: $email) {
    id
    exists
    hasPassword
    profileId
  }
}
    `;

/**
 * __useUserProfileExistsQuery__
 *
 * To run a query within a React component, call `useUserProfileExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileExistsQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUserProfileExistsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserProfileExistsQuery, UserProfileExistsQueryVariables> & ({ variables: UserProfileExistsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserProfileExistsQuery, UserProfileExistsQueryVariables>(UserProfileExistsDocument, options);
      }
export function useUserProfileExistsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserProfileExistsQuery, UserProfileExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserProfileExistsQuery, UserProfileExistsQueryVariables>(UserProfileExistsDocument, options);
        }
export function useUserProfileExistsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserProfileExistsQuery, UserProfileExistsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserProfileExistsQuery, UserProfileExistsQueryVariables>(UserProfileExistsDocument, options);
        }
export type UserProfileExistsQueryHookResult = ReturnType<typeof useUserProfileExistsQuery>;
export type UserProfileExistsLazyQueryHookResult = ReturnType<typeof useUserProfileExistsLazyQuery>;
export type UserProfileExistsSuspenseQueryHookResult = ReturnType<typeof useUserProfileExistsSuspenseQuery>;
export type UserProfileExistsQueryResult = Apollo.QueryResult<UserProfileExistsQuery, UserProfileExistsQueryVariables>;
export const UserProfileLinkGroupDocument = gql`
    mutation UserProfileLinkGroup($id: Int!, $clientid: String, $data1: String, $data2: String, $groupid: String, $webid: String) {
  userProfileLinkGroup(
    input: {id: $id, clientid: $clientid, data1: $data1, data2: $data2, groupid: $groupid, webid: $webid}
  ) {
    success
  }
}
    `;
export type UserProfileLinkGroupMutationFn = Apollo.MutationFunction<UserProfileLinkGroupMutation, UserProfileLinkGroupMutationVariables>;

/**
 * __useUserProfileLinkGroupMutation__
 *
 * To run a mutation, you first call `useUserProfileLinkGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserProfileLinkGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userProfileLinkGroupMutation, { data, loading, error }] = useUserProfileLinkGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      clientid: // value for 'clientid'
 *      data1: // value for 'data1'
 *      data2: // value for 'data2'
 *      groupid: // value for 'groupid'
 *      webid: // value for 'webid'
 *   },
 * });
 */
export function useUserProfileLinkGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserProfileLinkGroupMutation, UserProfileLinkGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserProfileLinkGroupMutation, UserProfileLinkGroupMutationVariables>(UserProfileLinkGroupDocument, options);
      }
export type UserProfileLinkGroupMutationHookResult = ReturnType<typeof useUserProfileLinkGroupMutation>;
export type UserProfileLinkGroupMutationResult = Apollo.MutationResult<UserProfileLinkGroupMutation>;
export type UserProfileLinkGroupMutationOptions = Apollo.BaseMutationOptions<UserProfileLinkGroupMutation, UserProfileLinkGroupMutationVariables>;
export const UserProfileUpdateDocument = gql`
    mutation UserProfileUpdate($id: Int!, $updatedFields: ProfileUpdateProfileType!) {
  userProfileUpdate(input: {id: $id, updatedFields: $updatedFields}) {
    success
  }
}
    `;
export type UserProfileUpdateMutationFn = Apollo.MutationFunction<UserProfileUpdateMutation, UserProfileUpdateMutationVariables>;

/**
 * __useUserProfileUpdateMutation__
 *
 * To run a mutation, you first call `useUserProfileUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserProfileUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userProfileUpdateMutation, { data, loading, error }] = useUserProfileUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updatedFields: // value for 'updatedFields'
 *   },
 * });
 */
export function useUserProfileUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserProfileUpdateMutation, UserProfileUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserProfileUpdateMutation, UserProfileUpdateMutationVariables>(UserProfileUpdateDocument, options);
      }
export type UserProfileUpdateMutationHookResult = ReturnType<typeof useUserProfileUpdateMutation>;
export type UserProfileUpdateMutationResult = Apollo.MutationResult<UserProfileUpdateMutation>;
export type UserProfileUpdateMutationOptions = Apollo.BaseMutationOptions<UserProfileUpdateMutation, UserProfileUpdateMutationVariables>;
export const UserProfileUpdatePudDocument = gql`
    mutation UserProfileUpdatePud($profileId: Int!, $location: ProfilePud) {
  userProfileUpdatePud(input: {profileId: $profileId, location: $location}) {
    success
    errorMessage
  }
}
    `;
export type UserProfileUpdatePudMutationFn = Apollo.MutationFunction<UserProfileUpdatePudMutation, UserProfileUpdatePudMutationVariables>;

/**
 * __useUserProfileUpdatePudMutation__
 *
 * To run a mutation, you first call `useUserProfileUpdatePudMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserProfileUpdatePudMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userProfileUpdatePudMutation, { data, loading, error }] = useUserProfileUpdatePudMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useUserProfileUpdatePudMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserProfileUpdatePudMutation, UserProfileUpdatePudMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserProfileUpdatePudMutation, UserProfileUpdatePudMutationVariables>(UserProfileUpdatePudDocument, options);
      }
export type UserProfileUpdatePudMutationHookResult = ReturnType<typeof useUserProfileUpdatePudMutation>;
export type UserProfileUpdatePudMutationResult = Apollo.MutationResult<UserProfileUpdatePudMutation>;
export type UserProfileUpdatePudMutationOptions = Apollo.BaseMutationOptions<UserProfileUpdatePudMutation, UserProfileUpdatePudMutationVariables>;
export const ValpayConfigDocument = gql`
    query valpayConfig($processorId: Int, $shopperReference: String) {
  valpayConfig(processorId: $processorId, shopperReference: $shopperReference) {
    id
    clientKey
    enabled
    environment
    error
    paymentMethods
  }
}
    `;

/**
 * __useValpayConfigQuery__
 *
 * To run a query within a React component, call `useValpayConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useValpayConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValpayConfigQuery({
 *   variables: {
 *      processorId: // value for 'processorId'
 *      shopperReference: // value for 'shopperReference'
 *   },
 * });
 */
export function useValpayConfigQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ValpayConfigQuery, ValpayConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ValpayConfigQuery, ValpayConfigQueryVariables>(ValpayConfigDocument, options);
      }
export function useValpayConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ValpayConfigQuery, ValpayConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ValpayConfigQuery, ValpayConfigQueryVariables>(ValpayConfigDocument, options);
        }
export function useValpayConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ValpayConfigQuery, ValpayConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ValpayConfigQuery, ValpayConfigQueryVariables>(ValpayConfigDocument, options);
        }
export type ValpayConfigQueryHookResult = ReturnType<typeof useValpayConfigQuery>;
export type ValpayConfigLazyQueryHookResult = ReturnType<typeof useValpayConfigLazyQuery>;
export type ValpayConfigSuspenseQueryHookResult = ReturnType<typeof useValpayConfigSuspenseQuery>;
export type ValpayConfigQueryResult = Apollo.QueryResult<ValpayConfigQuery, ValpayConfigQueryVariables>;
export const VerifyResDocument = gql`
    mutation VerifyRes($resId: String!, $validationMode: String!, $validationValue: String!) {
  verifyRes(
    input: {resId: $resId, validationMode: $validationMode, validationValue: $validationValue}
  ) {
    error
    resId
    success
  }
}
    `;
export type VerifyResMutationFn = Apollo.MutationFunction<VerifyResMutation, VerifyResMutationVariables>;

/**
 * __useVerifyResMutation__
 *
 * To run a mutation, you first call `useVerifyResMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyResMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyResMutation, { data, loading, error }] = useVerifyResMutation({
 *   variables: {
 *      resId: // value for 'resId'
 *      validationMode: // value for 'validationMode'
 *      validationValue: // value for 'validationValue'
 *   },
 * });
 */
export function useVerifyResMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VerifyResMutation, VerifyResMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<VerifyResMutation, VerifyResMutationVariables>(VerifyResDocument, options);
      }
export type VerifyResMutationHookResult = ReturnType<typeof useVerifyResMutation>;
export type VerifyResMutationResult = Apollo.MutationResult<VerifyResMutation>;
export type VerifyResMutationOptions = Apollo.BaseMutationOptions<VerifyResMutation, VerifyResMutationVariables>;